window.__lmgCfg = { s: 'lmg2026xK9' };
const TD_MODE = true;
const STRIPE_PK = 'pk_live_51M1Z5iDtR152QzRJamDSzMPtbURa5eRPk0zGyHSBD8PfGbPFZ0bT7KAX5dVIj7fi1AUue55SCV8GEVr9Pnpyt4bg00IjCFqUuA';
const STRIPE_OBJ = Stripe(STRIPE_PK);

const CDN = 'https://cdn.shopify.com/s/files/1/0686/5289/2231/files/';
const IMG_V = '&v=20260704b';
const SWATCH_SIZE = '?width=200' + IMG_V;
const CARD_SIZE = '?width=800' + IMG_V;
const LIGHTBOX_SIZE = '?width=1600' + IMG_V;

const LIFT_OPTIONS = {
'Zebra Shades': [
{ lift: 'Cordless', icon: '🤲', price: 0, label: 'Included' },
{ lift: 'Manual Corded', icon: '🪢', price: 0, label: 'Included' },
{ lift: 'Motorized', icon: '⚡', price: 0, label: 'Choose motor at Step 5', requiresWidth: 18 },
],
'Roller Shades': [
{ lift: 'Cordless', icon: '🤲', price: 0, label: 'Included' },
{ lift: 'Manual Corded', icon: '🪢', price: 0, label: 'Included' },
{ lift: 'Motorized', icon: '⚡', price: 0, label: 'Choose motor at Step 5', requiresWidth: 18 },
],
'Honeycomb': [
{ lift: 'Corded', icon: '🪢', price: 0, label: 'Included' },
{ lift: 'Cordless', icon: '🤲', price: 0, label: 'Included' },
{ lift: 'Top Down Bottom Up - Corded', icon: '↕️', price: 0, label: 'Included' },
{ lift: 'Top Down Bottom Up - Cordless', icon: '↕️', price: 0, label: 'Included' },
{ lift: 'Bottom Up (Motorized)', icon: '⬆️', price: 0, label: 'Motor added at Step 5', requiresWidth: 18 },
{ lift: 'Top Down Bottom Up (Motorized)', icon: '⚡', price: 0, label: 'Motor added at Step 5', requiresWidth: 18 },
],
'Roman Shades': [
{ lift: 'Cordless', icon: '🤲', price: 0, label: 'Included' },
{ lift: 'Manual Corded', icon: '🪢', price: 0, label: 'Included' },
{ lift: 'Motorized', icon: '⚡', price: 0, label: 'Choose motor at Step 5', requiresWidth: 18 },
],
'Triple/Shangri-La': [
{ lift: 'Cordless', icon: '🤲', price: 0, label: 'Included' },
{ lift: 'Manual Corded', icon: '🪢', price: 0, label: 'Included' },
{ lift: 'Motorized', icon: '⚡', price: 0, label: 'Choose motor at Step 5', requiresWidth: 18 },
],
'Butterfly Shades': [
{ lift: 'Cordless', icon: '🤲', price: 0, label: 'Included' },
{ lift: 'Manual Corded', icon: '🪢', price: 0, label: 'Included' },
{ lift: 'Motorized', icon: '⚡', price: 0, label: 'Choose motor at Step 5', requiresWidth: 18 },
],
'Print Blinds': [
{ lift: 'Cordless', icon: '🤲', price: 0, label: 'Included' },
{ lift: 'Manual Corded', icon: '🪢', price: 0, label: 'Included' },
{ lift: 'Motorized', icon: '⚡', price: 0, label: 'Choose motor at Step 5', requiresWidth: 18 },
],
'Dual Roller': [
{ lift: 'Cordless', icon: '🤲', price: 0, label: 'Included' },
{ lift: 'Manual Corded', icon: '🪢', price: 0, label: 'Included' },
{ lift: 'Motorized', icon: '⚡', price: 0, label: 'Choose motor at Step 5', requiresWidth: 18 },
],
'Dream Curtains': [
{ lift: 'Manual Chain', icon: '⛓️', price: 0, label: 'Included' },
{ lift: 'Manual Wand', icon: '🪄', price: 0, label: 'Included' },
{ lift: 'Motorized', icon: '⚡', price: 643.75, label: '+$257.50', requiresWidth: 18 },
],
};

function calcChinaShipping(widthIn) {
if (widthIn <= 39) return 40.00;
if (widthIn <= 78) return 60.00;
if (widthIn <= 118) return 85.00;
return 85.00;
}

const PRODUCT_IMAGES = {
'Zebra Shades': 'https://lmgblinds.com/cdn/shop/files/284C4DD9-5D26-409A-8BB7-59E313812C05.jpg?v=1783026420&width=400',
'Honeycomb': 'https://lmg-blinds.myshopify.com/cdn/shop/files/Facetune_30-06-2026-01-46-09.jpg?v=1782809189&width=400',
'Roman Shades': 'https://lmg-blinds.myshopify.com/cdn/shop/files/Facetune_30-06-2026-02-06-50.jpg?v=1782810433&width=400',
'Roller Shades': 'https://lmg-blinds.myshopify.com/cdn/shop/files/Facetune_30-06-2026-02-57-35.jpg?v=1782813532&width=400',
'Dream Curtains': 'https://lmg-blinds.myshopify.com/cdn/shop/files/Facetune_30-06-2026-02-36-50.jpg?v=1782812314&width=400',
'Print Blinds': 'https://cdn.shopify.com/s/files/1/0686/5289/2231/files/7cdde8ca-aaa3-46b4-afda-239feae66e70.jpg?v=1782897723',
'Butterfly Shades': 'https://cdn.shopify.com/s/files/1/0686/5289/2231/files/IMG_1333.png?v=1782960312',
'Triple/Shangri-La': 'https://lmgblinds.com/cdn/shop/files/R.jpg?v=1783024841&width=400',
'Dual Roller': 'https://cdn.shopify.com/s/files/1/0686/5289/2231/files/dual_roller_product_thumbnail.jpg?v=1783584080',
'Genuine Chinese Bamboo/Woven Wood Shades': 'https://cdn.shopify.com/s/files/1/0686/5289/2231/files/IMG_1844.jpg?v=1784541098',
'Venetian Wood Blinds': 'https://cdn.shopify.com/s/files/1/0686/5289/2231/files/IMG_1845.png?v=1784541309',
'Custom Drapes': 'https://cdn.shopify.com/s/files/1/0686/5289/2231/files/IMG_1846.png?v=1784541717',
'Plantation Shutters': 'https://cdn.shopify.com/s/files/1/0686/5289/2231/files/IMG_1477.jpg?v=1784541886',
'Outdoor Windproof Roller Shades': 'https://cdn.shopify.com/s/files/1/0686/5289/2231/files/IMG_1847.png?v=1784542044',
};

const HONEYCOMB_LIFT_COSTS = {
'Corded': 3.32, 'Cordless': 3.68,
'Top Down Bottom Up - Corded': 3.91, 'Top Down Bottom Up - Cordless': 3.91,
'Bottom Up (Motorized)': 3.91, 'Top Down Bottom Up (Motorized)': 3.91,
};

const SERIES_SPECS = {
'MS25': { comp: '30% Polyester / 70% PVC', thick: '0.67mm', open: '5%',  note: 'Sunscreen · FR(US)-NFPA 701 · Class 8 · Ideal for kitchens & bathrooms' },
'MF2':  { comp: '30% Polyester / 70% PVC', thick: '0.86mm', open: '3%',  note: 'Sunscreen · FR(US)-NFPA 701 · Class 8 · Ideal for kitchens & bathrooms' },
'MF3':  { comp: '30% Polyester / 70% PVC', thick: '0.46mm', open: '3%',  note: 'Sunscreen · FR(US)-NFPA 701 · Class 8 · Ideal for kitchens & bathrooms' },
'MS18': { comp: '30% Polyester / 70% PVC', thick: '0.85mm', open: '8%',  note: 'Sunscreen · FR(US)-NFPA 701 · Class 8 · Ideal for kitchens & bathrooms' },
'MS24': { comp: '30% Polyester / 70% PVC', thick: '0.70mm', open: '5%',  note: 'Sunscreen · FR(US)-NFPA 701 · Class 8 · Ideal for kitchens & bathrooms' },
'MS2':  { comp: '30% Polyester / 70% PVC', thick: '0.43mm', open: '5%',  note: 'Sunscreen · Customized FR(US)-NFPA 701 · Class 5 · Ideal for kitchens & bathrooms' },
'MS15': { comp: '30% Polyester / 70% PVC', thick: '0.75mm', open: '5%',  note: 'Sunscreen · FR(US)-NFPA 701 · Class 8 · Ideal for kitchens & bathrooms' },
'MS1':  { comp: '30% Polyester / 70% PVC', thick: '0.46mm', open: '3%',  note: 'Sunscreen · Customized FR(US)-NFPA 701 · Class 8 · Ideal for kitchens & bathrooms' },
'MS3':  { comp: '24% Polyester / 76% PVC',  thick: '0.69mm', open: '0.5%', note: 'Near-opaque sunscreen · FR(US)-NFPA 701 · Class 8 · Ideal for kitchens & bathrooms' },
'ME23': { comp: '100% Polyester', thick: '0.33mm', open: 'Semi-blackout', note: 'Horizontal stripe · Customized FR(US)-NFPA 701 · Class 5' },
'ME24': { comp: '100% Polyester', thick: '0.31mm', open: 'Semi-blackout', note: 'Linen crosshatch · Customized FR(US)-NFPA 701 · Class 4' },
'ME26': { comp: '100% Polyester', thick: '0.48mm', open: 'Semi-blackout', note: 'Linen texture · Customized FR(US)-NFPA 701 · Class 4' },
'ME25': { comp: '100% Polyester', thick: '0.41mm', open: 'Semi-blackout', note: 'Fine dot · Customized FR(US)-NFPA 701 · Class 4' },
'ME15': { comp: '100% Polyester', thick: '0.35mm', open: 'Semi-blackout', note: 'Horizontal stripe · Customized FR(US)-NFPA 701 · Class 5' },
'ME8':  { comp: '100% Polyester', thick: '0.50mm', open: 'Semi-blackout', note: 'Horizontal stripe · Customized FR(US)-NFPA 701 · Class 4' },
'ME12': { comp: '100% Polyester', thick: '0.50mm', open: 'Semi-blackout', note: 'Mixed stripe · Customized FR(US)-NFPA 701 · Class 5' },
'ME16': { comp: '100% Polyester', thick: '0.35mm', open: 'Semi-blackout', note: 'Plain · Customized FR(US)-NFPA 701 · Class 5' },
'ME3':  { comp: '100% Polyester', thick: '0.45mm', open: 'Semi-blackout', note: 'Horizontal stripe · Customized FR(US)-NFPA 701 · Class 6' },
'ME5':  { comp: '100% Polyester', thick: '0.45mm', open: 'Semi-blackout', note: 'Linen crosshatch · Customized FR(US)-NFPA 701 · Class 8' },
'ME1':  { comp: '100% Polyester', thick: '0.55mm', open: 'Semi-blackout', note: 'Horizontal linen stripe · Customized FR(US)-NFPA 701 · Class 5' },
'ME2':  { comp: '100% Polyester', thick: '0.38mm', open: 'Semi-blackout', note: 'Horizontal stripe · Customized FR(US)-NFPA 701 · Class 4' },
'MB25': { comp: '100% Polyester', thick: '0.65mm', open: '0%', note: 'Blackout · Customized FR(US)-NFPA 701 · Class 5' },
'MB20': { comp: '30% Polyester / 70% PVC', thick: '0.73mm', open: '0%', note: 'Blackout · Customized FR(US)-NFPA 701 · Class 8' },
'MB23': { comp: '100% Polyester', thick: '0.62mm', open: '0%', note: 'Blackout · Customized FR(US)-NFPA 701 · Class 4' },
'MB33': { comp: '25% Polyester / 75% PVC',  thick: '0.69mm', open: '0%', note: 'Blackout · FR(US)-NFPA 701 · Class 8' },
'MB17': { comp: '100% Polyester', thick: '0.74mm', open: '0%', note: 'Blackout · Customized FR(US)-NFPA 701 · Class 6' },
'MB26': { comp: '100% Polyester', thick: '0.40mm', open: '0%', note: 'Blackout · Customized FR(US)-NFPA 701 · Class 4' },
'MB16': { comp: '100% Polyester', thick: '0.50mm', open: '0%', note: 'Blackout · Customized FR(US)-NFPA 701 · Class 5' },
'MB22': { comp: '100% Polyester', thick: '0.55mm', open: '0%', note: 'Blackout · Customized FR(US)-NFPA 701 · Class 5' },
'MB2':  { comp: '100% Polyester', thick: '0.55mm', open: '0%', note: 'Blackout · Customized FR(US)-NFPA 701 · Class 4' },
'MB3':  { comp: '100% Polyester', thick: '0.65mm', open: '0%', note: 'Blackout · Customized FR(US)-NFPA 701 · Class 6' },
'MB8':  { comp: '100% Polyester', thick: '0.60mm', open: '0%', note: 'Blackout · Customized FR(US)-NFPA 701 · Class 4' },
'MB11': { comp: '100% Polyester', thick: '0.65mm', open: '0%', note: 'Blackout · Customized FR(US)-NFPA 701 · Class 5 · Max width 110"' },
'MB1':  { comp: '100% Polyester', thick: '0.64mm', open: '0%', note: 'Blackout · Customized FR(US)-NFPA 701 · Class 5' },
'DB30': { comp: '100% Polyester', thick: '0.45mm', open: 'Alternating bands', note: '' },
'DB27': { comp: '100% Polyester', thick: '0.45mm', open: 'Alternating bands', note: '' },
'DB24': { comp: '100% Polyester', thick: '0.45mm', open: 'Alternating bands', note: '' },
'DB1':  { comp: '100% Polyester', thick: '0.42mm', open: 'Alternating bands', note: '' },
'DB9':  { comp: '100% Polyester', thick: '0.48mm', open: 'Alternating bands', note: '' },
'DB22': { comp: '100% Polyester', thick: '0.45mm', open: 'Alternating bands', note: '' },
'DB17': { comp: '100% Polyester', thick: '0.46mm', open: 'Alternating bands', note: '' },
'DB4':  { comp: '100% Polyester', thick: '0.42mm', open: 'Alternating bands', note: '' },
'DE55': { comp: '100% Polyester', thick: '0.45mm', open: 'Alternating bands', note: '' },
'DE37': { comp: '100% Polyester', thick: '0.45mm', open: 'Alternating bands', note: '' },
'DE28': { comp: '100% Polyester', thick: '0.45mm', open: 'Alternating bands', note: '' },
'DE20': { comp: '100% Polyester', thick: '0.42mm', open: 'Alternating bands', note: '' },
'DE13': { comp: '100% Polyester', thick: '0.42mm', open: 'Alternating bands', note: '' },
'DE10': { comp: '100% Polyester', thick: '0.45mm', open: 'Alternating bands', note: '' },
'DE1':  { comp: '100% Polyester', thick: '0.42mm', open: 'Alternating bands', note: '' },
'DE7':  { comp: '100% Polyester', thick: '0.40mm', open: 'Open weave sheer', note: '' },
'DE6':  { comp: '100% Polyester', thick: '0.40mm', open: 'Open weave sheer', note: '' },
};

const MARKUP = 7.1875;
const PRODUCT_MARKUP = { 'Zebra Shades': 7.4175, 'Roller Shades': 7.4175 };
function markupFor(product) { return PRODUCT_MARKUP[product] || MARKUP; }
const DISCOUNT = 0.40;
const OVERSIZED_THRESHOLD = 94.5;
const OVERSIZED_FEE = 275.00;
const SHIPPING_MIN = 10.00;
const SHIPPING_MAX = 30.00;
const SHIPPING_STEP = 0.25;
const SHIPPING_SQFT_MAX = 120;

function calcShipping(sqft) {
const steps = (SHIPPING_MAX - SHIPPING_MIN) / SHIPPING_STEP;
const bracketSize = SHIPPING_SQFT_MAX / steps;
const tier = Math.min(Math.floor(sqft / bracketSize), steps);
return Math.round((SHIPPING_MIN + (tier * SHIPPING_STEP)) * 100) / 100;
}

// ── STATE ──
const state = {
step: 0, product: null, fabricCostPerSqFt: 1.99,
room: null, mount: null, width: null, height: null,
lift: null, liftPrice: 0, bandWidth: null,
color: null, colorCode: null, colorDesc: null, light: null,
motor: 'None', motorPrice: 0, motorSide: null,
hub: false, hubPrice: 0, hookwand: false, hookwandPrice: 0,
solar: false, solarPrice: 0, remoteChannel: null, extraCable: false,
sideChannel: false, sideChannelPrice: 0, sideChannelColor: null,
chain: 'plastic', chainUpgrade: false, chainColor: null, cordSide: null,
dualColorLF: null, dualColorCodeLF: null, dualColorDescLF: null,
dualColorBO: null, dualColorCodeBO: null, dualColorDescBO: null,
_dualSlot: 'lf', dualCombo: 'roller-roller',
bottomRail: null, bottomRailType: null, bottomRailColor: null,
cassetteType: null, cassetteShape: null, cassetteColor: null,
windowName: null, editingIndex: null,
bottomChannel: false, bottomChannelColor: null,
printFile: null, printFileName: null, printNotes: null,
};

let orderList = [];
let orderWarranty = 'standard';
let orderWarrantyPrice = 0;
let lightboxColors = [];
let lightboxIndex = 0;
let currentSelectedBandWidth = null;
let currentSeriesIndex = 0;

// ── DUAL ROLLER FABRIC PICKERS ──
let currentDualLFIdx=0,currentDualBOIdx=0;
function selectDualCombo(card){
document.querySelectorAll('[data-combo]').forEach(function(c){c.classList.remove('selected');});
card.classList.add('selected'); state.dualCombo=card.dataset.combo;
state.dualColorLF=null;state.dualColorCodeLF=null;state.dualColorDescLF=null;
state.dualColorBO=null;state.dualColorCodeBO=null;state.dualColorDescBO=null;
currentDualLFIdx=0;currentDualBOIdx=0;
document.getElementById('sum-color').textContent='Not selected';
document.getElementById('sum-color').classList.add('empty');
renderDualRollerFabrics();checkStep4();
}
function renderDualRollerFabrics(){
var combo=state.dualCombo||'roller-roller';
var roller=FABRIC_CATALOG['Roller Shades']||{};
var zebra=FABRIC_CATALOG['Zebra Shades']||{};
var shangrila=FABRIC_CATALOG['Triple/Shangri-La']||{};
var catLF,catBO,lblLF,lblBO;
if(combo==='zebra-roller'){
catLF=(zebra['Light Filtering']||[]).concat(zebra['Blackout']||[]);
catBO=roller['Blackout']||[];
lblLF='🦓 Zebra Layer — Select Fabric';
lblBO='🪟 Roller Blackout Layer — Select Fabric';
}else if(combo==='shangrila-roller'){
catLF=shangrila['Light Filtering']||[];
catBO=roller['Blackout']||[];
lblLF='✨ Shangri-La Layer — Select Fabric';
lblBO='🪟 Roller Blackout Layer — Select Fabric';
}else{
catLF=roller['Light Filtering']||[];
catBO=roller['Blackout']||[];
lblLF='☀️ Light Filtering Layer — Select Fabric';
lblBO='🌙 Blackout Layer — Select Fabric';
}
var lfLbl=document.getElementById('dual-lf-label');if(lfLbl)lfLbl.textContent=lblLF;
var boLbl=document.getElementById('dual-bo-label');if(boLbl)boLbl.textContent=lblBO;
renderDualSlotSwatches(catLF,'dual-lf-swatches','dual-lf-selected','lf',currentDualLFIdx);
renderDualSlotSwatches(catBO,'dual-bo-swatches','dual-bo-selected','bo',currentDualBOIdx);
}
function renderDualSlotSwatches(catalog,containerId,selId,slot,seriesIdx){
var container=document.getElementById(containerId);if(!container)return;
var selCode=slot==='lf'?state.dualColorCodeLF:state.dualColorCodeBO;
var allColors=[];
catalog.forEach(function(ser){ser.colors.forEach(function(c){allColors.push({name:c.name,desc:c.desc,code:c.code,file:c.file,series:ser.series});});});
var selEl=document.getElementById(selId);
if(selEl){if(selCode){var sc=allColors.find(function(c){return c.code===selCode;});selEl.style.display='block';selEl.innerHTML='✓ <strong>'+selCode+' — '+(sc?sc.name:'')+'</strong>';}else{selEl.style.display='none';}}
container.innerHTML='';
var series=catalog[seriesIdx];if(!series)return;
var lbl=document.createElement('div');lbl.className='color-series-label';lbl.textContent=series.series;container.appendChild(lbl);
var row=document.createElement('div');row.className='color-swatches-row';
series.colors.forEach(function(c){
var gi=allColors.findIndex(function(sc){return sc.code===c.code;});
var isSelected=selCode===c.code;
var wrap=document.createElement('div');wrap.className='color-swatch-wrap';
var swatch=document.createElement('div');
swatch.className='color-swatch'+(isSelected?' selected':'');
swatch.style.backgroundImage="url('"+CDN+c.file+SWATCH_SIZE+"')";
swatch.onclick=(function(sl,cols,idx){return function(){state._dualSlot=sl;lightboxColors=cols;openLightbox(idx);};})(slot,allColors,gi);
var name=document.createElement('span');name.className='color-swatch-name';name.textContent=c.name;
wrap.appendChild(swatch);wrap.appendChild(name);row.appendChild(wrap);
});
container.appendChild(row);
var nb=document.createElement('div');nb.style.cssText='display:flex;align-items:center;justify-content:space-between;gap:8px;margin-top:16px;';
var pBtn=document.createElement('button');pBtn.textContent='← Prev';pBtn.style.cssText='padding:8px 14px;background:transparent;border:1.5px solid var(--gold);color:var(--gold);font-family:var(--font-body);font-size:11px;font-weight:600;letter-spacing:0.1em;text-transform:uppercase;border-radius:4px;cursor:pointer;'+(seriesIdx===0?'opacity:0;pointer-events:none;':'');
pBtn.onclick=(function(sl,idx){return function(){if(sl==='lf'){currentDualLFIdx=Math.max(0,idx-1);}else{currentDualBOIdx=Math.max(0,idx-1);}renderDualRollerFabrics();};})(slot,seriesIdx);
var ctr=document.createElement('span');ctr.style.cssText='font-size:11px;color:var(--ink-muted);font-weight:500;text-align:center;flex:1;';ctr.textContent='Series '+(seriesIdx+1)+' of '+catalog.length;
var nBtn=document.createElement('button');nBtn.textContent='Next →';var isLast=seriesIdx>=catalog.length-1;nBtn.style.cssText='padding:8px 14px;background:transparent;border:1.5px solid var(--gold);color:var(--gold);font-family:var(--font-body);font-size:11px;font-weight:600;letter-spacing:0.1em;text-transform:uppercase;border-radius:4px;cursor:pointer;'+(isLast?'opacity:0;pointer-events:none;':'');
nBtn.onclick=(function(sl,idx,max){return function(){if(sl==='lf'){currentDualLFIdx=Math.min(max,idx+1);}else{currentDualBOIdx=Math.min(max,idx+1);}renderDualRollerFabrics();};})(slot,seriesIdx,catalog.length-1);
nb.appendChild(pBtn);nb.appendChild(ctr);nb.appendChild(nBtn);container.appendChild(nb);
}
// ── MATTER MOTOR MODAL ──
function openMatterModal() {
const btn = document.querySelector('.matter-modal-btn-cancel');
if (btn) {
let lbl = 'Switch to Standard Motor';
if (state.product === 'Honeycomb') {
if (state.lift === 'Top Down Bottom Up (Motorized)') lbl = 'Switch to Top Down – Bottom Up Motor';
else if (state.lift === 'Bottom Up (Motorized)') lbl = 'Switch to Bottom Up Motor';
}
btn.textContent = lbl;
}
document.getElementById('matter-modal-overlay').classList.add('open');
}
function closeMatterModal(switchToStandard) {
document.getElementById('matter-modal-overlay').classList.remove('open');
if (switchToStandard) {
let targetId = 'motor-standard';
if (state.product === 'Honeycomb') {
if (state.lift === 'Top Down Bottom Up (Motorized)') targetId = 'motor-tdbu';
else if (state.lift === 'Bottom Up (Motorized)') targetId = 'motor-bottomup';
}
const stdOpt = document.getElementById(targetId);
if (stdOpt && !stdOpt.classList.contains('hidden')) {
document.querySelectorAll('.motor-option').forEach(o => o.classList.remove('selected'));
stdOpt.classList.add('selected');
state.motor = stdOpt.dataset.motor; state.motorPrice = parseFloat(stdOpt.dataset.motorPrice) || 0;
document.getElementById('sum-motor').textContent = state.motor;
updatePrice();
}
}
}

// ── PRICING ──
function calcListPrice(width, height, fabricCost, liftPrice, motorPrice, hubPrice, solarPrice, hookwandPrice, lift, product, sideChannel) {
const sqft = (width * height) / 144;
const cordlessUp = (lift && lift.toLowerCase().indexOf('cordless') !== -1) ? (sqft * .092903 * 4) : 0;
const chinaCost = (sqft * fabricCost) + cordlessUp + calcChinaShipping(width);
const oversized = width > OVERSIZED_THRESHOLD ? OVERSIZED_FEE : 0;
const hubListed = (hubPrice || 0) / DISCOUNT;
const solarListed = (solarPrice || 0) / DISCOUNT;
const hookwandListed = (hookwandPrice || 0) / DISCOUNT;
const scCost = sideChannel ? ((height * 0.0254 * 50.40) / DISCOUNT) : 0;
const bcCost = state.bottomChannel ? ((state.width * 1.28) / DISCOUNT) : 0;
const listedPrice = (chinaCost * markupFor(product)) + oversized + (liftPrice || 0) + (motorPrice || 0) + hubListed + solarListed + hookwandListed + scCost + bcCost;
return { sqft, listedPrice, customerPrice: listedPrice * DISCOUNT };
}

function calcOrderTotal(windows) {
const oversizedCount = windows.filter(w => w.width > OVERSIZED_THRESHOLD).length;
const numCartons = Math.ceil(oversizedCount / 4);
let total = 0;
windows.forEach(w => {
const sqft = (w.width * w.height) / 144;
const cordlessUp = (w.lift && w.lift.toLowerCase().indexOf('cordless') !== -1) ? (sqft * .092903 * 4) : 0;
const chinaCost = (sqft * (w.fabricCost || 1.99)) + cordlessUp + calcChinaShipping(w.width);
const hubListed = (w.hubPrice || 0) / DISCOUNT;
const solarListed = (w.solarPrice || 0) / DISCOUNT;
const hookwandListed = (w.hookwandPrice || 0) / DISCOUNT;
const scCost = w.sideChannel ? ((w.height * 0.0254 * 50.40) / DISCOUNT) : 0;
const listedBase = (chinaCost * markupFor(w.product)) + (w.liftPrice || 0) + (w.motorPrice || 0) + hubListed + solarListed + hookwandListed + scCost;
total += listedBase * DISCOUNT;
total += calcShipping(sqft);
});
total += numCartons * 110;
return total;
}

// ── STORAGE ──
function saveOrder() { localStorage.setItem('lmg_td_order', JSON.stringify(orderList)); }
function loadOrder() {
try { const s = localStorage.getItem('lmg_td_order'); if (s) orderList = JSON.parse(s); } catch(e) { orderList = []; }
// Auto-edit from cart page ?edit=INDEX
(function() {
  var params = new URLSearchParams(window.location.search);
  var editIdx = params.get('edit');
  if (editIdx !== null) {
    var idx = parseInt(editIdx);
    if (!isNaN(idx) && orderList[idx]) {
      setTimeout(function() { editWindow(idx); }, 500);
    }
  }
})();
}

function flashLiftSection() {
const el = document.getElementById('lift-container'); if (!el) return;
el.style.borderRadius = '8px';
function doFlash(count) {
if (count <= 0) { el.style.boxShadow = ''; return; }
el.style.transition = 'box-shadow 0.18s ease';
el.style.boxShadow = '0 0 0 3px #C9A84C, 0 0 18px rgba(201,168,76,0.55)';
setTimeout(() => { el.style.boxShadow = 'none'; setTimeout(() => doFlash(count - 1), 180); }, 260);
}
setTimeout(() => doFlash(3), 450);
}

function flashMissing(elements) {
if (!elements || !elements.length) return;
const first = elements.filter(Boolean)[0];
if (first) setTimeout(() => first.scrollIntoView({ behavior: 'smooth', block: 'center' }), 50);
elements.forEach(el => {
if (!el) return;
el.style.transition = 'box-shadow 0.18s ease'; el.style.borderRadius = '6px';
let c = 3;
function pulse() { if (c <= 0) { el.style.boxShadow = ''; return; } el.style.boxShadow = '0 0 0 3px #C0392B, 0 0 12px rgba(192,57,43,0.5)'; setTimeout(() => { el.style.boxShadow = 'none'; setTimeout(() => { c--; pulse(); }, 150); }, 250); }
pulse();
});
showMissingToast();
}
function showMissingToast() {
let toast = document.getElementById('lmg-missing-toast');
if (!toast) {
toast = document.createElement('div');
toast.id = 'lmg-missing-toast';
toast.style.cssText = 'position:fixed;top:80px;left:50%;transform:translateX(-50%);background:#C0392B;color:#fff;font-family:var(--font-body);font-size:13px;font-weight:600;letter-spacing:.05em;padding:12px 24px;border-radius:6px;box-shadow:0 4px 20px rgba(0,0,0,0.3);z-index:9999;pointer-events:none;transition:opacity 0.3s ease;white-space:nowrap;';
toast.textContent = '⚠️ Please fill in the highlighted fields';
document.body.appendChild(toast);
}
toast.style.opacity = '1';
clearTimeout(toast._timer);
toast._timer = setTimeout(() => { toast.style.opacity = '0'; }, 3000);
}

// ── RENDER LIFT OPTIONS ──
const CORDLESS_LIMITS = {
'Zebra Shades': { maxW: 78.7, maxH: 90.55, minW: 15.75, minH: 0 },
'Roller Shades': { maxW: 98.4, maxH: 90.55, minW: 15.75, minH: 0 },
};
function cordlessBlocked() {
const lim = CORDLESS_LIMITS[state.product]; if (!lim || !state.width || !state.height) return null;
if (state.width > lim.maxW) return 'Cordless is limited to ' + lim.maxW + '" wide for ' + state.product + ' — your window is ' + formatDim(state.width) + ' wide.';
if (state.height > lim.maxH) return 'Cordless is limited to ' + lim.maxH + '" tall for ' + state.product + ' — your window is ' + formatDim(state.height) + ' tall.';
if (state.width < lim.minW) return 'Cordless requires at least ' + lim.minW + '" width.';
return null;
}
function selectCordSide(side) {
  state.cordSide = side;
  document.getElementById('cord-left').classList.toggle('selected', side === 'Left');
  document.getElementById('cord-right').classList.toggle('selected', side === 'Right');
  document.getElementById('sum-cord-side') && (document.getElementById('sum-cord-side').textContent = side + ' Side');
  checkStep4();
}
function updateCordSideVisibility() {
  var cordedLifts = ['Manual Corded', 'Corded', 'Manual Chain', 'Top Down Bottom Up - Corded', 'Cordless Chain'];
  var show = cordedLifts.indexOf(state.lift) !== -1;
  var sec = document.getElementById('cord-side-section');
  if (sec) sec.style.display = show ? 'block' : 'none';
  if (!show) { state.cordSide = null; document.getElementById('cord-left') && document.getElementById('cord-left').classList.remove('selected'); document.getElementById('cord-right') && document.getElementById('cord-right').classList.remove('selected'); }
}
function renderLiftOptions() {
const container = document.getElementById('lift-container');
const options = LIFT_OPTIONS[state.product] || [];
const isHoneycomb = state.product === 'Honeycomb';
const gridClass = isHoneycomb ? 'honeycomb-lift-grid' : 'lift-grid';
const cordlessMsg = cordlessBlocked();
container.innerHTML = '<div class="' + gridClass + '">' + options.map(opt => {
const motorized = opt.requiresWidth;
const isCordlessOpt = opt.lift.toLowerCase().indexOf('cordless') !== -1;
const disabled = (motorized && state.width && state.width < 18) || (isCordlessOpt && cordlessMsg);
const isCordedOpt = opt.lift === 'Manual Corded' || opt.lift === 'Corded' || opt.lift === 'Top Down Bottom Up - Corded';
const cordedNote = isCordedOpt ? '<div style="font-size:9px;color:var(--ink-muted);margin-top:4px;line-height:1.4;font-weight:400;">Safety chain guide included<br>to screw to side of wall</div>' : '';
return '<div class="lift-card' + (disabled ? ' disabled' : '') + '" data-lift="' + opt.lift + '" data-lift-price="' + opt.price + '"' + (opt.requiresWidth ? ' data-requires-width="18"' : '') + '><div class="lift-icon">' + opt.icon + '</div><div class="lift-name">' + opt.lift + '</div><div class="lift-price-tag">' + opt.label + '</div>' + cordedNote + '</div>';
}).join('') + '</div>' + (cordlessMsg ? '<div style="margin-top:10px;padding:10px 14px;background:#FFF3CD;border:1px solid #FFD700;border-radius:6px;font-size:12px;color:#856404;line-height:1.5;">⚠️ ' + cordlessMsg + '</div>' : '');
if (cordlessMsg && state.lift && state.lift.toLowerCase().indexOf('cordless') !== -1) {
state.lift = null; state.liftPrice = 0;
document.getElementById('sum-lift').textContent = 'Not selected';
document.getElementById('sum-lift').classList.add('empty');
}
container.querySelectorAll('.lift-card').forEach(card => {
card.onclick = function() {
const chosenLift = card.dataset.lift;
const isMotorizedLift = chosenLift && chosenLift.includes('Motorized');
const isTdbuLift = chosenLift === 'Top Down Bottom Up (Motorized)';
const isBuLift = chosenLift === 'Bottom Up (Motorized)';
// Honeycomb: block TDBU and BU motorized if width < 33"
if (state.product === 'Honeycomb' && (isTdbuLift || isBuLift) && state.width && state.width < 33) {
  showConfirm('⚠️ Width Too Narrow', 'Motorized Top Down Bottom Up and Bottom Up require a minimum width of 33 inches for Honeycomb shades. Please enter a wider measurement or choose a different lift type.', 'Got It', false, function(){});
  return;
}
// Honeycomb 25mm: block TDBU motorized
if (state.product === 'Honeycomb' && isTdbuLift) {
  const cell = getHoneycombCellSize();
  if (cell && cell.indexOf('25mm') !== -1) {
    showConfirm('⚠️ Incompatible Selection', '25mm Honeycomb fabrics cannot be used with Top Down Bottom Up motorized. You can switch to Bottom Up motorized only, or select a 38mm or larger Honeycomb fabric to use Top Down Bottom Up.', 'Got It', false, function(){});
    return;
  }
}
container.querySelectorAll('.lift-card').forEach(c => c.classList.remove('selected'));
card.classList.add('selected');
state.lift = chosenLift; updateCordSideVisibility();
state.liftPrice = parseFloat(card.dataset.liftPrice) || 0;
document.getElementById('sum-lift').textContent = state.lift;
document.getElementById('sum-lift').classList.remove('empty');
if (!isMotorizedLift && state.motor !== 'None') {
state.motor = 'None'; state.motorPrice = 0;
document.querySelectorAll('.motor-option').forEach(o => o.classList.remove('selected'));
const noMotorCard = document.querySelector('.motor-option[data-motor="None"]');
if (noMotorCard) noMotorCard.classList.add('selected');
document.getElementById('sum-motor').textContent = 'None';
state.hub = false; state.hubPrice = 0;
state.solar = false; state.solarPrice = 0;
state.extraCable = false; state.remoteChannel = null;
const hubCheck = document.getElementById('acc-hub-check');
const solarCheck = document.getElementById('acc-solar-check');
if (hubCheck) hubCheck.classList.remove('checked');
if (solarCheck) solarCheck.classList.remove('checked');
}
checkStep4(); updatePrice();
};
});
if (state.lift) {
const match = container.querySelector('[data-lift="' + state.lift + '"]');
if (match) match.classList.add('selected');
}
}

// ── RENDER COLOR SWATCHES ──
function renderColorSwatches() {
const container = document.getElementById('color-swatches-container');
const bwWrap = document.getElementById('bandwith-selector-wrap');
const bwButtons = document.getElementById('bandwith-buttons');
const hintText = document.getElementById('filter-hint-text');
const isZebra = state.product === 'Zebra Shades';
const isHoneycomb = state.product === 'Honeycomb';
const isRoman = state.product === 'Roman Shades';
const isDream = state.product === 'Dream Curtains';
const isButterfly = state.product === 'Butterfly Shades';
const isShangrila = state.product === 'Triple/Shangri-La';
const isRoller = state.product === 'Roller Shades';
let catalog = null;
if (isZebra || isHoneycomb || isRoman || isDream || isButterfly || isShangrila || isRoller) {
const productCatalog = FABRIC_CATALOG[state.product];
if (!state.light) {
container.innerHTML = '<p style="color:var(--ink-muted);font-size:13px;margin-top:8px;">Please select a light control option above to see available fabrics.</p>';
bwWrap.style.display = 'none'; return;
}
catalog = productCatalog[state.light] || null;
} else {
catalog = FABRIC_CATALOG[state.product] || null;
}
if (!catalog) {
container.innerHTML = '<p style="color:var(--ink-muted);font-size:13px;">Fabric colors coming soon for this product.</p>';
bwWrap.style.display = 'none'; return;
}
if (isZebra) {
const pairsSeen = new Set(); const pairs = [];
catalog.forEach(s => { const key = s.bandSolid + '|' + s.bandSheer; if (!pairsSeen.has(key)) { pairsSeen.add(key); pairs.push({ key, label: 'Solid Band Width: ' + s.bandSolid + '" / Sheer Mesh Band Width: ' + s.bandSheer + '"' }); } });
hintText.textContent = 'Filter by band width — colors from other widths are still available (shown with strikethrough).';
bwButtons.innerHTML = pairs.map(p => '<button class="bandwidth-btn" data-bw="' + p.key + '">' + p.label + '</button>').join('');
bwButtons.querySelectorAll('.bandwidth-btn').forEach(btn => {
if (currentSelectedBandWidth === btn.dataset.bw) { btn.classList.add('selected'); btn.style.cssText = 'background:#C9A84C !important; border-color:#C9A84C !important; color:#1A1A1A !important; font-weight:700 !important; box-shadow:0 0 0 2px #C9A84C !important;'; }
btn.addEventListener('click', () => { currentSelectedBandWidth = currentSelectedBandWidth === btn.dataset.bw ? null : btn.dataset.bw; renderColorSwatches(); });
});
bwWrap.style.display = 'block';
} else if (isHoneycomb) {
const sizesSeen = new Set(); const sizes = [];
catalog.forEach(s => { if (!sizesSeen.has(s.cellSize)) { sizesSeen.add(s.cellSize); sizes.push(s.cellSize); } });
hintText.textContent = 'Filter by cell size to narrow your selection.';
bwButtons.innerHTML = sizes.map((size, i) => '<button class="bandwidth-btn" data-bw-index="' + i + '">' + size + ' Cell</button>').join('');
bwButtons.querySelectorAll('.bandwidth-btn').forEach((btn, i) => {
const size = sizes[i];
if (currentSelectedBandWidth === size) { btn.classList.add('selected'); btn.style.cssText = 'background:#C9A84C !important; border-color:#C9A84C !important; color:#1A1A1A !important; font-weight:700 !important; box-shadow:0 0 0 2px #C9A84C !important;'; }
btn.addEventListener('click', () => { currentSelectedBandWidth = currentSelectedBandWidth === size ? null : size; renderColorSwatches(); });
});
bwWrap.style.display = 'block';
} else {
bwWrap.style.display = 'none';
}
lightboxColors = []; const codeToIndex = {};
catalog.forEach(series => series.colors.forEach(c => { codeToIndex[c.code] = lightboxColors.length; lightboxColors.push({ name: c.name, desc: c.desc, code: c.code, file: c.file, series: series.series, bandSolid: series.bandSolid || null, bandSheer: series.bandSheer || null, cellSize: series.cellSize || null, vane: series.vane || null }); }));
container.innerHTML = '<p style="color:var(--ink-muted);font-size:12px;margin:8px 0;">Loading fabrics…</p>';
function buildSeriesGroup(series) {
let hidden = false;
if (isZebra && currentSelectedBandWidth) hidden = currentSelectedBandWidth !== (series.bandSolid + '|' + series.bandSheer);
if (isHoneycomb && currentSelectedBandWidth) hidden = currentSelectedBandWidth !== series.cellSize;
let seriesSubLabel = '';
if (isZebra) seriesSubLabel = ' \xb7 Solid Band Width: ' + series.bandSolid + '" / Sheer Mesh Band Width: ' + series.bandSheer + '"';
if (isHoneycomb) seriesSubLabel = ' \xb7 Cell Size: ' + series.cellSize;
if (isShangrila && series.vane) seriesSubLabel = ' \xb7 Vane Size: ' + series.vane;
const group = document.createElement('div'); group.className = 'color-series-group';
const label = document.createElement('div'); label.className = 'color-series-label'; label.textContent = series.series + seriesSubLabel; group.appendChild(label);
if (isDream || isButterfly) {
const cardImg = document.createElement('img');
cardImg.src = CDN + series.colors[0].file + CARD_SIZE; cardImg.alt = series.series + ' color card';
cardImg.style.cssText = 'width:100%;max-height:160px;object-fit:cover;border-radius:6px;border:1px solid var(--border);margin-bottom:10px;cursor:zoom-in;';
cardImg.onclick = function() { openLightbox(codeToIndex[series.colors[0].code]); }; group.appendChild(cardImg);
const hint = document.createElement('p'); hint.style.cssText = 'font-size:10px;color:var(--ink-muted);margin-bottom:10px;'; hint.textContent = 'Tap image to zoom \xb7 Select your color below:'; group.appendChild(hint);
const btnGrid = document.createElement('div'); btnGrid.style.cssText = 'display:flex;flex-direction:column;gap:6px;';
series.colors.forEach(c => {
const isSelected = state.colorCode === c.code; const btn = document.createElement('button');
btn.style.cssText = 'width:100%;padding:10px 14px;text-align:left;border:1.5px solid ' + (isSelected ? 'var(--gold)' : 'var(--border)') + ';border-radius:6px;background:' + (isSelected ? 'var(--gold-pale)' : 'var(--white)') + ';cursor:pointer;font-family:var(--font-body);transition:all 0.2s;box-shadow:' + (isSelected ? '0 0 0 1px var(--gold)' : 'none') + ';';
btn.innerHTML = '<span style="font-size:11px;font-weight:700;color:var(--gold);letter-spacing:.05em;">' + c.code + '</span> <span style="font-size:12px;font-weight:500;color:var(--ink);">— ' + c.name + '</span><br><span style="font-size:10px;color:var(--ink-muted);font-weight:300;">' + c.desc + '</span>';
btn.onclick = function() {
  state.color = c.name; state.colorCode = c.code; state.colorDesc = c.desc;
  document.getElementById('sum-color').textContent = c.code + ' — ' + c.name;
  document.getElementById('sum-color').classList.remove('empty');
  renderColorSwatches(); checkStep4(); showFabricInquiryPopup();
  // Block 25mm Honeycomb if TDBU lift is active - clear and warn
  if (state.product === 'Honeycomb' && series && series.cellSize && series.cellSize.indexOf('25mm') !== -1 && state.lift === 'Top Down Bottom Up (Motorized)') {
    state.color = null; state.colorCode = null; state.colorDesc = null;
    document.getElementById('sum-color').textContent = 'Not selected';
    document.getElementById('sum-color').classList.add('empty');
    renderColorSwatches();
    showConfirm('⚠️ Incompatible Selection', '25mm Honeycomb fabrics cannot be used with Top Down Bottom Up motorized. You can switch to Bottom Up motorized only, or select a 38mm or larger Honeycomb fabric to use Top Down Bottom Up.', 'Got It', false, function(){});
    return;
  }
  if (state.step === 5) enforceMotorWidth();
};
btnGrid.appendChild(btn);
}); group.appendChild(btnGrid); return group;
}
const row = document.createElement('div'); row.className = 'color-swatches-row';
series.colors.forEach(c => {
const idx = codeToIndex[c.code]; const isSelected = state.colorCode === c.code;
const wrap = document.createElement('div'); wrap.className = 'color-swatch-wrap';
const swatch = document.createElement('div');
swatch.className = 'color-swatch' + (isSelected ? ' selected' : '') + (hidden ? ' band-mismatch' : '');
swatch.dataset.color = c.name; swatch.dataset.code = c.code; swatch.dataset.desc = c.desc;
swatch.dataset.index = idx; swatch.dataset.src = CDN + c.file + SWATCH_SIZE;
swatch.onclick = function() { openLightbox(idx); };
const name = document.createElement('span'); name.className = 'color-swatch-name'; name.textContent = c.name;
wrap.appendChild(swatch); wrap.appendChild(name); row.appendChild(wrap);
}); group.appendChild(row); return group;
}
let seriesIndex = currentSeriesIndex; const SERIES_PER_PAGE = 1;
function renderNextSeries() {
container.innerHTML = '';
const end = Math.min(seriesIndex + SERIES_PER_PAGE, catalog.length);
for (let i = seriesIndex; i < end; i++) container.appendChild(buildSeriesGroup(catalog[i]));
currentSeriesIndex = seriesIndex;
const remaining = catalog.length - end;
const navBar = document.createElement('div'); navBar.style.cssText = 'display:flex;align-items:center;justify-content:space-between;gap:8px;margin-top:16px;';
const prevBtn = document.createElement('button'); prevBtn.textContent = '← Prev';
prevBtn.style.cssText = 'padding:10px 18px;background:transparent;border:1.5px solid var(--gold);color:var(--gold);font-family:var(--font-body);font-size:11px;font-weight:600;letter-spacing:0.1em;text-transform:uppercase;border-radius:4px;cursor:pointer;' + (seriesIndex === 0 ? 'opacity:0;pointer-events:none;' : '');
prevBtn.onclick = function() { seriesIndex = Math.max(0, seriesIndex - SERIES_PER_PAGE); currentSeriesIndex = seriesIndex; renderNextSeries(); };
const counter = document.createElement('span'); counter.style.cssText = 'font-size:11px;color:var(--ink-muted);font-weight:500;text-align:center;flex:1;'; counter.textContent = 'Series ' + end + ' of ' + catalog.length;
const nextBtn = document.createElement('button'); nextBtn.textContent = remaining > 0 ? 'Next ' + remaining + ' more →' : 'Next →';
nextBtn.style.cssText = 'padding:10px 18px;background:transparent;border:1.5px solid var(--gold);color:var(--gold);font-family:var(--font-body);font-size:11px;font-weight:600;letter-spacing:0.1em;text-transform:uppercase;border-radius:4px;cursor:pointer;' + (remaining <= 0 ? 'opacity:0;pointer-events:none;' : '');
nextBtn.onclick = function() { seriesIndex = end; currentSeriesIndex = seriesIndex; renderNextSeries(); };
navBar.appendChild(prevBtn); navBar.appendChild(counter); navBar.appendChild(nextBtn); container.appendChild(navBar);
initSwatchLazyLoad();
}
setTimeout(renderNextSeries, 0);
}

function initSwatchLazyLoad() {
const swatches = document.querySelectorAll('.color-swatch[data-src]');
if ('IntersectionObserver' in window) {
const observer = new IntersectionObserver((entries) => { entries.forEach(entry => { if (entry.isIntersecting) { const el = entry.target; el.style.backgroundImage = "url('" + el.dataset.src + "')"; el.removeAttribute('data-src'); observer.unobserve(el); } }); }, { rootMargin: '100px' });
swatches.forEach(el => observer.observe(el));
} else { swatches.forEach(el => { el.style.backgroundImage = "url('" + el.dataset.src + "')"; el.removeAttribute('data-src'); }); }
}

// ── LIGHTBOX ──
function openLightbox(index) {
lightboxIndex = index; updateLightbox();
document.getElementById('lightbox-overlay').classList.add('open');
if (window._lmgResetZoom) window._lmgResetZoom();
}
function updateLightbox() {
const c = lightboxColors[lightboxIndex]; if (!c) return;
document.getElementById('lightbox-img').src = CDN + c.file + LIGHTBOX_SIZE;
[1, -1].forEach(d => { const n = lightboxColors[(lightboxIndex + d + lightboxColors.length) % lightboxColors.length]; if (n && n.file !== c.file) { const pre = new Image(); pre.src = CDN + n.file + LIGHTBOX_SIZE; } });
document.getElementById('lightbox-img').alt = c.name;
document.getElementById('lightbox-color-name').textContent = c.name;
const specs = (typeof SERIES_SPECS !== 'undefined') ? SERIES_SPECS[c.series] : null;
let descText = c.desc;
if (specs) {
let specParts = [];
if (specs.comp) specParts.push(specs.comp);
if (specs.thick) specParts.push('Thickness: ' + specs.thick);
if (specs.open === 'Alternating bands') specParts.push('Alternating solid/sheer bands');
else if (specs.open && specs.open !== '0%') specParts.push('Openness: ' + specs.open);
if (specs.note) specParts.push(specs.note);
if (specParts.length) descText = c.desc + ' · ' + specParts.join(' · ');
}
document.getElementById('lightbox-color-desc').textContent = descText;
let seriesInfo = c.code + ' \xb7 ' + c.series;
if (c.bandSolid) seriesInfo += ' \xb7 Solid Band Width: ' + c.bandSolid + '" / Sheer Mesh: ' + c.bandSheer + '"';
if (c.cellSize) seriesInfo += ' \xb7 Cell Size: ' + c.cellSize;
if (c.vane) seriesInfo += ' \xb7 Vane Size: ' + c.vane;
document.getElementById('lightbox-series').textContent = seriesInfo;
document.getElementById('lightbox-select-btn').textContent = state.colorCode === c.code ? '✓ Selected' : 'Select This Color →';
}
function lightboxNav(dir) { lightboxIndex = (lightboxIndex + dir + lightboxColors.length) % lightboxColors.length; if (window._lmgResetZoom) window._lmgResetZoom(); updateLightbox(); }

// ── LIGHTBOX ZOOM & PAN ──
(function() {
const ZOOM_SCALE = 2.5; let isZoomed = false, isDragging = false;
let startX, startY, translateX = 0, translateY = 0, pointerDownX, pointerDownY;
function getWrap() { return document.getElementById('lightbox-img-wrap'); }
function getImg() { return document.getElementById('lightbox-img'); }
function resetZoom() {
isZoomed = false; translateX = 0; translateY = 0;
const img = getImg(); const wrap = getWrap();
img.style.transition = 'transform 0.25s ease'; img.style.transform = 'scale(1)'; img.style.transformOrigin = 'center center';
wrap.classList.remove('zoomed', 'dragging');
}
function applyTransform(animated) {
const img = getImg(); img.style.transition = animated ? 'transform 0.25s ease' : 'none';
img.style.transform = 'scale(' + ZOOM_SCALE + ') translate(' + (translateX / ZOOM_SCALE) + 'px, ' + (translateY / ZOOM_SCALE) + 'px)';
}
function clampTranslate(wrap) {
const wRect = wrap.getBoundingClientRect();
const maxX = (wRect.width * (ZOOM_SCALE - 1)) / 2; const maxY = (wRect.height * (ZOOM_SCALE - 1)) / 2;
translateX = Math.max(-maxX, Math.min(maxX, translateX)); translateY = Math.max(-maxY, Math.min(maxY, translateY));
}
function wasDrag(x, y) { return Math.abs(x - pointerDownX) > 5 || Math.abs(y - pointerDownY) > 5; }
function onMouseDown(e) {
pointerDownX = e.clientX; pointerDownY = e.clientY; isDragging = false;
if (!isZoomed) return;
startX = e.clientX - translateX; startY = e.clientY - translateY;
getWrap().classList.add('dragging');
document.addEventListener('mousemove', onMouseMove); document.addEventListener('mouseup', onMouseUp); e.preventDefault();
}
function onMouseMove(e) {
if (!isZoomed) return; if (wasDrag(e.clientX, e.clientY)) isDragging = true; if (!isDragging) return;
translateX = e.clientX - startX; translateY = e.clientY - startY; clampTranslate(getWrap()); applyTransform(false);
}
function onMouseUp(e) { if (isDragging) window._lmgLastDrag = Date.now(); getWrap().classList.remove('dragging'); document.removeEventListener('mousemove', onMouseMove); document.removeEventListener('mouseup', onMouseUp); }
function onImgClick(e) {
if (Date.now() - lastTouchHandled < 700) return;
if (wasDrag(e.clientX, e.clientY)) return;
const wrap = getWrap();
if (isZoomed) { resetZoom(); return; }
const rect = wrap.getBoundingClientRect();
translateX = -(e.clientX - rect.left - rect.width / 2) * (ZOOM_SCALE - 1);
translateY = -(e.clientY - rect.top - rect.height / 2) * (ZOOM_SCALE - 1);
clampTranslate(wrap); isZoomed = true; wrap.classList.add('zoomed'); applyTransform(true);
}
let touch0 = null; let lastTouchHandled = 0;
function onTouchStart(e) {
if (e.touches.length !== 1) return; const t = e.touches[0];
pointerDownX = t.clientX; pointerDownY = t.clientY; isDragging = false; touch0 = t;
if (!isZoomed) return; startX = t.clientX - translateX; startY = t.clientY - translateY;
}
function onTouchMove(e) {
if (!isZoomed || !touch0 || e.touches.length !== 1) return; e.preventDefault();
const t = e.touches[0]; if (wasDrag(t.clientX, t.clientY)) isDragging = true; if (!isDragging) return;
translateX = t.clientX - startX; translateY = t.clientY - startY; clampTranslate(getWrap()); applyTransform(false);
}
function onTouchEnd(e) {
const t = e.changedTouches[0];
lastTouchHandled = Date.now();
if (!wasDrag(t.clientX, t.clientY)) {
if (e.cancelable) e.preventDefault();
const wrap = getWrap();
if (isZoomed) { resetZoom(); } else {
const rect = wrap.getBoundingClientRect();
translateX = -(t.clientX - rect.left - rect.width / 2) * (ZOOM_SCALE - 1);
translateY = -(t.clientY - rect.top - rect.height / 2) * (ZOOM_SCALE - 1);
clampTranslate(wrap); isZoomed = true; wrap.classList.add('zoomed'); applyTransform(true);
}
}
if (isDragging) window._lmgLastDrag = Date.now();
touch0 = null; setTimeout(() => { isDragging = false; }, 50);
}
document.addEventListener('DOMContentLoaded', function() {
const wrap = getWrap();
wrap.addEventListener('click', onImgClick); wrap.addEventListener('mousedown', onMouseDown);
wrap.addEventListener('touchstart', onTouchStart, { passive: true });
wrap.addEventListener('touchmove', onTouchMove, { passive: false });
wrap.addEventListener('touchend', onTouchEnd, { passive: false });
});
window._lmgResetZoom = resetZoom;
})();

function openAccessoryZoom(imgUrl, name, desc) {
document.getElementById('lightbox-img').src = imgUrl;
document.getElementById('lightbox-img').alt = name;
document.getElementById('lightbox-color-name').textContent = name;
document.getElementById('lightbox-color-desc').textContent = desc;
document.getElementById('lightbox-series').textContent = 'Accessory';
document.getElementById('lightbox-select-btn').style.display = 'none';
document.getElementById('lightbox-overlay').classList.add('open');
document.getElementById('lightbox-img-wrap').classList.remove('zoomed');
document.querySelector('.lightbox-prev').style.display = 'none';
document.querySelector('.lightbox-next').style.display = 'none';
}
function closeLightbox() {
document.getElementById('lightbox-overlay').classList.remove('open');
if (window._lmgResetZoom) window._lmgResetZoom();
document.getElementById('lightbox-select-btn').style.display = '';
document.querySelector('.lightbox-prev').style.display = '';
document.querySelector('.lightbox-next').style.display = '';
}
function closeLightboxOnOverlay(e) { if (Date.now() - (window._lmgLastDrag || 0) < 400) return; if (e.target === document.getElementById('lightbox-overlay')) closeLightbox(); }
function selectColorFromLightbox() {
// Show fabric info popup on first ever color selection
if (!localStorage.getItem('lmg_fabric_info_shown')) {
  setTimeout(function(){ document.getElementById('lmg-fabric-info-modal').classList.add('open'); }, 400);
  try { localStorage.setItem('lmg_fabric_info_shown','1'); } catch(e) {}
}
const c = lightboxColors[lightboxIndex];
if (state.product === 'Dual Roller') {
if (state._dualSlot === 'lf'){state.dualColorLF=c.name;state.dualColorCodeLF=c.code;state.dualColorDescLF=c.desc;}
else{state.dualColorBO=c.name;state.dualColorCodeBO=c.code;state.dualColorDescBO=c.desc;}
document.getElementById('sum-color').textContent='LF: '+(state.dualColorCodeLF||'—')+' / BO: '+(state.dualColorCodeBO||'—');
document.getElementById('sum-color').classList.remove('empty');
renderDualRollerFabrics();checkStep4();closeLightbox();
_fabricPopupShown=false;showFabricInquiryPopup();return;
}
state.color = c.name; state.colorCode = c.code; state.colorDesc = c.desc;
const isDream = state.product === 'Dream Curtains';
document.getElementById('sum-color').textContent = isDream ? c.code + ' — ' + c.name : c.name + ' (' + c.desc + ')';
document.getElementById('sum-color').classList.remove('empty');
renderColorSwatches(); checkStep4(); closeLightbox();
// Block 25mm Honeycomb if TDBU lift is active - clear and warn
if (state.product === 'Honeycomb' && state.lift === 'Top Down Bottom Up (Motorized)') {
  const cell = getHoneycombCellSize();
  if (cell && cell.indexOf('25mm') !== -1) {
    state.color = null; state.colorCode = null; state.colorDesc = null;
    document.getElementById('sum-color').textContent = 'Not selected';
    document.getElementById('sum-color').classList.add('empty');
    renderColorSwatches();
    showConfirm('⚠️ Incompatible Selection', '25mm Honeycomb fabrics cannot be used with Top Down Bottom Up motorized. You can switch to Bottom Up motorized only, or select a 38mm or larger Honeycomb fabric to use Top Down Bottom Up.', 'Got It', false, function(){});
    return;
  }
}
if (state.step === 5) enforceMotorWidth();
document.getElementById('lightbox-select-btn').textContent = '✓ Selected';
showFabricInquiryPopup();
}

// ── PREVIOUS FABRIC QUICK-PICK ──
function findFabricInCatalog(product, code) {
const cat = FABRIC_CATALOG[product]; if (!cat) return null;
const groups = Array.isArray(cat) ? { _: cat } : cat;
for (const light in groups) {
for (const ser of groups[light]) {
for (const c of ser.colors) {
if (c.code === code) return { color: c, light: Array.isArray(cat) ? null : light };
}
}
}
return null;
}
function renderPrevFabricSuggest() {
const wrap = document.getElementById('prev-fabric-suggest'); if (!wrap) return;
wrap.style.display = 'none'; wrap.innerHTML = '';
if (!state.product || state.product === 'Print Blinds') return;
const seen = new Set(); const matches = [];
orderList.forEach((w, i) => {
if (i === state.editingIndex) return;
if (w.product !== state.product || !w.colorCode || seen.has(w.colorCode)) return;
const found = findFabricInCatalog(state.product, w.colorCode);
if (!found) return;
seen.add(w.colorCode);
matches.push({ code: w.colorCode, name: w.color, desc: w.colorDesc || found.color.desc, light: found.light || w.light, label: w.label, file: found.color.file });
});
if (matches.length === 0) return;
let html = '<div style="background:var(--gold-pale);border:1.5px solid var(--gold);border-radius:8px;padding:14px 16px;">';
html += '<div style="font-size:11px;font-weight:700;letter-spacing:0.1em;text-transform:uppercase;color:var(--gold);margin-bottom:10px;">⚡ Match a previous window</div>';
html += '<div style="display:flex;flex-direction:column;gap:8px;">';
matches.slice(0, 4).forEach(m => {
html += '<button onclick="selectPrevFabric(\'' + m.code + '\')" style="display:flex;align-items:center;gap:12px;width:100%;padding:10px 12px;background:var(--white);border:1.5px solid var(--border);border-radius:6px;cursor:pointer;font-family:var(--font-body);text-align:left;transition:all 0.2s;" onmouseover="this.style.borderColor=\'var(--gold)\'" onmouseout="this.style.borderColor=\'var(--border)\'">';
html += '<span style="width:36px;height:36px;border-radius:4px;border:1px solid var(--border);background-image:url(\'' + CDN + m.file + SWATCH_SIZE + '\');background-size:cover;background-position:center;flex-shrink:0;"></span>';
html += '<span style="flex:1;"><span style="font-size:12px;font-weight:600;color:var(--ink);">' + m.code + ' — ' + m.name + '</span><br><span style="font-size:10px;color:var(--ink-muted);">Used on: ' + escHtml(m.label) + '</span></span>';
html += '<span style="font-size:11px;font-weight:700;color:var(--gold);letter-spacing:.05em;white-space:nowrap;">USE SAME →</span>';
html += '</button>';
});
html += '</div></div>';
wrap.innerHTML = html; wrap.style.display = 'block';
}
function selectPrevFabric(code) {
const found = findFabricInCatalog(state.product, code); if (!found) return;
if (found.light && found.light !== state.light) {
state.light = found.light;
document.querySelectorAll('.light-card').forEach(c => c.classList.toggle('selected', c.dataset.light === found.light));
document.getElementById('sum-light').textContent = state.light;
document.getElementById('sum-light').classList.remove('empty');
currentSelectedBandWidth = null; currentSeriesIndex = 0;
}
state.color = found.color.name; state.colorCode = found.color.code; state.colorDesc = found.color.desc;
document.getElementById('sum-color').textContent = found.color.code + ' — ' + found.color.name;
document.getElementById('sum-color').classList.remove('empty');
renderColorSwatches(); checkStep4();
// Block 25mm Honeycomb if TDBU lift is active
if (state.product === 'Honeycomb' && state.lift === 'Top Down Bottom Up (Motorized)') {
  const cell = getHoneycombCellSize();
  if (cell && cell.indexOf('25mm') !== -1) {
    state.color = null; state.colorCode = null; state.colorDesc = null;
    document.getElementById('sum-color').textContent = 'Not selected';
    document.getElementById('sum-color').classList.add('empty');
    renderColorSwatches();
    showConfirm('⚠️ Incompatible Selection', '25mm Honeycomb fabrics cannot be used with Top Down Bottom Up motorized. You can switch to Bottom Up motorized only, or select a 38mm or larger Honeycomb fabric to use Top Down Bottom Up.', 'Got It', false, function(){});
    return;
  }
}
}

var _fabricPopupShown = false;
function showFabricInquiryPopup() {
  if (_fabricPopupShown) return;
  _fabricPopupShown = true;
  var m = document.getElementById('fabric-inquiry-modal');
  if (m) { m.style.visibility='visible'; m.style.opacity='1'; m.style.pointerEvents='auto'; }
}
window._lmgRCMatches = [];
function renderPrevRailCassetteSuggest() {
const wrap = document.getElementById('prev-rc-suggest'); if (!wrap) return;
wrap.style.display = 'none'; wrap.innerHTML = ''; window._lmgRCMatches = [];
if (!state.product) return;
const seen = new Set(); const matches = [];
orderList.forEach((w, i) => {
if (i === state.editingIndex) return;
if (w.product !== state.product) return;
if (!w.bottomRail && !w.cassetteType) return;
const key = [w.bottomRail, w.bottomRailType, w.bottomRailColor, w.cassetteType, w.cassetteShape, w.cassetteColor].join('|');
if (seen.has(key)) return; seen.add(key);
matches.push({ label: w.label, bottomRail: w.bottomRail, bottomRailType: w.bottomRailType, bottomRailColor: w.bottomRailColor, cassetteType: w.cassetteType, cassetteShape: w.cassetteShape, cassetteColor: w.cassetteColor });
});
if (matches.length === 0) return;
window._lmgRCMatches = matches;
let html = '<div style="background:var(--gold-pale);border:1.5px solid var(--gold);border-radius:8px;padding:14px 16px;">';
html += '<div style="font-size:11px;font-weight:700;letter-spacing:0.1em;text-transform:uppercase;color:var(--gold);margin-bottom:10px;">⚡ Match rail &amp; cassette from a previous window</div>';
html += '<div style="display:flex;flex-direction:column;gap:8px;">';
matches.slice(0, 4).forEach((m, i) => {
const railTxt = m.bottomRail ? [m.bottomRail, m.bottomRailType, m.bottomRailColor].filter(Boolean).join(' — ') : null;
const casTxt = m.cassetteType ? [m.cassetteType, m.cassetteShape, m.cassetteColor].filter(Boolean).join(' — ') : null;
html += '<button onclick="applyPrevRC(' + i + ')" style="display:flex;align-items:center;gap:12px;width:100%;padding:10px 12px;background:var(--white);border:1.5px solid var(--border);border-radius:6px;cursor:pointer;font-family:var(--font-body);text-align:left;transition:all 0.2s;" onmouseover="this.style.borderColor=\'var(--gold)\'" onmouseout="this.style.borderColor=\'var(--border)\'">';
html += '<span style="flex:1;">';
if (railTxt) html += '<span style="font-size:11px;color:var(--ink);"><strong>Rail:</strong> ' + railTxt + '</span><br>';
if (casTxt) html += '<span style="font-size:11px;color:var(--ink);"><strong>Cassette:</strong> ' + casTxt + '</span><br>';
html += '<span style="font-size:10px;color:var(--ink-muted);">Used on: ' + escHtml(m.label) + '</span></span>';
html += '<span style="font-size:11px;font-weight:700;color:var(--gold);letter-spacing:.05em;white-space:nowrap;">USE SAME →</span>';
html += '</button>';
});
html += '</div></div>';
wrap.innerHTML = html; wrap.style.display = 'block';
}
function _clickIfPresent(selector, handler) {
const el = document.querySelector(selector);
if (el && el.offsetParent !== null) { handler(el); return true; }
return false;
}
function applyPrevRC(i) {
const m = window._lmgRCMatches[i]; if (!m) return;
if (m.bottomRail) {
_clickIfPresent('[data-rail-material="' + m.bottomRail + '"]', selectRailMaterial);
if (m.bottomRailType) _clickIfPresent('#rail-shape-grid [data-rail-shape="' + m.bottomRailType + '"]', selectRailShape);
if (m.bottomRailColor) {
if (!_clickIfPresent('#rail-color-section [data-rail-color="' + m.bottomRailColor + '"]', selectRailColor)) {
if (!_clickIfPresent('#rail-shangrila-color-grid [data-rail-color="' + m.bottomRailColor + '"]', selectRailColor)) {
_clickIfPresent('#hc-rail-color-grid [data-rail-color="' + m.bottomRailColor + '"]', selectRailColor);
}
}
}
}
if (m.cassetteType) {
_clickIfPresent('[data-cassette="' + m.cassetteType + '"]', selectCassette);
if (m.cassetteShape) _clickIfPresent('#cassette-shape-section [data-shape="' + m.cassetteShape + '"]', selectShape);
if (m.cassetteColor) {
if (!_clickIfPresent('#cassette-color-section [data-cassette-color="' + m.cassetteColor + '"]', selectCassetteColor)) {
_clickIfPresent('#hc-cassette-color-grid [data-cassette-color="' + m.cassetteColor + '"]', selectCassetteColor);
}
}
}
checkStep4();
}

// ── HONEYCOMB CASSETTE COLOR RULES ──
function getHoneycombCellSize() {
if (state.product !== 'Honeycomb' || !state.colorCode || !state.light) return null;
const groups = FABRIC_CATALOG['Honeycomb'][state.light] || [];
for (const ser of groups) { for (const c of ser.colors) { if (c.code === state.colorCode) return ser.cellSize; } }
return null;
}
function updateHoneycombCassetteColors() {
const grid = document.getElementById('hc-cassette-color-grid'); if (!grid) return;
if (state.product !== 'Honeycomb') return;
const cell = getHoneycombCellSize();
const is25 = cell && cell.indexOf('25mm') !== -1;
const is45 = cell && cell.indexOf('45mm') !== -1;
const allowed = (is25 || is45) ? ['White'] : ['White', 'Beige', 'Grey', 'Black'];
const note = document.getElementById('hc-cassette-25-note'); if (note) note.style.display = (is25 || is45) ? 'block' : 'none';
grid.querySelectorAll('[data-cassette-color]').forEach(el => {
el.style.display = allowed.includes(el.dataset.cassetteColor) ? '' : 'none';
});
if (state.cassetteColor && !allowed.includes(state.cassetteColor)) {
state.cassetteColor = null;
grid.querySelectorAll('[data-cassette-color]').forEach(c => { c.classList.remove('selected'); c.style.cssText = ''; const lbl = c.querySelector('.option-card-label'); if (lbl) lbl.style.color = ''; });
}
const railGrid = document.getElementById('hc-rail-color-grid');
if (railGrid) {
const railNote = document.getElementById('hc-rail-25-note'); if (railNote) railNote.style.display = (is25 || is45) ? 'block' : 'none';
railGrid.querySelectorAll('[data-rail-color]').forEach(el => {
el.style.display = allowed.includes(el.dataset.railColor) ? '' : 'none';
});
if (state.bottomRailColor && !allowed.includes(state.bottomRailColor)) {
state.bottomRailColor = null;
railGrid.querySelectorAll('[data-rail-color]').forEach(c => { c.classList.remove('selected'); c.style.cssText = ''; const lbl = c.querySelector('.option-card-label'); if (lbl) lbl.style.color = ''; });
}
}
}

// ── PRINT UPLOAD ──
document.getElementById('print-file-input').addEventListener('change', (e) => {
const file = e.target.files[0]; if (!file) return;
state.printFile = file; state.printFileName = file.name;
document.getElementById('print-upload-wrap').classList.add('has-file');
document.getElementById('print-filename').textContent = file.name;
document.getElementById('print-preview').style.display = 'block';
if (file.type.startsWith('image/')) {
const reader = new FileReader(); reader.onload = (ev) => { document.getElementById('print-preview-img').src = ev.target.result; }; reader.readAsDataURL(file);
document.getElementById('print-preview-img').style.display = 'block';
} else { document.getElementById('print-preview-img').style.display = 'none'; }
checkStep4();
});
document.getElementById('print-notes-input').addEventListener('input', (e) => { state.printNotes = e.target.value.trim(); });

// ── STEP 4 VALIDATION ──
function checkStep4() {
updateRoomPreviewCta();
updateHoneycombCassetteColors();
const isPrint = state.product === 'Print Blinds';
let valid = false;
if (isPrint) { valid = !!state.lift && !!state.printFile; }
else { valid = !!state.lift && !!state.color && !!state.light; }
const isDualRollerChk = state.product === 'Dual Roller';
const isDream = state.product === 'Dream Curtains';
const isHoneycomb = state.product === 'Honeycomb';
const isShangrila = state.product === 'Triple/Shangri-La';
if (isDualRollerChk) { valid = !!state.lift && !!state.dualColorCodeLF && !!state.dualColorCodeBO && !!state.cassetteColor && !!state.bottomRailColor; }
if (!isDream && !isDualRollerChk && valid) {
if (isHoneycomb) {
valid = !!state.bottomRailColor && !!state.cassetteColor;
} else if (isShangrila) {
valid = !!state.bottomRailColor && !!state.cassetteType;
if (valid && state.cassetteType !== 'No Cassette') valid = !!state.cassetteShape && !!state.cassetteColor;
} else {
valid = !!state.bottomRail && !!state.bottomRailType && !!state.bottomRailColor && !!state.cassetteType;
if (valid && state.cassetteType !== 'No Cassette') valid = !!state.cassetteShape && !!state.cassetteColor;
}
}
if (valid) updatePrice();
}

// ── MOTOR WIDTH ENFORCEMENT ──
const MOTOR_MAX_WIDTH = 110;
function enforceMotorWidth() {
const tooNarrow = state.width && state.width < 18;
const tooWide = state.width && state.width > MOTOR_MAX_WIDTH && state.product !== 'Dream Curtains';
// Honeycomb: all motorized requires min 33" width
const honeycombTooNarrow = state.product === 'Honeycomb' && state.width && state.width < 33;
const motorIds = ['motor-standard', 'motor-zigbee', 'motor-matter', 'motor-bottomup', 'motor-tdbu', 'motor-curtain'];
document.getElementById('motor-min-warning').classList.toggle('show', tooNarrow);
document.getElementById('motor-max-warning').classList.toggle('show', tooWide);
const globalDisable = tooNarrow || tooWide || honeycombTooNarrow;
motorIds.forEach(id => { const el = document.getElementById(id); if (el) el.classList.toggle('disabled', globalDisable); });
if (globalDisable && state.motor !== 'None') {
state.motor = 'None'; state.motorPrice = 0;
document.querySelectorAll('.motor-option').forEach(o => o.classList.remove('selected'));
const noM = document.querySelector('.motor-option[data-motor="None"]');
if (noM) noM.classList.add('selected');
document.getElementById('sum-motor').textContent = 'None';
}
// Honeycomb 25mm: additionally disable TDBU (Bottom Up still allowed)
const cell = getHoneycombCellSize();
const is25mm = cell && cell.indexOf('25mm') !== -1;
const tdbuEl = document.getElementById('motor-tdbu');
if (tdbuEl && !globalDisable) {
tdbuEl.classList.toggle('disabled', is25mm);
if (is25mm && (state.motor === 'Top Down - Bottom Up Motor' || state.motor === 'Top Down - Bottom Up Zigbee Motor' || state.motor === 'Top Down - Bottom Up Matter Motor')) {
state.motor = 'None'; state.motorPrice = 0;
document.querySelectorAll('.motor-option').forEach(o => o.classList.remove('selected'));
const noM = document.querySelector('.motor-option[data-motor="None"]');
if (noM) noM.classList.add('selected');
document.getElementById('sum-motor').textContent = 'None';
}
}
}

// ── TDBU / MOTOR VISIBILITY ──
function setMotorCardIdentity(id, motorName, displayName) {
const card = document.getElementById(id); if (!card) return;
card.dataset.motor = motorName;
const nameEl = card.querySelector('.motor-name');
if (nameEl) nameEl.textContent = displayName || motorName;
}
function setMotorCardPrice(id, listed) {
const card = document.getElementById(id); if (!card) return;
card.dataset.motorPrice = listed;
const priceEl = card.querySelector('.motor-price');
if (priceEl) priceEl.textContent = '+$' + (listed * 0.4).toFixed(2);
if (state.motor === card.dataset.motor) { state.motorPrice = listed; }
}
function updateTdbuMotorVisibility() {
const tdbuMotor = document.getElementById('motor-tdbu');
const bottomUpMotor = document.getElementById('motor-bottomup');
const standardMotor = document.getElementById('motor-standard');
const zigbeeMotor = document.getElementById('motor-zigbee');
const matterMotor = document.getElementById('motor-matter');
const curtainMotor = document.getElementById('motor-curtain');
const noMotorCard = document.querySelector('.motor-option[data-motor="None"]');
const isMotorizedLift = state.lift && state.lift.includes('Motorized');
function selectMotor(motorName, price, summaryText) {
state.motor = motorName; state.motorPrice = price;
document.querySelectorAll('.motor-option').forEach(o => o.classList.remove('selected'));
const card = document.querySelector('.motor-option[data-motor="' + motorName + '"]');
if (card) card.classList.add('selected');
document.getElementById('sum-motor').textContent = summaryText || motorName;
updatePrice();
}
[tdbuMotor, bottomUpMotor, standardMotor, zigbeeMotor, matterMotor, curtainMotor].forEach(el => { if (el) el.classList.add('hidden'); });
if (!isMotorizedLift) {
noMotorCard.classList.remove('hidden');
if (state.motor !== 'None') selectMotor('None', 0, 'None');
return;
}
noMotorCard.classList.add('hidden');
if (state.product === 'Honeycomb') {
if (state.lift === 'Bottom Up (Motorized)') {
bottomUpMotor.classList.remove('hidden'); zigbeeMotor.classList.remove('hidden'); matterMotor.classList.remove('hidden');
setMotorCardIdentity('motor-zigbee', 'Bottom Up Zigbee Motor'); setMotorCardIdentity('motor-matter', 'Bottom Up Matter Motor');
setMotorCardPrice('motor-zigbee', 346.88 + 62.5); setMotorCardPrice('motor-matter', 346.88 + 187.5);
const validBuMotors = ['Bottom Up Motor', 'Bottom Up Zigbee Motor', 'Bottom Up Matter Motor'];
if (!validBuMotors.includes(state.motor)) selectMotor('Bottom Up Motor', 346.88, 'Bottom Up Motor');
}
else if (state.lift === 'Top Down Bottom Up (Motorized)') {
tdbuMotor.classList.remove('hidden'); zigbeeMotor.classList.remove('hidden'); matterMotor.classList.remove('hidden');
setMotorCardIdentity('motor-zigbee', 'Top Down - Bottom Up Zigbee Motor', 'Top Down – Bottom Up Zigbee Motor'); setMotorCardIdentity('motor-matter', 'Top Down - Bottom Up Matter Motor', 'Top Down – Bottom Up Matter Motor');
setMotorCardPrice('motor-zigbee', 443.75 + 62.5); setMotorCardPrice('motor-matter', 443.75 + 187.5);
const validTdbuMotors = ['Top Down - Bottom Up Motor', 'Top Down - Bottom Up Zigbee Motor', 'Top Down - Bottom Up Matter Motor'];
if (!validTdbuMotors.includes(state.motor)) selectMotor('Top Down - Bottom Up Motor', 443.75, 'Top Down - Bottom Up Motor');
}
else {
standardMotor.classList.remove('hidden'); zigbeeMotor.classList.remove('hidden'); matterMotor.classList.remove('hidden');
setMotorCardIdentity('motor-zigbee', 'Zigbee Motor'); setMotorCardIdentity('motor-matter', 'Matter Motor');
setMotorCardPrice('motor-zigbee', 406.25); setMotorCardPrice('motor-matter', 531.25);
const validHcMotors = ['Standard Motor', 'Zigbee Motor', 'Matter Motor'];
if (!validHcMotors.includes(state.motor)) selectMotor('Standard Motor', 343.75, 'Standard Motor');
}
document.querySelectorAll('.motor-option').forEach(o => o.classList.toggle('selected', o.dataset.motor === state.motor));
} else if (state.product === 'Dream Curtains') {
if (curtainMotor) curtainMotor.classList.remove('hidden');
selectMotor('Curtain Track Motor', 0, 'Curtain Track Motor (Included)');
} else {
standardMotor.classList.remove('hidden'); zigbeeMotor.classList.remove('hidden'); matterMotor.classList.remove('hidden');
setMotorCardIdentity('motor-zigbee', 'Zigbee Motor'); setMotorCardIdentity('motor-matter', 'Matter Motor');
setMotorCardPrice('motor-zigbee', 406.25); setMotorCardPrice('motor-matter', 531.25);
const validMotors = ['Standard Motor', 'Zigbee Motor', 'Matter Motor'];
if (!validMotors.includes(state.motor)) selectMotor('Standard Motor', 343.75, 'Standard Motor');
}
}

// ── STEP NAVIGATION (P11 applied: updateChainVisibility added) ──
function goToStep(n) {
// Toggle skip buttons and qty
for(var si=0;si<=3;si++){var sb=document.getElementById('blind-skip-'+si);if(sb)sb.style.display=(state.editingIndex!==null)?'inline-flex':'none';}
var qBox=document.getElementById('blind-qty-box');if(qBox)qBox.style.display=(state.editingIndex!==null)?'none':'flex';
if(n===5){var qEl=document.getElementById('blind-qty');if(qEl&&state.editingIndex===null)qEl.value=1;}
document.getElementById('step-' + state.step).classList.remove('active');
document.querySelectorAll('.progress-step').forEach(el => {
const s = parseInt(el.dataset.step); el.classList.remove('active', 'completed');
if (s < n) el.classList.add('completed'); if (s === n) el.classList.add('active');
});
state.step = n; document.getElementById('step-' + n).classList.add('active');
if (n === 4) { renderStep4ForProduct(); flashLiftSection(); }
var _drv=document.getElementById('dual-roller-step1-video');if(_drv)_drv.style.display=(n===1&&state.product==='Dual Roller')?'block':'none';
var _rrv=document.getElementById('roman-step1-video');if(_rrv)_rrv.style.display=(n===1&&state.product==='Roman Shades')?'block':'none';
var _shangrila_step1_video=document.getElementById('shangrila-step1-video');if(_shangrila_step1_video)_shangrila_step1_video.style.display=(n===1&&state.product==='Triple/Shangri-La')?'block':'none';
var _honeycomb_step1_video=document.getElementById('honeycomb-step1-video');if(_honeycomb_step1_video)_honeycomb_step1_video.style.display=(n===1&&state.product==='Honeycomb')?'block':'none';
var _dream_step1_video=document.getElementById('dream-step1-video');if(_dream_step1_video)_dream_step1_video.style.display=(n===1&&state.product==='Dream Curtains')?'block':'none';
var _butterfly_step1_video=document.getElementById('butterfly-step1-video');if(_butterfly_step1_video)_butterfly_step1_video.style.display=(n===1&&state.product==='Butterfly Shades')?'block':'none';
var _roller_step1_video=document.getElementById('roller-step1-video');if(_roller_step1_video)_roller_step1_video.style.display=(n===1&&state.product==='Roller Shades')?'block':'none';
var _zebra_step1_video=document.getElementById('zebra-step1-video');if(_zebra_step1_video)_zebra_step1_video.style.display=(n===1&&state.product==='Zebra Shades')?'block':'none';
var _print_step1_video=document.getElementById('print-step1-video');if(_print_step1_video)_print_step1_video.style.display=(n===1&&state.product==='Print Blinds')?'block':'none';
var _zig=document.getElementById('zebra-inside-guide');if(_zig)_zig.style.display=(n===3&&state.product==='Zebra Shades'&&state.mount==='Inside Mount')?'block':'none';
var _zog=document.getElementById('zebra-outside-guide');if(_zog)_zog.style.display=(n===3&&state.product==='Zebra Shades'&&state.mount==='Outside Mount')?'block':'none';
var _hig=document.getElementById('honeycomb-inside-guide');if(_hig)_hig.style.display=(n===3&&state.product==='Honeycomb'&&state.mount==='Inside Mount')?'block':'none';
var _hog=document.getElementById('honeycomb-outside-guide');if(_hog)_hog.style.display=(n===3&&state.product==='Honeycomb'&&state.mount==='Outside Mount')?'block':'none';
var _rig=document.getElementById('roller-inside-guide');if(_rig)_rig.style.display=(n===3&&state.product==='Roller Shades'&&state.mount==='Inside Mount')?'block':'none';
var _rog=document.getElementById('roller-outside-guide');if(_rog)_rog.style.display=(n===3&&state.product==='Roller Shades'&&state.mount==='Outside Mount')?'block':'none';
var _roig=document.getElementById('roman-inside-guide');if(_roig)_roig.style.display=(n===3&&state.product==='Roman Shades'&&state.mount==='Inside Mount')?'block':'none';
var _roog=document.getElementById('roman-outside-guide');if(_roog)_roog.style.display=(n===3&&state.product==='Roman Shades'&&state.mount==='Outside Mount')?'block':'none';
var _sig=document.getElementById('shangrila-inside-guide');if(_sig)_sig.style.display=(n===3&&state.product==='Triple/Shangri-La'&&state.mount==='Inside Mount')?'block':'none';
var _sog=document.getElementById('shangrila-outside-guide');if(_sog)_sog.style.display=(n===3&&state.product==='Triple/Shangri-La'&&state.mount==='Outside Mount')?'block':'none';
var _big=document.getElementById('butterfly-inside-guide');if(_big)_big.style.display=(n===3&&state.product==='Butterfly Shades'&&state.mount==='Inside Mount')?'block':'none';
var _bog=document.getElementById('butterfly-outside-guide');if(_bog)_bog.style.display=(n===3&&state.product==='Butterfly Shades'&&state.mount==='Outside Mount')?'block':'none';
var _pig=document.getElementById('print-inside-guide');if(_pig)_pig.style.display=(n===3&&state.product==='Print Blinds'&&state.mount==='Inside Mount')?'block':'none';
var _pog=document.getElementById('print-outside-guide');if(_pog)_pog.style.display=(n===3&&state.product==='Print Blinds'&&state.mount==='Outside Mount')?'block':'none';
var _dig=document.getElementById('dream-inside-guide');if(_dig)_dig.style.display=(n===3&&state.product==='Dream Curtains'&&state.mount==='Inside Mount')?'block':'none';
var _dog=document.getElementById('dream-outside-guide');if(_dog)_dog.style.display=(n===3&&state.product==='Dream Curtains'&&state.mount==='Outside Mount')?'block':'none';
var _drig=document.getElementById('dual-inside-guide');if(_drig)_drig.style.display=(n===3&&state.product==='Dual Roller'&&state.mount==='Inside Mount')?'block':'none';
var _drog=document.getElementById('dual-outside-guide');if(_drog)_drog.style.display=(n===3&&state.product==='Dual Roller'&&state.mount==='Outside Mount')?'block':'none';
var _draig=document.getElementById('drape-inside-guide');if(_draig)_draig.style.display=(n===3&&state.product==='Drapes'&&state.mount==='Inside Mount')?'block':'none';
var _draog=document.getElementById('drape-outside-guide');if(_draog)_draog.style.display=(n===3&&state.product==='Drapes'&&state.mount==='Outside Mount')?'block':'none';
var _vs=document.getElementById('step0-video-section');if(_vs)_vs.style.display=n===0?'block':'none';
if (n === 5) { enforceMotorWidth(); updateTdbuMotorVisibility(); updateHookWandVisibility(); updateMotorSideVisibility(); updateSideChannelVisibility(); updateBottomChannelVisibility(); updateChainVisibility(); }
document.querySelector('.configurator-wrap').scrollIntoView({ behavior: 'smooth', block: 'start' });
updatePrice();
}

// ── PRODUCT TYPE ──
document.querySelectorAll('.product-type-card').forEach(card => {
card.addEventListener('click', () => {
document.querySelectorAll('.product-type-card').forEach(c => c.classList.remove('selected'));
card.classList.add('selected');
state.product = card.dataset.product; state.fabricCostPerSqFt = parseFloat(card.dataset.fabricCost);
document.getElementById('sum-product').textContent = state.product;
document.getElementById('sum-product').classList.remove('empty');
document.getElementById('summary-product-title').textContent = state.product;
});
});
document.getElementById('next-0').addEventListener('click', () => {
if (!state.product) {
flashMissing([document.querySelector('.product-type-grid')]);
return;
}
if (state.product === 'Drapes') {
window.location.href = '/pages/configure-your-drapes';
return;
} else if (state.product === 'Bamboo') {
window.location.href = '/pages/configure-your-bamboo-shades';
return;
} else if (state.product === 'Venetian') {
window.location.href = '/pages/venetian-wood-blinds';
return;
} else if (state.product === 'Outdoor') {
window.location.href = '/pages/outdoor-windproof-roller-shades';
return;
}
goToStep(1);
});

// ── ROOM ──
document.querySelectorAll('.room-card').forEach(card => {
card.addEventListener('click', () => {
document.querySelectorAll('.room-card').forEach(c => c.classList.remove('selected'));
card.classList.add('selected'); state.room = card.dataset.room;
const nameWrap = document.getElementById('window-name-wrap'); const nameInput = document.getElementById('window-name-input');
nameWrap.classList.add('visible');
if (!nameInput.value || nameInput.dataset.autoFilled === 'true') { nameInput.value = getRoomLabel(state.room); nameInput.dataset.autoFilled = 'true'; state.windowName = nameInput.value; }
document.getElementById('sum-room').textContent = state.windowName || state.room;
document.getElementById('sum-room').classList.remove('empty');
});
});
document.getElementById('window-name-input').addEventListener('input', e => { e.target.dataset.autoFilled = 'false'; state.windowName = e.target.value.trim() || null; document.getElementById('sum-room').textContent = state.windowName || state.room || 'Not selected'; });
document.getElementById('next-1').addEventListener('click', () => {
if (!state.room) {
flashMissing([document.querySelector('.room-grid')]);
return;
}
const nameInput = document.getElementById('window-name-input');
state.windowName = nameInput.value.trim() || getRoomLabel(state.room);
document.getElementById('sum-room').textContent = state.windowName;
goToStep(2);
});

// ── MOUNT ──
document.querySelectorAll('.mount-card').forEach(card => {
card.addEventListener('click', () => {
document.querySelectorAll('.mount-card').forEach(c => c.classList.remove('selected')); card.classList.add('selected');
state.mount = card.dataset.mount; document.getElementById('sum-mount').textContent = state.mount; document.getElementById('sum-mount').classList.remove('empty'); });
});
document.getElementById('next-2').addEventListener('click', () => {
if (!state.mount) {
flashMissing([document.querySelector('.mount-grid')]);
return;
}
goToStep(3);
});

// ── DIMENSIONS ──
const FRACTION_LABELS = { '0': '', '0.0625': ' 1/16', '0.125': ' 1/8', '0.1875': ' 3/16', '0.25': ' 1/4', '0.3125': ' 5/16', '0.375': ' 3/8', '0.4375': ' 7/16', '0.5': ' 1/2', '0.5625': ' 9/16', '0.625': ' 5/8', '0.6875': ' 11/16', '0.75': ' 3/4', '0.8125': ' 13/16', '0.875': ' 7/8', '0.9375': ' 15/16' };
function formatDim(value) { const whole = Math.floor(value); const frac = value - whole; const fracLabel = FRACTION_LABELS[frac.toString()] || ''; return whole + fracLabel + '"'; }
function validateDims() {
const wWhole = parseFloat(document.getElementById('width-input').value);
const hWhole = parseFloat(document.getElementById('height-input').value);
const wFrac = parseFloat(document.getElementById('width-fraction').value) || 0;
const hFrac = parseFloat(document.getElementById('height-fraction').value) || 0;
const w = wWhole ? wWhole + wFrac : NaN; const h = hWhole ? hWhole + hFrac : NaN;
const wErr = document.getElementById('width-error'); const hErr = document.getElementById('height-error');
const w110 = document.getElementById('width-110-warning');
const wInput = document.getElementById('width-input'); const hInput = document.getElementById('height-input');
const _isDream = state.product === 'Dream Curtains';
const _wMax = _isDream ? 9999 : 110; const _hMax = _isDream ? 9999 : 120;
if (w && (w < 10 || w > _wMax)) { wErr.classList.add('show'); wInput.classList.add('error'); } else { wErr.classList.remove('show'); wInput.classList.remove('error'); }
if (h && (h < 10 || h > _hMax)) { hErr.classList.add('show'); hInput.classList.add('error'); } else { hErr.classList.remove('show'); hInput.classList.remove('error'); }
w110.style.display = 'none';
if (w >= 10 && w <= _wMax && h >= 10 && h <= _hMax) {
state.width = w; state.height = h;
const sqft = (w * h) / 144;
document.getElementById('sqft-value').innerHTML = sqft.toFixed(2) + '<span class="sqft-unit"> sq ft</span>';
document.getElementById('sqft-display').style.display = 'block';
document.getElementById('sum-width').textContent = formatDim(w); document.getElementById('sum-height').textContent = formatDim(h);
document.getElementById('sum-width').classList.remove('empty'); document.getElementById('sum-height').classList.remove('empty');
document.getElementById('next-3').disabled = false; updatePrice();
} else { document.getElementById('next-3').disabled = true; }
}
document.getElementById('width-input').addEventListener('input', validateDims);
document.getElementById('width-input').addEventListener('blur', function(){
  var _wv=parseFloat(this.value)||0;
  var _wf=parseFloat(document.getElementById('width-fraction').value)||0;
  var _t=_wv+_wf;
  if(state.product==='Dream Curtains'){if(_t>114){document.getElementById('lmg-dream-wide-modal').classList.add('open');}}
  else if(_t>110){document.getElementById('lmg-wide-modal').classList.add('open');}
});
document.getElementById('width-fraction').addEventListener('change', function(){
  var _wv=parseFloat(document.getElementById('width-input').value)||0;
  var _wf=parseFloat(this.value)||0;
  var _t=_wv+_wf;
  if(state.product==='Dream Curtains'){if(_t>114){document.getElementById('lmg-dream-wide-modal').classList.add('open');}}
  else if(_t>110){document.getElementById('lmg-wide-modal').classList.add('open');}
});
document.getElementById('height-input').addEventListener('input', validateDims);
document.getElementById('width-fraction').addEventListener('change', validateDims);
document.getElementById('height-fraction').addEventListener('change', validateDims);
document.getElementById('next-3').addEventListener('click', () => {
const missing = [];
if (!state.width) missing.push(document.getElementById('width-input'));
if (!state.height) missing.push(document.getElementById('height-input'));
if (missing.length) { flashMissing(missing); return; }
goToStep(4);
});

// ── LIGHT CONTROL ──
document.querySelectorAll('.light-card').forEach(card => {
card.addEventListener('click', () => {
const prevLight = state.light;
document.querySelectorAll('.light-card').forEach(c => c.classList.remove('selected')); card.classList.add('selected');
state.light = card.dataset.light; document.getElementById('sum-light').textContent = state.light; document.getElementById('sum-light').classList.remove('empty');
if (prevLight !== state.light) { state.color = null; state.colorCode = null; state.colorDesc = null; currentSelectedBandWidth = null; currentSeriesIndex = 0; document.getElementById('sum-color').textContent = 'Not selected'; document.getElementById('sum-color').classList.add('empty'); }
renderColorSwatches(); checkStep4();
});
});
document.getElementById('next-4').addEventListener('click', () => {
const missing = [];
const isPrint = state.product === 'Print Blinds';
const isHoneycomb = state.product === 'Honeycomb';
const isShangrila = state.product === 'Triple/Shangri-La';
const isDream = state.product === 'Dream Curtains';
const isDualRollerNext = state.product === 'Dual Roller';
if (!state.lift) missing.push(document.getElementById('lift-container'));
if (!isPrint && !isDualRollerNext) {
if (!state.light) missing.push(document.querySelector('.light-grid'));
if (!state.color) missing.push(document.getElementById('color-swatches-container'));
}
if (isDualRollerNext) {
if (!state.dualColorCodeLF) missing.push(document.getElementById('dual-lf-swatches'));
if (!state.dualColorCodeBO) missing.push(document.getElementById('dual-bo-swatches'));
if (!state.cassetteColor) missing.push(document.getElementById('cassette-color-section'));
if (!state.bottomRailColor) missing.push(document.getElementById('rail-color-section'));
}
if (isPrint && !state.printFile) missing.push(document.getElementById('print-upload-wrap'));
if (!isDream && !isDualRollerNext) {
if (isHoneycomb) {
if (!state.bottomRailColor) missing.push(document.getElementById('hc-rail-color-grid'));
if (!state.cassetteColor) missing.push(document.getElementById('hc-cassette-color-grid'));
} else if (isShangrila) {
if (!state.bottomRailColor) missing.push(document.getElementById('rail-shangrila-color-grid'));
if (!state.cassetteType) missing.push(document.getElementById('cassette-type-grid'));
if (state.cassetteType && state.cassetteType !== 'No Cassette') {
if (!state.cassetteShape) missing.push(document.getElementById('cassette-shape-section'));
if (!state.cassetteColor) missing.push(document.getElementById('cassette-color-section'));
}
} else {
if (!state.bottomRail) missing.push(document.getElementById('rail-material-grid'));
if (state.bottomRail && !state.bottomRailType) missing.push(document.getElementById('rail-shape-section'));
if (state.bottomRailType && !state.bottomRailColor) missing.push(document.getElementById('rail-color-section'));
if (!state.cassetteType) missing.push(document.getElementById('cassette-type-section'));
if (state.cassetteType && state.cassetteType !== 'No Cassette') {
if (!state.cassetteShape) missing.push(document.getElementById('cassette-shape-section'));
if (!state.cassetteColor) missing.push(document.getElementById('cassette-color-section'));
}
}
}
if (missing.length) {
flashMissing(missing.filter(Boolean));
return;
}
goToStep(5);
});

// ── MOTOR ──
document.querySelectorAll('.motor-option').forEach(opt => {
opt.onclick = function() {
if (opt.classList.contains('disabled') || opt.classList.contains('hidden')) return;
const isMatter = opt.dataset.motor.indexOf('Matter') !== -1;
const isHoneycomb = state.product === 'Honeycomb';
document.querySelectorAll('.motor-option').forEach(o => o.classList.remove('selected'));
opt.classList.add('selected');
state.motor = opt.dataset.motor; state.motorPrice = parseFloat(opt.dataset.motorPrice) || 0;
document.getElementById('sum-motor').textContent = state.motor === 'None' ? 'None' : state.motor;
updateMotorSideVisibility();
updatePrice();
if (isMatter && isHoneycomb) { openMatterModal(); }
};
});

// ── PRICE UPDATE ──
function updatePrice() {
if (!state.width || !state.height) return;
const { listedPrice, customerPrice } = calcListPrice(state.width, state.height, state.fabricCostPerSqFt, state.liftPrice, state.motorPrice, state.hubPrice, state.solarPrice, state.hookwandPrice, state.lift, state.product, state.sideChannel);
document.getElementById('price-display').style.display = 'block';
document.getElementById('price-original').textContent = '$' + listedPrice.toFixed(2);
document.getElementById('price-amount').innerHTML = '<span>$</span>' + customerPrice.toFixed(2);
}

// ── HELPERS ──
function escHtml(str) { return String(str == null ? '' : str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;'); }
function getRoomLabel(room) {
const existing = orderList.filter(w => w.room === room && w !== orderList[state.editingIndex]);
const count = existing.length + 1; return count === 1 ? room : room + ' ' + count;
}
function calcOversizedFees(windows) { return Math.ceil(windows.filter(w => w.width > OVERSIZED_THRESHOLD).length / 4); }

// ── ADD TO ORDER ──
function addWindowToOrder() {
// TD: Block adding more than 1 window
if (state.editingIndex === null && orderList.length >= 1) {
  showToast('Test Drive is limited to one blind. Use Start Over to reset.', true);
  return;
}
if (!state.width || !state.height) { showToast('Please enter window dimensions.',true); return; }

if (state.sideChannel && !state.sideChannelColor) {
const scItem = document.getElementById('acc-sidechannel-item');
if (scItem) {
scItem.scrollIntoView({ behavior: 'smooth', block: 'center' });
scItem.style.transition = 'box-shadow 0.2s'; scItem.style.boxShadow = '0 0 0 3px #C0392B'; scItem.style.borderRadius = '8px';
setTimeout(() => { scItem.style.boxShadow = 'none'; }, 2200);
}
showToast('Please select a color for your side channels.',true);
return;
}
if (state.motor && state.motor !== 'None' && !state.motorSide) {
const sec = document.getElementById('motor-side-section');
if (sec) {
sec.scrollIntoView({ behavior: 'smooth', block: 'center' });
sec.style.transition = 'box-shadow 0.2s'; sec.style.boxShadow = '0 0 0 3px #C0392B'; sec.style.borderRadius = '8px';
setTimeout(() => { sec.style.boxShadow = 'none'; }, 2200);
}
showToast('Please select the motor charging port side (Left or Right).',true);
return;
}
const { listedPrice, customerPrice } = calcListPrice(state.width, state.height, state.fabricCostPerSqFt, state.liftPrice, state.motorPrice, state.hubPrice, state.solarPrice, state.hookwandPrice, state.lift, state.product, state.sideChannel);
const winSqft = (state.width * state.height) / 144;
const win = {
id: state.editingIndex !== null ? orderList[state.editingIndex].id : Date.now(),
      cordSide: state.cordSide || null,
label: state.windowName || (state.editingIndex !== null ? orderList[state.editingIndex].label : getRoomLabel(state.room)),
product: state.product, fabricCost: state.fabricCostPerSqFt, room: state.room, mount: state.mount,
width: state.width, height: state.height, lift: state.lift, liftPrice: state.liftPrice,
color: state.color, colorCode: state.colorCode, colorDesc: state.colorDesc,
dualColorLF: state.dualColorLF, dualColorCodeLF: state.dualColorCodeLF,
dualColorBO: state.dualColorBO, dualColorCodeBO: state.dualColorCodeBO,
light: state.light, motor: state.motor, motorPrice: state.motorPrice, motorSide: state.motorSide,
printFileName: state.printFileName, printNotes: state.printNotes,
shippingAmt: calcShipping(winSqft),
hub: state.hub, hubPrice: state.hubPrice, solar: state.solar, solarPrice: state.solarPrice,
hookwand: state.hookwand, hookwandPrice: state.hookwandPrice,
sideChannel: state.sideChannel, sideChannelColor: state.sideChannelColor,
sideChannel: state.sideChannel, sideChannelPrice: state.sideChannelPrice, sideChannelColor: state.sideChannelColor,
bottomChannel: state.bottomChannel, bottomChannelColor: state.bottomChannelColor,
remoteChannnel: state.remoteChannel, extraCable: state.extraCable,
bottomRail: state.bottomRail, bottomRailType: state.bottomRailType, bottomRailColor: state.bottomRailColor,
cassetteType: state.cassetteType, cassetteShape: state.cassetteShape, cassetteColor: state.cassetteColor,
chain: state.chain, chainUpgrade: state.chainUpgrade, chainColor: state.chainColor,
listedPrice, customerPrice: customerPrice + (state.sideChannel && state.height ? (state.height * 0.0254 * 50.40) : 0),
};
const wasEditing = state.editingIndex !== null;
if (wasEditing) {
  const editIdx = state.editingIndex;
  orderList[state.editingIndex] = win;
  state.editingIndex = null;
  document.getElementById('btn-add-window').textContent = 'Add to My Test Drive →';
  saveOrder(); renderOrderList();
  setTimeout(function() {
    var items = document.querySelectorAll('.order-item');
    var el = items[editIdx] || null;
    if (el) { el.scrollIntoView({behavior:'smooth',block:'center'}); el.style.transition='box-shadow 0.3s'; el.style.boxShadow='0 0 0 3px var(--gold)'; setTimeout(function(){el.style.boxShadow='';},2000); }
  }, 400);
} else {
  var qty = 1; // TD: always 1
  blindNamingPanel = win; blindNamingQty = qty;
  var baseRoom = win.label || getRoomLabel(state.room) || (state.windowName || 'Window');
  var fields = document.getElementById('blind-naming-fields');
  fields.innerHTML = '';
  for (var ni = 0; ni < qty; ni++) {
    var lbl = qty > 1 ? baseRoom + ' — Window ' + (ni+1) : baseRoom;
    var row = document.createElement('div');
    row.style.cssText = 'display:flex;align-items:center;gap:10px;';
    row.innerHTML = '<span style="font-size:11px;color:#6A6A6A;font-weight:600;min-width:24px;">' + (ni+1) + '.</span>'
      + '<input type="text" value="' + lbl.replace(/"/g,'&quot;') + '" style="flex:1;padding:10px 12px;border:1px solid #DDD;border-radius:4px;font-size:13px;font-family:inherit;" placeholder="Window name">';
    fields.appendChild(row);
  }
  var overlay = document.getElementById('blind-naming-overlay');
  if (overlay) overlay.style.display = 'flex';
  return;
}
const targetIndex = wasEditing ? orderList.indexOf(win) : orderList.length - 1;
saveOrder(); renderOrderList();
resetConfigurator();
document.getElementById('step-' + state.step).classList.remove('active');
document.querySelectorAll('.progress-step').forEach(el => { el.classList.remove('active', 'completed'); if (parseInt(el.dataset.step) === 0) el.classList.add('active'); });
state.step = 0; document.getElementById('step-0').classList.add('active');
setTimeout(() => {
const item = document.getElementById('order-item-' + targetIndex);
if (item) {
item.scrollIntoView({ behavior: 'smooth', block: 'center' });
item.style.transition = 'box-shadow 0.3s'; item.style.boxShadow = '0 0 0 3px var(--gold)';
setTimeout(() => { item.style.boxShadow = ''; }, 2000);
}
}, 150);
document.getElementById('btn-new-window').classList.add('visible');
const bnw2a = document.getElementById('btn-new-window-2'); if (bnw2a) bnw2a.classList.add('visible');
}

function startNewWindow() { state.editingIndex = null; resetConfigurator(); goToStep(0); window.scrollTo({ top: 0, behavior: 'smooth' }); }

// ── EDIT WINDOW ──
function editWindow(index) {
const w = orderList[index]; resetConfigurator(); state.editingIndex = index;
state.product = w.product; state.fabricCostPerSqFt = w.fabricCost;
state.room = w.room; state.mount = w.mount; state.width = w.width; state.height = w.height;
state.lift = w.lift; state.liftPrice = w.liftPrice || 0;
state.color = w.color; state.colorCode = w.colorCode; state.colorDesc = w.colorDesc;
state.light = w.light; state.motor = w.motor; state.motorPrice = w.motorPrice; state.motorSide = w.motorSide || null; state.windowName = w.label;
document.querySelectorAll('.product-type-card').forEach(c => c.classList.toggle('selected', c.dataset.product === w.product));
document.getElementById('sum-product').textContent = w.product; document.getElementById('sum-product').classList.remove('empty');
document.getElementById('summary-product-title').textContent = w.product; document.getElementById('next-0').disabled = false;
document.querySelectorAll('.room-card').forEach(c => c.classList.toggle('selected', c.dataset.room === w.room));
document.getElementById('sum-room').textContent = w.label; document.getElementById('sum-room').classList.remove('empty'); document.getElementById('next-1').disabled = false;
const nameInput = document.getElementById('window-name-input'); nameInput.value = w.label; nameInput.dataset.autoFilled = 'false';
document.getElementById('window-name-wrap').classList.add('visible');
document.querySelectorAll('.mount-card').forEach(c => c.classList.toggle('selected', c.dataset.mount === w.mount));
document.getElementById('sum-mount').textContent = w.mount; document.getElementById('sum-mount').classList.remove('empty'); document.getElementById('next-2').disabled = false;
const wWhole = Math.floor(w.width); const wFracVal = w.width - wWhole; const hWhole = Math.floor(w.height); const hFracVal = w.height - hWhole;
document.getElementById('width-input').value = wWhole; document.getElementById('width-fraction').value = wFracVal.toString();
document.getElementById('height-input').value = hWhole; document.getElementById('height-fraction').value = hFracVal.toString();
document.getElementById('sum-width').textContent = formatDim(w.width); document.getElementById('sum-height').textContent = formatDim(w.height);
document.getElementById('sum-width').classList.remove('empty'); document.getElementById('sum-height').classList.remove('empty');
const sqft = (w.width * w.height) / 144;
document.getElementById('sqft-value').innerHTML = sqft.toFixed(2) + '<span class="sqft-unit"> sq ft</span>';
document.getElementById('sqft-display').style.display = 'block'; document.getElementById('sum-lift').textContent = w.lift; document.getElementById('sum-lift').classList.remove('empty');
document.getElementById('sum-color').textContent = w.color ? (w.color + ' (' + (w.colorDesc || '') + ')') : 'Not selected';
if (w.color) document.getElementById('sum-color').classList.remove('empty');
document.getElementById('sum-light').textContent = w.light || 'Not selected'; if (w.light) document.getElementById('sum-light').classList.remove('empty');
document.querySelectorAll('.motor-option').forEach(o => o.classList.toggle('selected', o.dataset.motor === w.motor));
document.getElementById('sum-motor').textContent = w.motor === 'None' ? 'None' : w.motor;
state.hub = w.hub || false; state.hubPrice = w.hubPrice || 0; state.solar = w.solar || false; state.solarPrice = w.solarPrice || 0;
state.remoteChannel = w.remoteChannel || null; state.extraCable = w.extraCable || false;
state.hookwand = w.hookwand || false; state.hookwandPrice = w.hookwandPrice || 0;
state.sideChannel = w.sideChannel || false; state.sideChannelColor = w.sideChannelColor || null;
state.sideChannel = w.sideChannel || false; state.sideChannelPrice = w.sideChannelPrice || 0; state.sideChannelColor = w.sideChannelColor || null;
state.bottomRail = w.bottomRail || null; state.bottomRailType = w.bottomRailType || null; state.bottomRailColor = w.bottomRailColor || null;
state.cassetteType = w.cassetteType || null; state.cassetteShape = w.cassetteShape || null; state.cassetteColor = w.cassetteColor || null;
const hubCheck = document.getElementById('acc-hub-check'); const solarCheck = document.getElementById('acc-solar-check');
const cableCheck = document.getElementById('acc-cable-check'); const hookwandCheck = document.getElementById('acc-hookwand-check');
const scCheck = document.getElementById('acc-sidechannel-check');
if (hubCheck) hubCheck.classList.toggle('checked', state.hub);
if (solarCheck) solarCheck.classList.toggle('checked', state.solar);
if (cableCheck) cableCheck.classList.toggle('checked', state.extraCable);
if (hookwandCheck) hookwandCheck.classList.toggle('checked', state.hookwand);
if (scCheck) scCheck.classList.toggle('checked', state.sideChannel);
if (state.sideChannelColor) { document.querySelectorAll('#sidechannel-colors .accessory-select-btn').forEach(b => { if (b.dataset.scColor === state.sideChannelColor) { b.classList.add('selected'); b.style.cssText = 'background:#C9A84C !important; border-color:#C9A84C !important; color:#1A1A1A !important; font-weight:700 !important;'; } }); }
if (scCheck) scCheck.classList.toggle('checked', state.sideChannel);
if (state.sideChannelColor) {
document.querySelectorAll('#sidechannel-colors .accessory-select-btn').forEach(b => {
if (b.dataset.scColor === state.sideChannelColor) { b.classList.add('selected'); b.style.cssText = 'background:#C9A84C !important; border-color:#C9A84C !important; color:#1A1A1A !important; font-weight:700 !important;'; }
});
}
if (state.remoteChannel) { document.querySelectorAll('#remote-channels .accessory-select-btn').forEach(b => { if (b.dataset.channel === state.remoteChannel) { b.classList.add('selected'); b.style.cssText = 'background:#C9A84C !important; border-color:#C9A84C !important; color:#1A1A1A !important; font-weight:700 !important;'; } }); }
// Restore chain
state.chain = w.chain || 'plastic';
state.chainUpgrade = w.chainUpgrade || false;
state.chainColor = w.chainColor || null;
if (w.chain) {
  document.querySelectorAll('#chain-btns [data-chain]').forEach(function(b) {
    b.classList.toggle('selected', b.dataset.chain === w.chain);
    if (b.dataset.chain === w.chain) b.style.cssText = 'background:#C9A84C !important;border-color:#C9A84C !important;color:#1A1A1A !important;font-weight:700 !important;';
    else b.style.cssText = '';
  });
}
if (w.chainColor) {
  document.querySelectorAll('[data-chain-color]').forEach(function(b) {
    b.classList.toggle('selected', b.dataset.chainColor === w.chainColor);
    if (b.dataset.chainColor === w.chainColor) b.style.cssText = 'background:#C9A84C !important;border-color:#C9A84C !important;color:#1A1A1A !important;font-weight:700 !important;';
    else b.style.cssText = '';
  });
}
document.getElementById('btn-add-window').textContent = 'Save Changes →';
document.getElementById('btn-new-window').classList.add('visible');
const bnw2b = document.getElementById('btn-new-window-2'); if (bnw2b) bnw2b.classList.add('visible');
goToStep(0); document.querySelector('.configurator-wrap').scrollIntoView({ behavior: 'smooth', block: 'start' });
updatePrice();
function doFlash(count) { if (count <= 0) return; const selected = document.querySelector('.product-type-card.selected'); if (!selected) return; selected.style.transition = 'box-shadow 0.15s ease'; selected.style.boxShadow = '0 0 0 4px #C9A84C, 0 0 16px rgba(201,168,76,0.6)'; setTimeout(() => { selected.style.boxShadow = ''; setTimeout(() => doFlash(count - 1), 150); }, 200); }
setTimeout(() => doFlash(3), 600);
}

function deleteAllWindows() {
showConfirm('Start Over','Remove your test drive blind and start over?','Start Over',true,function(){
orderList=[]; saveOrder(); renderOrderList(); resetConfigurator(); orderWarranty='standard'; orderWarrantyPrice=0; document.querySelectorAll('.warranty-card').forEach(function(c,i){c.classList.toggle('selected',i===0);});
// TD: main-site shutters/drapes/warranty carts are left untouched
document.getElementById('step-'+state.step).classList.remove('active');
document.querySelectorAll('.progress-step').forEach(function(el){el.classList.remove('active','completed');if(parseInt(el.dataset.step)===0)el.classList.add('active');});
state.step=0; document.getElementById('step-0').classList.add('active');
try{bRenderCrossCart();}catch(e){}
window.scrollTo({top:0,behavior:'smooth'});
});
}
function deleteWindow(index){showConfirm('Remove Window','Remove this window?','Remove',true,function(){orderList.splice(index,1);saveOrder();renderOrderList();});}
function duplicateWindow(index) {
const w = { ...orderList[index], id: Date.now() };
const base = (orderList[index].label || w.room || 'Window').replace(/\s+\d+$/, '');
let maxN = 1;
orderList.forEach(win => {
const lbl = win.label || '';
if (lbl === base) { maxN = Math.max(maxN, 1); return; }
if (lbl.indexOf(base + ' ') === 0) {
const n = parseInt(lbl.slice(base.length + 1));
if (!isNaN(n)) maxN = Math.max(maxN, n);
}
});
w.label = base + ' ' + (maxN + 1);
orderList.splice(index + 1, 0, w); saveOrder(); renderOrderList();
// Scroll to and flash the duplicated item
setTimeout(function() {
  var items = document.querySelectorAll('.order-item');
  var el = items[index + 1] || null;
  if (el) { el.scrollIntoView({behavior:'smooth',block:'center'}); el.style.transition='box-shadow 0.3s'; el.style.boxShadow='0 0 0 3px var(--gold)'; setTimeout(function(){el.style.boxShadow='';},2000); }
}, 400);
}

// ── RENDER ORDER LIST ──

// ── Cross-cart preview (blind configurator) ───────────────────────
function lcEscB(s){return String(s||"").replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;");}
function bRenderCrossCart(){if(typeof TD_MODE!=='undefined'&&TD_MODE){var _tdT=orderList.reduce(function(s,w){return s+(w.customerPrice||0)+(w.shippingAmt||0);},0);var _tdEl=document.getElementById("order-total-amount");if(_tdEl)_tdEl.textContent="$"+_tdT.toFixed(2);var _tdCs=document.getElementById("b-cross-section");if(_tdCs)_tdCs.style.display="none";try{tdUpdateDepositDisplay();}catch(e){}return;}var _sh=[],_dr=[],_bam=[];try{var _s=localStorage.getItem("lmg_shutters");if(_s)_sh=JSON.parse(_s);}catch(e){}try{var _d=localStorage.getItem("lmg_drapes");if(_d)_dr=JSON.parse(_d);}catch(e){}try{var _b=localStorage.getItem("lmg_bamboo");if(_b)_bam=JSON.parse(_b);}catch(e){}var _ven=[];try{var _vx=localStorage.getItem("lmg_venetian");if(_vx)_ven=JSON.parse(_vx);}catch(e){}function _mk(w,href,sub){return'<div style="display:grid;grid-template-columns:1fr auto;gap:12px;padding:12px 0;border-bottom:1px solid var(--border);"><div><div style="font-size:12px;font-weight:600;">'+lcEscB(w.label||w.room)+'</div><div style="font-size:11px;color:var(--ink-muted);">'+lcEscB(sub)+'</div><a href="'+href+'" target="_top" style="font-size:10px;font-weight:700;color:var(--gold);text-decoration:none;display:inline-block;margin-top:6px;">Edit</a></div><div style="text-align:right;font-family:var(--font-display);font-size:18px;">$'+(((w.customer||0)+(w.shipping||0))||((w.customerPrice||0)+(w.shippingAmt||0))).toFixed(2)+'</div></div>';}function _hdr(t,n){return'<div style="font-size:10px;font-weight:700;color:var(--gold);margin-bottom:10px;">'+t+" ("+n+')</div>';}var ss=document.getElementById("b-cross-shutters");if(ss){if(_sh.length){ss.innerHTML=_hdr("Plantation Shutters",_sh.length)+_sh.map(function(w){return _mk(w,"/pages/build-your-plantation-shutters?edit="+_sh.indexOf(w),w.type+(w.w?" "+w.w.toFixed(1)+'" x '+w.h.toFixed(1)+'"':""));}).join("");ss.style.display="block";}else ss.style.display="none";}var ds=document.getElementById("b-cross-drapes");if(ds){if(_dr.length){ds.innerHTML=_hdr("Drapes",_dr.length)+_dr.map(function(w){return _mk(w,"/pages/configure-your-drapes?edit="+_dr.indexOf(w),w.fabric||w.category||"Drape");}).join("");ds.style.display="block";}else ds.style.display="none";}var bams=document.getElementById("b-cross-bamboo");if(bams){if(_bam.length){bams.innerHTML=_hdr("Bamboo / Woven Wood",_bam.length)+_bam.map(function(w){return _mk(w,"/pages/configure-your-bamboo-shades?edit="+_bam.indexOf(w),(w.fabSku||"")+(" — "+w.fab||"")+" | "+w.lift);}).join("");bams.style.display="block";}else bams.style.display="none";}var vens=document.getElementById("b-cross-venetian");if(vens){if(_ven.length){vens.innerHTML='<div style="font-size:10px;font-weight:700;color:var(--gold);margin-bottom:10px;">🪵 Venetian Wood Blinds ('+_ven.length+')</div>'+_ven.map(function(w){return _mk(w,"/pages/venetian-wood-blinds?edit="+_ven.indexOf(w),(w.mat||"")+" · "+(w.colorCode?w.colorCode+" — ":"")+( w.color||""));}). join("");vens.style.display="block";}else vens.style.display="none";}var cs=document.getElementById("b-cross-section");if(cs)var _outd=[];try{var _ox=localStorage.getItem('lmg_outdoor');if(_ox)_outd=JSON.parse(_ox);}catch(e){}var outds=document.getElementById("b-cross-outdoor");if(outds){if(_outd.length){outds.innerHTML='<div style="font-size:10px;font-weight:700;color:var(--gold);margin-bottom:10px;">🌿 Outdoor Windproof Roller Shades ('+_outd.length+')</div>'+_outd.map(function(w,i){return _mk(w,'/pages/outdoor-windproof-roller-shades?edit='+i,(w.fabCode?w.fabCode+' — ':'')+( w.fabName||'')+' · '+(w.lift||''));}). join('');outds.style.display='block';}else outds.style.display='none';}cs.style.display=(_sh.length||_dr.length||_bam.length||_ven.length||_outd.length)?"block":"none";var st=_sh.reduce(function(s,w){return s+(w.customer||0)+(w.shipping||0);},0);var dt=_dr.reduce(function(s,w){return s+(w.customer||0)+(w.shipping||0);},0);var bamt=_bam.reduce(function(s,w){return s+(w.customer||0)+(w.ship||0);},0);
  var vent2=_ven.reduce(function(s,w){return s+(w.customer||0)+(w.ship||0);},0);var outdt=_outd.reduce(function(s,w){return s+(w.customer||0)+(w.ship||0);},0);var bt=orderList.reduce(function(s,w){return s+(w.customerPrice||0)+(w.shippingAmt||0);},0)+orderWarrantyPrice;var tel=document.getElementById("order-total-amount");if(tel)tel.textContent="$"+(bt+st+dt+bamt+vent2+outdt).toFixed(2);
  (function(){
    var blindSav=orderList.reduce(function(s,w){return s+(w.listedPrice||0)-(w.customerPrice||0);},0);var shutSav=_sh.reduce(function(s,w){return s+(w.listed||0)-(w.customer||0);},0);var drapeSav=_dr.reduce(function(s,w){return s+(w.listed||0)-(w.customer||0);},0);var bamSavBlX=_bam.reduce(function(s,w){return s+(w.listed||w.listedPrice||0)-(w.customer||w.customerPrice||0);},0);var venSavBlX=_ven.reduce(function(s,w){return s+(w.listed||w.listedPrice||0)-(w.customer||w.customerPrice||0);},0);var outSavBlX=_outd.reduce(function(s,w){return s+(w.listed||w.listedPrice||0)-(w.customer||w.customerPrice||0);},0);var savings=blindSav+shutSav+drapeSav+bamSavBlX+venSavBlX+outSavBlX;
    var savingsEl=document.getElementById("order-total-savings");
    if(!savingsEl){savingsEl=document.createElement("div");savingsEl.id="order-total-savings";savingsEl.style.cssText="font-size:12px;font-weight:600;color:#e74c3c;margin-top:6px;letter-spacing:0.03em;";var bar=document.querySelector(".order-total-bar");var left=bar?bar.querySelector(".order-total-left"):null;if(left)left.appendChild(savingsEl);}
    var blindShX=orderList.reduce(function(s,w){return s+(w.shippingAmt||0);},0);var shutShX=_sh.reduce(function(s,w){return s+(w.shipping||0);},0);var drapeShX=_dr.reduce(function(s,w){return s+(w.shipping||0);},0);var venShX=_ven.reduce(function(s,w){return s+(w.ship||0);},0);var bamShX=_bam.reduce(function(s,w){return s+(w.ship||0);},0);var outShX=_outd.reduce(function(s,w){return s+(w.ship||0);},0);var allShX=blindShX+shutShX+drapeShX+venShX+bamShX+outShX;if(savings>0){savingsEl.innerHTML='<span style="text-decoration:line-through;color:#9A9A9A;font-weight:400;">$'+(bt+st+dt+bamt+vent2+outdt-allShX-orderWarrantyPrice+savings).toFixed(2)+'<'+'/span> &nbsp;You save $'+savings.toFixed(2);}
    else{savingsEl.innerHTML="";}
  })();}


// ── AUTO SCROLL DURING DRAG ───────────────────────────────────────
var _scrollInterval = null;
var _lastDragY = null;
var _mouseY = 0;
document.addEventListener('mousemove', function(e){ _mouseY = e.clientY; });
function startDragScroll() {
  stopAutoScroll();
  _scrollInterval = setInterval(function() {
    var y = _mouseY;
    var vh = window.innerHeight;
    var zone = 200;
    if (y < zone) {
      var spd = Math.round(20 * (1 - y / zone)) + 5;
      window.scrollBy(0, -spd);
    } else if (y > vh - zone) {
      var spd = Math.round(20 * (1 - (vh - y) / zone)) + 5;
      window.scrollBy(0, spd);
    }
  }, 16);
}
function startAutoScroll(y, isTouch) {
  stopAutoScroll();
  var zone = 200, vh = window.innerHeight;
  var distTop = y, distBot = vh - y;
  var baseSpeed = isTouch ? 300 : 15;
  var scrollSpeed = 0;
  if (distTop < zone) {
    scrollSpeed = -(baseSpeed + Math.round(baseSpeed * (1 - distTop / zone)));
  } else if (distBot < zone) {
    scrollSpeed = baseSpeed + Math.round(baseSpeed * (1 - distBot / zone));
  }
  if (scrollSpeed !== 0) {
    var spd = scrollSpeed;
    _scrollInterval = setInterval(function(){ window.scrollBy(0, spd); }, 16);
  }
}
function stopAutoScroll() {
  if (_scrollInterval) { clearInterval(_scrollInterval); _scrollInterval = null; }
}
// ──────────────────────────────────────────────────────────────────
var _orderDragIdx = null, _orderTouchEl = null, _orderGhost = null;
function orderDragStart(e,i){_orderDragIdx=i;e.dataTransfer.effectAllowed='move';e.currentTarget.style.opacity='0.4';}
function orderDragOver(e){
  e.preventDefault();e.dataTransfer.dropEffect='move';
  e.currentTarget.style.outline='2px solid var(--gold)';
  // Scroll based on direction: above or below the dragged item
  if(_orderDragIdx===null)return;
  var srcEl=document.getElementById('order-item-'+_orderDragIdx);
  if(!srcEl)return;
  var srcRect=srcEl.getBoundingClientRect();
  var curRect=e.currentTarget.getBoundingClientRect();
  stopAutoScroll();
  if(curRect.top < srcRect.top){
    _scrollInterval=setInterval(function(){window.scrollBy(0,-12);},16);
  } else if(curRect.top > srcRect.top){
    _scrollInterval=setInterval(function(){window.scrollBy(0,12);},16);
  }
}
function orderDrop(e,toIdx){e.preventDefault();if(_orderDragIdx===null||_orderDragIdx===toIdx)return;var m=orderList.splice(_orderDragIdx,1)[0];orderList.splice(toIdx,0,m);saveOrder();renderOrderList();}
function orderDragEnd(e){_orderDragIdx=null;document.querySelectorAll('.order-item').forEach(function(el){el.style.opacity='';el.style.outline='';});}
function orderTouchStart(e,i){
  _orderDragIdx=i; _orderTouchEl=e.currentTarget.closest('.order-item');
  e.preventDefault();
  var rect=_orderTouchEl.getBoundingClientRect();
  _orderGhost=_orderTouchEl.cloneNode(true);
  _orderGhost.style.cssText='position:fixed;left:'+rect.left+'px;top:'+rect.top+'px;width:'+rect.width+'px;opacity:0.75;pointer-events:none;z-index:9999;box-shadow:0 8px 32px rgba(0,0,0,0.25);border-radius:8px;transform:scale(1.02);transition:none;';
  document.body.appendChild(_orderGhost);
  _orderTouchEl.style.opacity='0.3';
}
function orderTouchMove(e){
  if(!_orderGhost)return; e.preventDefault();
  var t=e.touches[0];
  var rect=_orderTouchEl.getBoundingClientRect();
  _orderGhost.style.top=(t.clientY - rect.height/2)+'px';
  startAutoScroll(t.clientY, true);
  _orderGhost.style.left=_orderGhost.style.left;
  document.querySelectorAll('.order-item').forEach(function(el){el.style.outline='';});
  var target=document.elementFromPoint(t.clientX, t.clientY);
  var item=target&&target.closest('.order-item');
  if(item&&item!==_orderTouchEl) item.style.outline='2px solid var(--gold)';
}
function orderTouchEnd(e){  stopAutoScroll();
  if(_orderDragIdx===null)return;
  if(_orderGhost){_orderGhost.remove();_orderGhost=null;}
  var t=e.changedTouches[0];
  var target=document.elementFromPoint(t.clientX,t.clientY);
  var item=target&&target.closest('.order-item');
  if(item&&item!==_orderTouchEl){
    var toIdx=parseInt(item.id.replace('order-item-',''));
    if(!isNaN(toIdx)&&toIdx!==_orderDragIdx){
      var m=orderList.splice(_orderDragIdx,1)[0];
      orderList.splice(toIdx,0,m); saveOrder();
    }
  }
  document.querySelectorAll('.order-item').forEach(function(el){el.style.opacity='';el.style.outline='';});
  _orderDragIdx=null; _orderTouchEl=null; renderOrderList();
}

// Use both document and window to catch dragover near sticky header
function _handleDesktopDragOver(e) {
  e.preventDefault();
}
document.addEventListener('dragover', _handleDesktopDragOver);
window.addEventListener('dragover', _handleDesktopDragOver);
document.addEventListener('dragend', function() { stopAutoScroll(); });
window.addEventListener('dragend', function() { stopAutoScroll(); });
function renderOrderList() {
const section = document.getElementById('order-list-section'); const container = document.getElementById('order-items-container');
const countEl = document.getElementById('order-count'); const totalEl = document.getElementById('order-total-amount');
if (!section || !container) { return; }
if (orderList.length === 0) { section.classList.remove('visible'); return; }
section.classList.add('visible');
countEl.textContent = orderList.length + ' window' + (orderList.length > 1 ? 's' : '') + ' configured';
container.innerHTML = orderList.map((w, i) => {
const specs = [w.product, {t: formatDim(w.width) + ' \xd7 ' + formatDim(w.height), ed:'size'}, w.mount, w.dualColorCodeLF ? 'LF: ' + w.dualColorCodeLF + ' — ' + (w.dualColorLF||'') : null,
w.dualColorCodeBO ? 'BO: ' + w.dualColorCodeBO + ' — ' + (w.dualColorBO||'') : null,
(!w.dualColorCodeLF ? (w.color ? {t:w.color, ed:'fab'} : w.printFileName) : null), w.light, w.lift, w.motor !== 'None' ? w.motor : null, w.motor !== 'None' && w.motorSide ? 'Motor Side: ' + w.motorSide : null, w.hub ? 'Hub ($150)' : null, w.solar ? 'Solar Panel ($65)' : null, w.hookwand ? 'Hook Wand ($15)' : null,
w.sideChannel ? 'Side Channels' + (w.sideChannelColor ? ' — ' + w.sideChannelColor : '') : null, w.remoteChannel ? 'Remote ' + w.remoteChannel + ' (Free)' : null, w.extraCable ? 'Extra Cable (Free)' : null, w.bottomRail ? (() => { const mat = w.bottomRail === 'Metal' ? 'Metal Rail' : w.bottomRail === 'Fabric Covered' ? 'Fabric Covered Rail' : w.bottomRail === 'Aluminum' ? 'Aluminum Rail' : w.bottomRail === 'Fixed' ? 'Fixed Rail' : w.bottomRail + ' Rail'; return mat + (w.bottomRailType ? ' — ' + w.bottomRailType : '') + (w.bottomRailColor ? ' — ' + w.bottomRailColor : ''); })() : null, w.cassetteType && w.cassetteType !== 'No Cassette' ? w.cassetteType + (w.cassetteShape ? ' — ' + w.cassetteShape : '') + (w.cassetteColor ? ' — ' + w.cassetteColor : '') : null].filter(Boolean);
const { customerPrice } = calcListPrice(w.width, w.height, w.fabricCost || 1.99, w.liftPrice || 0, w.motorPrice || 0, w.hubPrice || 0, w.solarPrice || 0, w.hookwandPrice || 0, w.lift, w.product, w.sideChannel);
const shippingAmt = w.shippingAmt || calcShipping((w.width * w.height) / 144);
const imgUrl = PRODUCT_IMAGES[w.product] || null;
return '<div class="order-item" id="order-item-' + i + '" draggable="true" ondragstart="orderDragStart(event,' + i + ')" ondragover="orderDragOver(event)" ondrop="orderDrop(event,' + i + ')" ondragend="orderDragEnd(event)"><div style="display:flex;gap:16px;align-items:flex-start;"><input type="checkbox" class="blind-item-check" data-idx="' + i + '" onchange="blindUpdateDeleteBar()" style="width:16px;height:16px;cursor:pointer;accent-color:var(--gold);flex-shrink:0;margin-top:4px;"><span title="Drag to reorder" style="cursor:grab;color:var(--ink-muted);font-size:20px;padding:8px 4px;flex-shrink:0;user-select:none;touch-action:none;" ontouchstart="orderTouchStart(event,' + i + ')" ontouchmove="orderTouchMove(event)" ontouchend="orderTouchEnd(event)">⠿</span>' + (imgUrl ? '<img src="' + imgUrl + '" alt="' + w.product + '" style="width:72px;height:72px;object-fit:cover;border-radius:6px;border:1px solid var(--border);flex-shrink:0;" />' : '') + '<div style="flex:1;min-width:0;"><div class="order-item-label">Window ' + (i + 1) + '</div><div class="order-item-title-row"><span class="order-item-title" id="lmg-title-' + i + '">' + escHtml(w.label) + '</span><button class="lmg-ip" type="button" title="Rename this window" aria-label="Rename this window" onclick="lmgRename(' + i + ')">✏️</button></div><div class="order-item-specs">' + specs.map(s => (s && s.ed) ? '<span class="order-item-spec lmg-spec-ed">' + escHtml(s.t) + '<button class="lmg-ip" type="button" title="Edit" aria-label="Edit" onclick="' + (s.ed === 'size' ? 'lmgSizeOpen' : 'lmgFabOpen') + '(' + i + ')">✏️</button></span>' : '<span class="order-item-spec">' + escHtml(s) + '</span>').join('') + '</div>' + (w.printNotes ? '<div style="margin-top:8px;font-size:11px;color:var(--ink-muted);">Notes: ' + escHtml(w.printNotes) + '</div>' : '') + '<div class="order-item-actions"><button class="btn-item-action" onclick="editWindow(' + i + ')">Edit</button><button class="btn-item-action" onclick="duplicateWindow(' + i + ')">Duplicate</button><button class="btn-item-action delete" onclick="deleteWindow(' + i + ')">Delete</button></div></div></div><div><div class="order-item-price-label">Your Price</div><div class="order-item-price">$' + customerPrice.toFixed(2) + '</div><div style="font-size:10px;color:var(--ink-muted);text-align:right;margin-top:2px;">+ $' + shippingAmt.toFixed(2) + ' shipping</div></div></div>';
}).join('');
totalEl.textContent = '$' + (calcOrderTotal(orderList) + orderWarrantyPrice).toFixed(2);
var winNote=document.getElementById('order-total-windows');
if(winNote) winNote.textContent="Your Test Drive price";
(function(){
  var _shR2=[],_drR2=[];try{var _sxR2=localStorage.getItem('lmg_shutters');if(_sxR2)_shR2=JSON.parse(_sxR2);}catch(e){}try{var _dxR2=localStorage.getItem('lmg_drapes');if(_dxR2)_drR2=JSON.parse(_dxR2);}catch(e){}
var blindSav2=orderList.reduce(function(s,w){return s+(w.listedPrice||0)-(w.customerPrice||0);},0);var shutSav2=_shR2.reduce(function(s,w){return s+(w.listed||0)-(w.customer||0);},0);var drapeSav2=_drR2.reduce(function(s,w){return s+(w.listed||0)-(w.customer||0);},0);var _bamRX=[],_venRX=[],_outRX=[];try{var _bxRX=localStorage.getItem('lmg_bamboo');if(_bxRX)_bamRX=JSON.parse(_bxRX);}catch(e){}try{var _vxRX=localStorage.getItem('lmg_venetian');if(_vxRX)_venRX=JSON.parse(_vxRX);}catch(e){}try{var _oxRX=localStorage.getItem('lmg_outdoor');if(_oxRX)_outRX=JSON.parse(_oxRX);}catch(e){}var bamSavBl2=_bamRX.reduce(function(s,w){return s+(w.listed||w.listedPrice||0)-(w.customer||w.customerPrice||0);},0);var venSavBl2=_venRX.reduce(function(s,w){return s+(w.listed||w.listedPrice||0)-(w.customer||w.customerPrice||0);},0);var outSavBl2=_outRX.reduce(function(s,w){return s+(w.listed||w.listedPrice||0)-(w.customer||w.customerPrice||0);},0);var savings=blindSav2+shutSav2+drapeSav2+bamSavBl2+venSavBl2+outSavBl2;
  var savingsEl=document.getElementById('order-total-savings');
  if(!savingsEl){savingsEl=document.createElement('div');savingsEl.id='order-total-savings';savingsEl.style.cssText='font-size:12px;font-weight:600;color:#e74c3c;margin-top:6px;letter-spacing:0.03em;';var bar=document.querySelector('.order-total-bar');var left=bar?bar.querySelector('.order-total-left'):null;if(left)left.appendChild(savingsEl);}
  var blindShR=orderList.reduce(function(s,w){return s+(w.shippingAmt||0);},0);var shutShR=_shR2.reduce(function(s,w){return s+(w.shipping||0);},0);var drapeShR=_drR2.reduce(function(s,w){return s+(w.shipping||0);},0);var allShR=blindShR+shutShR+drapeShR;if(savings>0){savingsEl.innerHTML='<span style="text-decoration:line-through;color:#9A9A9A;font-weight:400;">$'+(calcOrderTotal(orderList)-allShR+savings).toFixed(2)+'<'+'/span> &nbsp;You save $'+savings.toFixed(2);}
  else{savingsEl.innerHTML='';}
})();
try { bRenderCrossCart(); } catch(e){}
}

function emailQuote(){openEmailModal();}

// ── TD: proof-of-terms record sent with the deposit (used as chargeback evidence) ──
var TD_TERMS_VERSION='2026-09-27-v2-70pct-5x';
var TD_DEPOSIT_RATE=0.70; // must match DEPOSIT_RATE in the lmg-test-drive Worker
function tdBuildConsent(){
  var termsEl=document.getElementById('td-terms-check');
  var termsLabel=termsEl?termsEl.closest('label'):null;
  var modal=document.getElementById('td-how-it-works-modal');
  var tz='';try{tz=Intl.DateTimeFormat().resolvedOptions().timeZone||'';}catch(e){}
  return {
    termsAccepted:!!(termsEl&&termsEl.checked),
    howItWorksAgreed:(typeof tdTermsAgreed!=='undefined'&&tdTermsAgreed===true),
    termsText:termsLabel?(termsLabel.innerText||termsLabel.textContent||'').replace(/\s+/g,' ').trim():'',
    programTermsText:modal?(modal.innerText||modal.textContent||'').replace(/[ \t]+/g,' ').replace(/\n\s*\n+/g,'\n').trim():'',
    termsVersion:TD_TERMS_VERSION,
    acceptedAtClient:new Date().toString(),
    timezone:tz,
    pageUrl:window.location.origin+window.location.pathname
  };
}
// ── TD: pay-button busy state (spinner, locked, clear text) ──
function tdBtnBusy(btn,text){
  if(!btn)return;
  if(!document.getElementById('td-spin-style')){var st=document.createElement('style');st.id='td-spin-style';st.textContent='@keyframes tdspin{to{transform:rotate(360deg)}}.td-spin{display:inline-block;width:14px;height:14px;border:2px solid currentColor;border-right-color:transparent;border-radius:50%;animation:tdspin .7s linear infinite;vertical-align:-2px;margin-right:10px}';document.head.appendChild(st);}
  if(!btn.dataset.tdOrigHtml)btn.dataset.tdOrigHtml=btn.innerHTML;
  btn.innerHTML='<span class="td-spin"></span>'+text;
  btn.disabled=true;btn.style.opacity='0.85';btn.style.cursor='wait';btn.style.pointerEvents='none';
}
function tdBtnReset(btn){
  window._tdPaying=false;
  if(!btn)return;
  btn.innerHTML=btn.dataset.tdOrigHtml||'Start My Test Drive →';
  btn.disabled=false;btn.style.opacity='';btn.style.cursor='pointer';btn.style.pointerEvents='';
}
async function checkoutAll(){
if(orderList.length===0){showToast('Add at least one blind to your test drive first.',true);return;}
// TD: the button in the order section just takes the customer to Step 2 (details + card)
var _tdEv=window.event;var _tdFromPanel=!!(_tdEv&&_tdEv.target&&_tdEv.target.closest&&_tdEv.target.closest('#td-checkout-panel'));
if(!_tdFromPanel){var _tdP=document.getElementById('td-checkout-panel');if(_tdP){_tdP.style.display='block';_tdP.scrollIntoView({behavior:'smooth',block:'start'});}return;}
// Validate required fields
var nameVal=document.getElementById('td-name').value.trim();
var emailVal=document.getElementById('td-email').value.trim();
var phoneVal=document.getElementById('td-phone').value.trim();
var addrVal=document.getElementById('td-address').value.trim();
var billZipVal=document.getElementById('td-bill-zip').value.trim();
var shipZipVal=document.getElementById('td-ship-zip').value.trim();
if(!nameVal||!emailVal||!phoneVal||!addrVal||!billZipVal||!shipZipVal){showToast('Please fill in all required fields.',true);document.getElementById('td-checkout-panel').scrollIntoView({behavior:'smooth',block:'start'});return;}
if(billZipVal!==shipZipVal){showToast('Billing ZIP must match shipping ZIP to qualify for the test drive.',true);return;}
var terms=document.getElementById('td-terms-check');
if(!terms||!terms.checked){showToast('Please agree to the Test Drive terms to continue.',true);var _tl=terms?terms.closest('label'):null;if(_tl){_tl.scrollIntoView({behavior:'smooth',block:'center'});var _tb=_tl.parentElement;if(_tb){_tb.style.transition='box-shadow .3s';_tb.style.boxShadow='0 0 0 3px #C9A84C';setTimeout(function(){_tb.style.boxShadow='';},2200);}}return;}
if(window._tdPaying)return;window._tdPaying=true;
var btn=(_tdEv&&_tdEv.target&&_tdEv.target.closest&&_tdEv.target.closest('button'))||document.getElementById('btn-checkout-all');tdBtnBusy(btn,'Setting up your test drive…');
try{
var tdTotal=orderList.reduce(function(s,w){return s+(w.customerPrice||0)+(w.shippingAmt||0);},0);
var deposit=Math.round(tdTotal*TD_DEPOSIT_RATE*100)/100;
// Create Stripe Payment Intent via worker
var TD_WORKER='https://lmg-test-drive.ericcnavarro.workers.dev';
var resp=await fetch(TD_WORKER,{method:'POST',headers:{'Content-Type':'application/json','X-Worker-Secret':window.__lmgCfg.s},body:JSON.stringify({type:'testDriveDeposit',name:nameVal,email:emailVal,phone:phoneVal,address:addrVal,billZip:billZipVal,shipZip:shipZipVal,orderList:orderList,totalAmount:tdTotal,depositAmount:deposit,utmSource:new URLSearchParams(window.location.search).get('utm_source')||'direct',utmCampaign:new URLSearchParams(window.location.search).get('utm_campaign')||'',testKey:new URLSearchParams(window.location.search).get('tdtest')||'',consent:tdBuildConsent()})});
if(!resp.ok){var err=await resp.json();throw new Error(err.error||'Setup error');}
var res=await resp.json();
if(!res.clientSecret)throw new Error('No payment intent returned');
if(res.test&&res.depositAmount){deposit=res.depositAmount;}
// Confirm card payment with Stripe.js
var cardEl=document.getElementById('td-stripe-card-element');
if(!window._tdStripeCard){showToast('Card field not loaded. Please refresh and try again.',true);tdBtnReset(btn);return;}
tdBtnBusy(btn,'Processing payment — please don\'t close this page…');
var confirmResult=await STRIPE_OBJ.confirmCardPayment(res.clientSecret,{payment_method:{card:window._tdStripeCard,billing_details:{name:nameVal,email:emailVal,phone:phoneVal,address:{postal_code:billZipVal,country:'US'}}}});
if(confirmResult.error){showToast(confirmResult.error.message||'Payment failed. Please try again.',true);tdBtnReset(btn);return;}
// Verify with test drive worker (saves card for day-7, blocks prepaid)
tdBtnBusy(btn,'Confirming your test drive…');
var vResp=null,vRes={};
try{vResp=await fetch(TD_WORKER,{method:'POST',headers:{'Content-Type':'application/json','X-Worker-Secret':window.__lmgCfg.s},body:JSON.stringify({type:'testDriveConfirm',trialId:res.trialId})});vRes=await vResp.json();}catch(e){}
if(vResp&&(vResp.status===402||vResp.status===409)){showToast(vRes.error||'Your card could not be used for the test drive.',true);tdBtnReset(btn);return;}
// Other verify errors: payment already succeeded; worker's safety net will activate the trial
// Success
window._tdPaying=false;
try{localStorage.removeItem('lmg_td_order');}catch(e){}
document.getElementById('td-checkout-panel').style.display='none';
document.getElementById('td-success-panel').style.display='block';
document.getElementById('td-success-amount').textContent='$'+deposit.toFixed(2);
document.getElementById('td-success-email').textContent=emailVal;
document.getElementById('td-success-panel').scrollIntoView({behavior:'smooth',block:'start'});
}catch(err){showToast('Something went wrong: '+(err.message||'Please try again or contact support@lmgblinds.com'),true);tdBtnReset(btn);}
}
// ── RESET CONFIGURATOR ──
function resetConfigurator() {
state.room = null; state.mount = null; state.width = null; state.height = null;
state.lift = null; state.liftPrice = 0; state.color = null; state.colorCode = null; state.colorDesc = null;
state.light = null; state.motor = 'None'; state.motorPrice = 0; state.motorSide = null;
document.querySelectorAll('[data-motor-side]').forEach(c => { c.classList.remove('selected'); c.style.cssText = ''; });
state.hub = false; state.hubPrice = 0; state.solar = false; state.solarPrice = 0;
state.hookwand = false; state.hookwandPrice = 0; state.remoteChannel = null; state.extraCable = false;
state.sideChannel = false; state.sideChannelPrice = 0; state.sideChannelColor = null;
state.chain='plastic';state.chainUpgrade=false;state.chainColor=null;
state.dualColorLF=null;state.dualColorCodeLF=null;state.dualColorDescLF=null;
state.dualColorBO=null;state.dualColorCodeBO=null;state.dualColorDescBO=null;
state._dualSlot='lf';state.dualCombo='roller-roller';currentDualLFIdx=0;currentDualBOIdx=0;
var dcn=document.getElementById('dual-cassette-note');if(dcn)dcn.style.display='none';
var brs=document.getElementById('bottom-rail-section');if(brs)brs.style.display='none';
document.querySelectorAll('[data-combo]').forEach(function(c,i){c.classList.toggle('selected',i===0);});
document.querySelectorAll('#chain-btns .accessory-select-btn,#chain-color-btns .accessory-select-btn').forEach(function(b){b.classList.remove('selected');b.style.cssText='';});
var _pb=document.querySelector('#chain-btns [data-chain="plastic"]');
if(_pb){_pb.classList.add('selected');_pb.style.cssText='background:#C9A84C !important;border-color:#C9A84C !important;color:#1A1A1A !important;font-weight:700 !important;';}
var _cl=document.getElementById('acc-chain-label');if(_cl)_cl.innerHTML='<span style="color:#2E7D32;font-size:16px;font-weight:500">Included</span>';
var _cw=document.getElementById('acc-chain-color-wrap');if(_cw)_cw.style.display='block';
state.bottomRail = null; state.bottomRailType = null; state.bottomRailColor = null;
state.cassetteType = null; state.cassetteShape = null; state.cassetteColor = null;
state.windowName = null; state.product = null; state.fabricCostPerSqFt = 1.99;
state.printFile = null; state.printFileName = null; state.printNotes = null;
currentSelectedBandWidth = null; currentSeriesIndex = 0;
['acc-hub-check','acc-solar-check','acc-cable-check','acc-hookwand-check','acc-sidechannel-check'].forEach(id => { const el = document.getElementById(id); if (el) el.classList.remove('checked'); });
document.querySelectorAll('#remote-channels .accessory-select-btn').forEach(b => { b.classList.remove('selected'); b.style.cssText = ''; });
document.querySelectorAll('#sidechannel-colors .accessory-select-btn').forEach(b => { b.classList.remove('selected'); b.style.cssText = ''; });
const scLabel = document.getElementById('acc-sidechannel-label'); if (scLabel) scLabel.textContent = 'Add side channels';
const scPrice = document.getElementById('acc-sidechannel-price'); if (scPrice) scPrice.textContent = '—';
const nameInput = document.getElementById('window-name-input'); nameInput.value = ''; nameInput.dataset.autoFilled = 'false';
document.getElementById('window-name-wrap').classList.remove('visible');
document.querySelectorAll('.room-card, .mount-card, .product-type-card').forEach(el => el.classList.remove('selected'));
document.querySelectorAll('.light-card').forEach(el => el.classList.remove('selected'));
document.querySelectorAll('.motor-option').forEach(o => o.classList.remove('selected'));
document.querySelector('.motor-option[data-motor="None"]').classList.add('selected');
document.getElementById('width-input').value = ''; document.getElementById('height-input').value = '';
document.getElementById('width-fraction').value = '0'; document.getElementById('height-fraction').value = '0';
document.getElementById('sqft-display').style.display = 'none';
document.getElementById('print-upload-wrap').classList.remove('has-file');
document.getElementById('print-preview').style.display = 'none';
document.getElementById('print-file-input').value = ''; document.getElementById('print-notes-input').value = '';
['sum-room','sum-mount','sum-lift','sum-color','sum-light','sum-product'].forEach(id => { const el = document.getElementById(id); el.textContent = 'Not selected'; el.classList.add('empty'); });
document.getElementById('sum-width').textContent = '—'; document.getElementById('sum-width').classList.add('empty');
document.getElementById('sum-height').textContent = '—'; document.getElementById('sum-height').classList.add('empty');
document.getElementById('sum-motor').textContent = 'None';
document.getElementById('summary-product-title').textContent = 'Select a Product';
document.getElementById('price-display').style.display = 'none';
const rpCta = document.getElementById('room-preview-cta'); if (rpCta) rpCta.style.display = 'none';
}

// Dual Roller ChatGPT CTA
function lmgBuildRoomPromptDual() {
  if (typeof state === 'undefined' || !state.dualColorCodeLF || !state.dualColorCodeBO) return '';
  let p = 'Can you show me what these Dual Roller Shades would look like on my window? I am shopping for Dual Roller Shades from LMG Blinds.';
  p += ' Front (Light Filtering) fabric: ' + state.dualColorCodeLF + ' - ' + (state.dualColorLF || '') + (state.dualColorDescLF ? ' (' + state.dualColorDescLF + ')' : '') + '.';
  p += ' Back (Blackout) fabric: ' + state.dualColorCodeBO + ' - ' + (state.dualColorBO || '') + (state.dualColorDescBO ? ' (' + state.dualColorDescBO + ')' : '') + '.';
  p += ' I am attaching a photo of my room - please render my window with these dual roller shades installed, keeping the rest of the room exactly the same.';
  return p;
}
function lmgUpdateDualCta() {
  const cta = document.getElementById('room-preview-cta-dual');
  if (!cta) return;
  if (state.product === 'Dual Roller' && state.dualColorCodeLF && state.dualColorCodeBO) {
    const el = document.getElementById('room-preview-prompt-dual');
    if (el) el.textContent = lmgBuildRoomPromptDual();
    cta.style.display = 'block';
  } else {
    cta.style.display = 'none';
  }
}
function lmgCopyRoomPromptDual() {
  const text = lmgBuildRoomPromptDual(); if (!text) return;
  const done = function() {
    const note = document.getElementById('room-prompt-copied-dual'); if (note) note.style.display = 'block';
    const btn = document.getElementById('btn-copy-room-prompt-dual');
    if (btn) { btn.textContent = 'Copied!'; setTimeout(function(){ btn.textContent = 'Copy Prompt'; }, 2500); }
  };
  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(text).then(done).catch(function(){ const ta=document.createElement('textarea');ta.value=text;ta.style.cssText='position:fixed;opacity:0;';document.body.appendChild(ta);ta.select();try{document.execCommand('copy');}catch(e){}document.body.removeChild(ta);done(); });
  } else { const ta=document.createElement('textarea');ta.value=text;ta.style.cssText='position:fixed;opacity:0;';document.body.appendChild(ta);ta.select();try{document.execCommand('copy');}catch(e){}document.body.removeChild(ta);done(); }
}
function lmgOpenChatGPTDual() {
  const text = lmgBuildRoomPromptDual();
  if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(text).catch(function(){}); }
  const note = document.getElementById('room-prompt-copied-dual');
  if (note) { note.textContent = 'Prompt copied - paste into ChatGPT with a photo of your window'; note.style.display = 'block'; }
  window.open('https://chatgpt.com/?q=' + encodeURIComponent(text), '_blank');
}
setInterval(function() { if (typeof state !== 'undefined') lmgUpdateDualCta(); }, 800);

document.querySelectorAll('.progress-step').forEach(step => { step.addEventListener('click', () => { const n = parseInt(step.dataset.step); if (n < state.step) goToStep(n); }); });
document.addEventListener('keydown', (e) => {
const lb = document.getElementById('lightbox-overlay');
if (!lb.classList.contains('open')) return;
if (e.key === 'Escape') closeLightbox(); if (e.key === 'ArrowLeft') lightboxNav(-1); if (e.key === 'ArrowRight') lightboxNav(1); if (e.key === 'Enter') selectColorFromLightbox();
});

// ── STEP 6: BOOKING ──
let bookingState = { service: null, time: null };
(function() {
const d = document.getElementById('booking-date'); if (!d) return;
function todayStr() {
const t = new Date();
return t.getFullYear() + '-' + String(t.getMonth() + 1).padStart(2, '0') + '-' + String(t.getDate()).padStart(2, '0');
}
d.min = todayStr();
d.addEventListener('input', function() {
if (d.value && d.value < todayStr()) { d.value = ''; }
});
})();
document.querySelectorAll('.booking-service-card').forEach(card => { card.addEventListener('click', () => { document.querySelectorAll('.booking-service-card').forEach(c => c.classList.remove('selected')); card.classList.add('selected'); bookingState.service = card.dataset.service; validateBookingForm(); }); });
document.querySelectorAll('.booking-time-btn').forEach(btn => { btn.addEventListener('click', () => { document.querySelectorAll('.booking-time-btn').forEach(b => b.classList.remove('selected')); btn.classList.add('selected'); bookingState.time = btn.dataset.time; validateBookingForm(); }); });
['booking-name', 'booking-phone', 'booking-address', 'booking-date'].forEach(id => { document.getElementById(id).addEventListener('input', validateBookingForm); });
document.getElementById('booking-jobtype').addEventListener('change', function() {
const isCustom = this.value === 'Custom / Hybrid Mix';
document.getElementById('booking-jobtype-custom').style.display = isCustom ? 'block' : 'none';
validateBookingForm();
});
document.getElementById('booking-jobtype-custom').addEventListener('input', validateBookingForm);
function validateBookingForm() {
const name = document.getElementById('booking-name').value.trim();
const phone = document.getElementById('booking-phone').value.trim();
const address = document.getElementById('booking-address').value.trim();
const date = document.getElementById('booking-date').value;
const t = new Date(); const todayStr = t.getFullYear() + '-' + String(t.getMonth() + 1).padStart(2, '0') + '-' + String(t.getDate()).padStart(2, '0');
const dateOk = date && date >= todayStr;
const jobtype = document.getElementById('booking-jobtype').value;
document.getElementById('btn-submit-booking').disabled = !(bookingState.service && bookingState.time && jobtype && name && phone && address && dateOk);
}
async function submitBooking() {
const btn = document.getElementById('btn-submit-booking'); btn.textContent = 'Sending…'; btn.disabled = true;
let jobType = document.getElementById('booking-jobtype').value;
const jobCustom = document.getElementById('booking-jobtype-custom').value.trim();
if (jobType === 'Custom / Hybrid Mix' && jobCustom) jobType = 'Custom / Hybrid Mix: ' + jobCustom;
const bookingData = { type: 'booking', service: bookingState.service, jobType: jobType, date: document.getElementById('booking-date').value, time: bookingState.time, name: document.getElementById('booking-name').value.trim(), phone: document.getElementById('booking-phone').value.trim(), address: document.getElementById('booking-address').value.trim(), orderSummary: orderList.map(w => w.label + ' — ' + w.product + ' ' + formatDim(w.width) + '\xd7' + formatDim(w.height)).join(', ') };
try {
const response = await fetch('https://lmg-draft-order.ericcnavarro.workers.dev', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Worker-Secret': window.__lmgCfg.s }, body: JSON.stringify(bookingData) });
if (!response.ok) throw new Error('Worker error');
document.getElementById('booking-form-wrap').style.display = 'none'; document.getElementById('booking-success').classList.add('show');
document.querySelector('.configurator-wrap').scrollIntoView({ behavior: 'smooth', block: 'start' });
} catch (err) {  alert('Something went wrong. Please call us directly.'); btn.textContent = 'Request Appointment →'; btn.disabled = false; }
}
function skipBookingAndCheckout() { checkoutAll(); }
function proceedAfterBooking() { document.getElementById('order-list-section').scrollIntoView({ behavior: 'smooth', block: 'start' }); setTimeout(() => checkoutAll(), 600); }
function goToBooking() { window.open('/pages/schedule-an-appointment', '_top'); }

// ── MOTOR SIDE ──
function selectMotorSide(card) {
document.querySelectorAll('[data-motor-side]').forEach(c => { c.classList.remove('selected'); c.style.cssText = ''; if (c.querySelector('.option-card-label')) c.querySelector('.option-card-label').style.color = ''; });
card.classList.add('selected'); card.style.cssText = 'background:#C9A84C !important; border-color:#C9A84C !important;'; card.querySelector('.option-card-label').style.color = '#1A1A1A';
state.motorSide = card.dataset.motorSide;
}
function updateMotorSideVisibility() {
const sec = document.getElementById('motor-side-section'); if (!sec) return;
const show = state.motor && state.motor !== 'None';
sec.style.display = show ? 'block' : 'none';
if (!show) {
state.motorSide = null;
document.querySelectorAll('[data-motor-side]').forEach(c => { c.classList.remove('selected'); c.style.cssText = ''; if (c.querySelector('.option-card-label')) c.querySelector('.option-card-label').style.color = ''; });
} else if (state.motorSide) {
document.querySelectorAll('[data-motor-side]').forEach(c => { if (c.dataset.motorSide === state.motorSide) { c.classList.add('selected'); c.style.cssText = 'background:#C9A84C !important; border-color:#C9A84C !important;'; c.querySelector('.option-card-label').style.color = '#1A1A1A'; } });
}
}

// ── ACCESSORIES ──
function toggleAccessory(key) {
const check = document.getElementById('acc-' + key + '-check');
if (key === 'hub') { state.hub = !state.hub; state.hubPrice = state.hub ? 150 : 0; check.classList.toggle('checked', state.hub); }
else if (key === 'solar') { state.solar = !state.solar; state.solarPrice = state.solar ? 65 : 0; check.classList.toggle('checked', state.solar); }
else if (key === 'cable') { state.extraCable = !state.extraCable; check.classList.toggle('checked', state.extraCable); }
else if (key === 'hookwand') { state.hookwand = !state.hookwand; state.hookwandPrice = state.hookwand ? 15 : 0; check.classList.toggle('checked', state.hookwand); }
else if (key === 'sidechannel') { state.sideChannel = !state.sideChannel; check.classList.toggle('checked', state.sideChannel); updateSideChannelPrice(); }
else if (key === 'bottomchannel') { state.bottomChannel = !state.bottomChannel; check.classList.toggle('checked', state.bottomChannel); if (!state.bottomChannel) { state.bottomChannelColor = null; document.querySelectorAll('[data-bottomchannel-color]').forEach(b => { b.classList.remove('selected'); b.style.cssText = ''; }); const grid = document.getElementById('bottomchannel-color-grid'); if (grid) grid.style.display = 'none'; } else { const grid = document.getElementById('bottomchannel-color-grid'); if (grid) grid.style.display = 'flex'; } updateBottomChannelPrice(); }
updatePrice();
}
function selectChannel(btn) {
const wasSelected = state.remoteChannel === btn.dataset.channel;
document.querySelectorAll('#remote-channels .accessory-select-btn').forEach(b => { b.classList.remove('selected'); b.style.cssText = ''; });
if (wasSelected) { state.remoteChannel = null; return; }
btn.classList.add('selected'); btn.style.cssText = 'background:#C9A84C !important; border-color:#C9A84C !important; color:#1A1A1A !important; font-weight:700 !important; box-shadow:0 0 0 1px #C9A84C !important;';
state.remoteChannel = btn.dataset.channel;
}
function selectSideChannelColor(btn) {
const wasSelected = state.sideChannelColor === btn.dataset.scColor;
document.querySelectorAll('#sidechannel-colors .accessory-select-btn').forEach(b => { b.classList.remove('selected'); b.style.cssText = ''; });
if (wasSelected) { state.sideChannelColor = null; return; }
btn.classList.add('selected'); btn.style.cssText = 'background:#C9A84C !important; border-color:#C9A84C !important; color:#1A1A1A !important; font-weight:700 !important; box-shadow:0 0 0 1px #C9A84C !important;';
state.sideChannelColor = btn.dataset.scColor;
}
function updateSideChannelPrice() {
const priceEl = document.getElementById('acc-sidechannel-price');
const labelEl = document.getElementById('acc-sidechannel-label');
if (!priceEl) return;
if (!state.height) { priceEl.textContent = '—'; if (labelEl) labelEl.textContent = 'Add side channels'; return; }
const heightM = state.height * 0.0254;
const customer = 50.40 * heightM;
priceEl.textContent = '$' + customer.toFixed(2);
if (labelEl) labelEl.textContent = 'Add side channels — $' + customer.toFixed(2);
}
function updateSideChannelVisibility() {
const item = document.getElementById('acc-sidechannel-item'); if (!item) return;
const scProducts = ['Roller Shades', 'Print Blinds', 'Dual Roller'];
// Honeycomb: only 38mm cell size can have side channels
let show = scProducts.includes(state.product);
if (state.product === 'Honeycomb') {
  const cell = getHoneycombCellSize();
  show = cell && cell.indexOf('38mm') !== -1;
}
item.style.display = show ? 'flex' : 'none';
if (!show) { state.sideChannel = false; state.sideChannelColor = null; const check = document.getElementById('acc-sidechannel-check'); if (check) check.classList.remove('checked'); document.querySelectorAll('#sidechannel-colors .accessory-select-btn').forEach(b => { b.classList.remove('selected'); b.style.cssText = ''; }); }
else { updateSideChannelPrice(); }
var dualNote = document.getElementById('acc-sidechannel-dual-note');
if (dualNote) dualNote.style.display = (state.product === 'Dual Roller') ? 'block' : 'none';
}

// ── BOTTOM CHANNEL ACCESSORY ──
function updateBottomChannelVisibility() {
const item = document.getElementById('acc-bottomchannel-item'); if (!item) return;
const bcProducts = ['Roller Shades', 'Print Blinds', 'Dual Roller', 'Honeycomb'];
// Honeycomb: only 38mm cell size can have bottom channels (mirrors the side channel rule)
let show = bcProducts.includes(state.product);
if (state.product === 'Honeycomb') {
  const cell = getHoneycombCellSize();
  show = cell && cell.indexOf('38mm') !== -1;
}
item.style.display = show ? 'flex' : 'none';
if (!show) { state.bottomChannel = false; state.bottomChannelColor = null; const check = document.getElementById('acc-bottomchannel-check'); if (check) check.classList.remove('checked'); document.querySelectorAll('[data-bottomchannel-color]').forEach(b => { b.classList.remove('selected'); b.style.cssText = ''; }); const grid = document.getElementById('bottomchannel-color-grid'); if (grid) grid.style.display = 'none'; }
updateBottomChannelPrice();
}
function updateBottomChannelPrice() {
const priceEl = document.getElementById('acc-bottomchannel-price');
if (!priceEl) return;
if (!state.width) { priceEl.textContent = '—'; return; }
const customer = 1.28 * state.width;
priceEl.textContent = '$' + customer.toFixed(2);
}
function toggleBottomChannel() {
if (!state.bottomChannel) {
state.bottomChannel = true;
const check = document.getElementById('acc-bottomchannel-check');
if (check) check.classList.add('checked');
const grid = document.getElementById('bottomchannel-color-grid');
if (grid) grid.style.display = 'flex';
} else {
state.bottomChannel = false; state.bottomChannelColor = null;
const check = document.getElementById('acc-bottomchannel-check');
if (check) check.classList.remove('checked');
document.querySelectorAll('[data-bottomchannel-color]').forEach(b => { b.classList.remove('selected'); b.style.cssText = ''; });
}
updatePrice();
}
function selectBottomChannel(btn) {
document.querySelectorAll('[data-bottomchannel-color]').forEach(b => { b.classList.remove('selected'); b.style.cssText = ''; });
btn.classList.add('selected');
btn.style.cssText = 'background:var(--gold);color:#fff;border-color:var(--gold);';
state.bottomChannelColor = btn.dataset.bottomchannelColor;
state.bottomChannel = true;
const check = document.getElementById('acc-bottomchannel-check');
if (check) check.classList.add('checked');
updatePrice();
}

// ── CHAIN TYPE ACCESSORY (PATCH 5b) ──
function updateChainVisibility() {
var item = document.getElementById('acc-chain-item');
if (!item) return;
var manualLifts = ['Manual Corded', 'Manual Chain', 'Corded', 'Top Down Bottom Up - Corded'];
var show = state.lift && manualLifts.indexOf(state.lift) !== -1;
item.style.display = show ? 'flex' : 'none';
if (!show) { state.chain = 'plastic'; state.chainUpgrade = false; state.chainColor = null; }
}
function selectChainType(btn) {
document.querySelectorAll('#chain-btns .accessory-select-btn').forEach(function(b) { b.classList.remove('selected'); b.style.cssText = ''; });
btn.classList.add('selected'); btn.style.cssText = 'background:#C9A84C !important;border-color:#C9A84C !important;color:#1A1A1A !important;font-weight:700 !important;';
state.chain = btn.dataset.chain; state.chainUpgrade = btn.dataset.chain === 'stainless';
var colorWrap = document.getElementById('acc-chain-color-wrap');
var chainLabel = document.getElementById('acc-chain-label');
if (state.chainUpgrade) {
if (colorWrap) colorWrap.style.display = 'none';
var sqm = (state.width && state.height) ? (state.width * state.height / 144) * .092903 : 0;
var listed = (1.5 * sqm * markupFor(state.product)).toFixed(2);
if (chainLabel) chainLabel.innerHTML = '<span style="font-size:10px;color:var(--ink-muted);text-decoration:line-through;display:block">$' + listed + '</span><span style="color:var(--gold);font-size:16px;font-weight:500">Free Upgrade</span>';
state.chainColor = null;
document.querySelectorAll('#chain-color-btns .accessory-select-btn').forEach(function(b) { b.classList.remove('selected'); b.style.cssText = ''; });
} else {
if (colorWrap) colorWrap.style.display = 'block';
if (chainLabel) chainLabel.innerHTML = '<span style="color:#2E7D32;font-size:16px;font-weight:500">Included</span>';
}
}
function selectChainColor(btn) {
document.querySelectorAll('#chain-color-btns .accessory-select-btn').forEach(function(b) { b.classList.remove('selected'); b.style.cssText = ''; });
btn.classList.add('selected'); btn.style.cssText = 'background:#C9A84C !important;border-color:#C9A84C !important;color:#1A1A1A !important;font-weight:700 !important;';
state.chainColor = btn.dataset.chainColor;
}

// ── SIDE CHANNEL FUNCTIONS (P10 applied) ──

// ── RAIL & CASSETTE ──
const RAIL_COLORS_FULL = ['White', 'Beige', 'Grey', 'Brown', 'Black'];
const RAIL_COLORS_SHANGRILA = ['White', 'Beige', 'Grey'];
const ROUND_CASSETTE_MAX_W = 90.5; const ROUND_CASSETTE_MAX_H = 70.8;

function getRailShapes(product, material) {
if (product === 'Zebra Shades') return material === 'Fabric Covered' ? ['Square', 'Oval'] : ['Square', 'Oval', 'Flat'];
if (['Roller Shades', 'Butterfly Shades', 'Print Blinds', 'Roman Shades'].includes(product)) return material === 'Fabric Covered' ? ['Square'] : ['Square', 'Oval', 'Flat'];
return ['Square', 'Oval', 'Flat'];
}

function selectRailMaterial(card) {
document.querySelectorAll('[data-rail-material]').forEach(c => { c.classList.remove('selected'); c.style.cssText = ''; if (c.querySelector('.option-card-label')) c.querySelector('.option-card-label').style.color = ''; });
card.classList.add('selected'); card.style.cssText = 'background:#C9A84C !important; border-color:#C9A84C !important;'; card.querySelector('.option-card-label').style.color = '#1A1A1A';
state.bottomRail = card.dataset.railMaterial; state.bottomRailType = null; state.bottomRailColor = null;
document.querySelectorAll('[data-rail-color]').forEach(c => { c.classList.remove('selected'); c.style.cssText = ''; const lbl = c.querySelector('.option-card-label'); if (lbl) lbl.style.color = ''; });
const isFabric = state.bottomRail === 'Fabric Covered'; const product = state.product;
const shapes = getRailShapes(product, state.bottomRail);
const shapeGrid = document.getElementById('rail-shape-grid');
shapeGrid.innerHTML = shapes.map(s => '<div class="option-card" data-rail-shape="' + s + '" onclick="selectRailShape(this)"><span class="option-card-icon">' + (s === 'Square' ? '⬜' : s === 'Oval' ? '⭕' : '▬') + '</span><div class="option-card-label">' + s + '</div><div class="option-card-price">Free</div></div>').join('');
document.getElementById('rail-shape-section').style.display = 'block';
document.getElementById('rail-color-section').style.display = 'none';
document.getElementById('rail-fabric-note').style.display = isFabric ? 'block' : 'none';
updateHookWandVisibility();
if(state.product==='Dual Roller'){var _rfc=document.getElementById('rail-fabric-option');if(_rfc)_rfc.style.display='none';document.querySelectorAll('#rail-shape-grid [data-rail-shape]').forEach(function(c){if(c.dataset.railShape!=='Square')c.style.display='none';});}
checkStep4();
}

function selectRailShape(card) {
document.querySelectorAll('[data-rail-shape]').forEach(c => { c.classList.remove('selected'); c.style.cssText = ''; if (c.querySelector('.option-card-label')) c.querySelector('.option-card-label').style.color = ''; });
card.classList.add('selected'); card.style.cssText = 'background:#C9A84C !important; border-color:#C9A84C !important;'; card.querySelector('.option-card-label').style.color = '#1A1A1A';
state.bottomRailType = card.dataset.railShape; state.bottomRailColor = null;
document.querySelectorAll('[data-rail-color]').forEach(c => { c.classList.remove('selected'); c.style.cssText = ''; const lbl = c.querySelector('.option-card-label'); if (lbl) lbl.style.color = ''; });
const isShangrila = state.product === 'Triple/Shangri-La';
const colors = isShangrila ? RAIL_COLORS_SHANGRILA : RAIL_COLORS_FULL;
document.querySelectorAll('[data-rail-color]').forEach(el => { el.style.display = colors.includes(el.dataset.railColor) ? '' : 'none'; });
document.getElementById('rail-color-section').style.display = 'block';
if(state.product==='Dual Roller'){document.querySelectorAll('#rail-shape-grid [data-rail-shape]').forEach(function(c){if(c.dataset.railShape!=='Square')c.style.display='none';});document.querySelectorAll('#rail-color-grid [data-rail-color]').forEach(function(c){if(!['White','Grey','Black'].includes(c.dataset.railColor))c.style.display='none';});}
checkStep4();
}

function selectRailColor(card) {
document.querySelectorAll('[data-rail-color]').forEach(c => { c.classList.remove('selected'); c.style.cssText = ''; if (c.querySelector('.option-card-label')) c.querySelector('.option-card-label').style.color = ''; });
card.classList.add('selected'); card.style.cssText = 'background:#C9A84C !important; border-color:#C9A84C !important;'; card.querySelector('.option-card-label').style.color = '#1A1A1A';
state.bottomRailColor = card.dataset.railColor;
if(state.product==='Dual Roller'){document.querySelectorAll('#rail-color-grid [data-rail-color]').forEach(function(c){if(!['White','Grey','Black'].includes(c.dataset.railColor))c.style.display='none';});}
checkStep4();
}

function selectCassette(card) {
document.querySelectorAll('[data-cassette]').forEach(c => { c.classList.remove('selected'); c.style.cssText = ''; if (c.querySelector('.option-card-label')) c.querySelector('.option-card-label').style.color = ''; });
card.classList.add('selected'); card.style.cssText = 'background:#C9A84C !important; border-color:#C9A84C !important;'; card.querySelector('.option-card-label').style.color = '#1A1A1A';
state.cassetteType = card.dataset.cassette; state.cassetteShape = null; state.cassetteColor = null;
document.querySelectorAll('[data-shape], [data-cassette-color]').forEach(c => { c.classList.remove('selected'); c.style.cssText = ''; const lbl = c.querySelector('.option-card-label'); if (lbl) lbl.style.color = ''; });
const isNone = state.cassetteType === 'No Cassette'; const isFabric = state.cassetteType === 'Fabric Covered Cassette'; const isShangrila = state.product === 'Triple/Shangri-La';
document.getElementById('cassette-shape-section').style.display = isNone ? 'none' : 'block';
document.getElementById('cassette-color-section').style.display = 'none';
document.getElementById('cassette-fabric-note').style.display = 'none';
document.getElementById('cassette-shangrila-note').style.display = 'none';
const largeNoteEl = document.getElementById('cassette-large-note'); if (largeNoteEl) largeNoteEl.style.display = 'none';
if (!isNone && isFabric) { if (isShangrila) document.getElementById('cassette-shangrila-note').style.display = 'block'; else document.getElementById('cassette-fabric-note').style.display = 'block'; }
if(state.product==='Dual Roller'){var _nc=document.getElementById('cassette-none');if(_nc)_nc.style.display='none';var _fc=document.getElementById('cassette-fabric-option');if(_fc)_fc.style.display='none';document.querySelectorAll('#cassette-shape-grid [data-shape]').forEach(function(c){if(c.dataset.shape!=='Square')c.style.display='none';});}
checkStep4();
}

function selectShape(card) {
document.querySelectorAll('[data-shape]').forEach(c => { c.classList.remove('selected'); c.style.cssText = ''; if (c.querySelector('.option-card-label')) c.querySelector('.option-card-label').style.color = ''; });
card.classList.add('selected'); card.style.cssText = 'background:#C9A84C !important; border-color:#C9A84C !important;'; card.querySelector('.option-card-label').style.color = '#1A1A1A';
state.cassetteShape = card.dataset.shape; state.cassetteColor = null;
document.querySelectorAll('[data-cassette-color]').forEach(c => { c.classList.remove('selected'); c.style.cssText = ''; const lbl = c.querySelector('.option-card-label'); if (lbl) lbl.style.color = ''; });
const isLargeRound = state.cassetteShape === 'Round' && ((state.width || 0) > ROUND_CASSETTE_MAX_W);
const largeNote = document.getElementById('cassette-large-note'); if (largeNote) largeNote.style.display = isLargeRound ? 'block' : 'none';
const colors = isLargeRound ? ['White'] : RAIL_COLORS_FULL;
document.querySelectorAll('[data-cassette-color]').forEach(el => { el.style.display = colors.includes(el.dataset.cassetteColor) ? '' : 'none'; });
document.getElementById('cassette-color-section').style.display = 'block';
if(state.product==='Dual Roller'){document.querySelectorAll('#cassette-shape-grid [data-shape]').forEach(function(c){if(c.dataset.shape!=='Square')c.style.display='none';});document.querySelectorAll('#cassette-color-grid [data-cassette-color]').forEach(function(c){if(!['White','Grey','Black'].includes(c.dataset.cassetteColor))c.style.display='none';});}
checkStep4();
}

function selectCassetteColor(card) {
const isLargeRound = state.cassetteShape === 'Round' && ((state.width || 0) > ROUND_CASSETTE_MAX_W);
document.querySelectorAll('[data-cassette-color]').forEach(c => {
c.classList.remove('selected');
const color = c.dataset.cassetteColor;
if (isLargeRound) { c.style.display = color === 'White' ? '' : 'none'; } else { c.style.display = ''; }
c.style.background = ''; c.style.border = '';
if (c.querySelector('.option-card-label')) c.querySelector('.option-card-label').style.color = '';
});
card.classList.add('selected'); card.style.cssText = 'background:#C9A84C !important; border-color:#C9A84C !important;'; card.querySelector('.option-card-label').style.color = '#1A1A1A';
state.cassetteColor = card.dataset.cassetteColor;
if(state.product==='Dual Roller'){
state.bottomRailColor = card.dataset.cassetteColor;
document.querySelectorAll('#cassette-color-grid [data-cassette-color]').forEach(function(c){if(!['White','Grey','Black'].includes(c.dataset.cassetteColor))c.style.display='none';});
var _sl=document.getElementById('sum-light');if(_sl){_sl.textContent='Cassette & Rail: '+card.dataset.cassetteColor;_sl.classList.remove('empty');}
}
checkStep4();
}

function updateHookWandVisibility() {
const hookwandItem = document.getElementById('acc-hookwand-item'); if (!hookwandItem) return;
const isCordless = state.lift && state.lift.toLowerCase().includes('cordless');
const hasRailOption = ['Zebra Shades', 'Roller Shades'].includes(state.product);
const hasFabricRail = state.bottomRail === 'Fabric Covered';
const show = isCordless && hasRailOption && hasFabricRail;
hookwandItem.style.display = show ? 'flex' : 'none';
if (!show) { state.hookwand = false; state.hookwandPrice = 0; const check = document.getElementById('acc-hookwand-check'); if (check) check.classList.remove('checked'); }
}

function renderStep4ForProduct() {
const isPrint = state.product === 'Print Blinds'; const product = state.product;
const isDualRoller = product === 'Dual Roller';
document.getElementById('light-control-section').style.display=(isPrint||isDualRoller)?'none':'block';
document.getElementById('color-section').style.display=(isPrint||isDualRoller)?'none':'block';
document.getElementById('print-upload-section').style.display=isPrint?'block':'none';
document.getElementById('dual-roller-section').style.display=isDualRoller?'block':'none';
if(isDualRoller){
var _sumLightEl=document.getElementById('sum-light');if(_sumLightEl&&(state.cassetteColor)){_sumLightEl.textContent='Cassette & Rail: '+state.cassetteColor;_sumLightEl.classList.remove('empty');}
currentDualLFIdx=0;currentDualBOIdx=0;
state.dualCombo='roller-roller';
document.querySelectorAll('[data-combo]').forEach(function(c,i){c.classList.toggle('selected',i===0);});
renderDualRollerFabrics();
document.getElementById('cassette-honeycomb-section').style.display='none';
// ── CASSETTE: Metal → Square → White/Grey/Black ──
document.getElementById('cassette-type-section').style.display='block';
document.getElementById('cassette-type-grid').style.display='';
var _mc=document.querySelector('[data-cassette="Metal Cassette"]');
if(_mc)selectCassette(_mc);
var _nc=document.getElementById('cassette-none');if(_nc)_nc.style.display='none';
var _fc=document.getElementById('cassette-fabric-option');if(_fc)_fc.style.display='none';
var _sq=document.querySelector('#cassette-shape-grid [data-shape="Square"]');
if(_sq)selectShape(_sq);
document.querySelectorAll('#cassette-shape-grid [data-shape]').forEach(function(c){if(c.dataset.shape!=='Square')c.style.display='none';});
document.querySelectorAll('#cassette-color-grid [data-cassette-color]').forEach(function(c){if(!['White','Grey','Black'].includes(c.dataset.cassetteColor))c.style.display='none';});
// ── RAIL: Metal → Square → White/Grey/Black ──
document.getElementById('bottom-rail-section').style.display='block';
document.getElementById('rail-shangrila-section').style.display='none';
document.getElementById('rail-honeycomb-section').style.display='none';
document.getElementById('rail-material-grid').style.display='';
var _rm=document.querySelector('[data-rail-material="Metal"]');
if(_rm)selectRailMaterial(_rm);
var _rfc=document.getElementById('rail-fabric-option');if(_rfc)_rfc.style.display='none';
var _rsq=document.querySelector('#rail-shape-grid [data-rail-shape="Square"]');
if(_rsq)selectRailShape(_rsq);
document.querySelectorAll('#rail-shape-grid [data-rail-shape]').forEach(function(c){if(c.dataset.railShape!=='Square')c.style.display='none';});
document.querySelectorAll('#rail-color-grid [data-rail-color]').forEach(function(c){if(!['White','Grey','Black'].includes(c.dataset.railColor))c.style.display='none';});
document.getElementById('rail-color-section').style.display='none';
var _preCol=state.cassetteColor||'White';
var _cwh=document.querySelector('#cassette-color-grid [data-cassette-color="'+_preCol+'"]');
if(_cwh)selectCassetteColor(_cwh);
var dualCasNote=document.getElementById('dual-cassette-note');
if(dualCasNote)dualCasNote.style.display='block';
}
const hasRail = !['Dream Curtains'].includes(product);
document.getElementById('bottom-rail-section').style.display = (hasRail && !isDualRoller) ? 'block' : 'none';
if (!hasRail) { state.bottomRail = null; state.bottomRailType = null; state.bottomRailColor = null; }
if (hasRail && !isDualRoller) {
const isShangrila = product === 'Triple/Shangri-La'; const isHoneycomb = product === 'Honeycomb';
const railMaterialGrid = document.getElementById('rail-material-grid');
const railShangrilaNote = document.getElementById('rail-shangrila-note'); const railFabricNote = document.getElementById('rail-fabric-note');
if (railShangrilaNote) railShangrilaNote.style.display = 'none'; if (railFabricNote) railFabricNote.style.display = 'none';
if (isHoneycomb) {
railMaterialGrid.style.display = 'none'; document.getElementById('rail-shape-section').style.display = 'none';
document.getElementById('rail-color-section').style.display = 'none';
document.getElementById('rail-shangrila-section').style.display = 'none'; document.getElementById('rail-honeycomb-section').style.display = 'block';
document.getElementById('cassette-type-grid').style.display = 'none'; document.getElementById('cassette-honeycomb-section').style.display = 'block';
document.getElementById('cassette-shape-section').style.display = 'none'; document.getElementById('cassette-color-section').style.display = 'none';
state.bottomRail = 'Aluminum'; state.bottomRailType = null; state.cassetteType = 'Metal Cassette'; state.cassetteShape = null;
} else if (isShangrila) {
railMaterialGrid.style.display = 'none'; document.getElementById('rail-shape-section').style.display = 'none';
document.getElementById('rail-color-section').style.display = 'none';
document.getElementById('rail-honeycomb-section').style.display = 'none'; document.getElementById('rail-shangrila-section').style.display = 'block';
document.getElementById('cassette-honeycomb-section').style.display = 'none'; document.getElementById('cassette-type-grid').style.display = '';
state.bottomRail = 'Fixed'; state.bottomRailType = 'Flat';
} else {
railMaterialGrid.style.display = ''; document.getElementById('rail-shape-section').style.display = 'none';
document.getElementById('rail-shangrila-section').style.display = 'none'; document.getElementById('rail-honeycomb-section').style.display = 'none';
document.getElementById('cassette-honeycomb-section').style.display = 'none'; document.getElementById('cassette-type-grid').style.display = '';
const hasFabricRailOption = ['Zebra Shades', 'Roller Shades', 'Roman Shades', 'Butterfly Shades', 'Print Blinds'].includes(product);
document.getElementById('rail-fabric-option').style.display = hasFabricRailOption ? '' : 'none';
document.getElementById('rail-color-section').style.display = 'none';
}
}
const isHoneycombProduct = product === 'Honeycomb'; const noCassetteProduct = ['Dream Curtains'].includes(product);
const cassetteFabricOption = document.getElementById('cassette-fabric-option');
if (noCassetteProduct) {
document.getElementById('cassette-type-section').style.display = 'none'; document.getElementById('cassette-honeycomb-section').style.display = 'none';
document.getElementById('cassette-shape-section').style.display = 'none'; document.getElementById('cassette-color-section').style.display = 'none';
state.cassetteType = null; state.cassetteShape = null; state.cassetteColor = null;
} else if (isHoneycombProduct) {
document.getElementById('cassette-type-section').style.display = 'none'; document.getElementById('cassette-honeycomb-section').style.display = 'block';
document.getElementById('cassette-shape-section').style.display = 'none'; document.getElementById('cassette-color-section').style.display = 'none';
document.getElementById('cassette-fabric-note').style.display = 'none'; document.getElementById('cassette-shangrila-note').style.display = 'none';
} else if (!isDualRoller) {
document.getElementById('cassette-type-section').style.display = 'block'; document.getElementById('cassette-honeycomb-section').style.display = 'none';
if (cassetteFabricOption) cassetteFabricOption.style.display = '';
const isMotorized = state.lift && state.lift.includes('Motorized');
const noCassetteCard = document.getElementById('cassette-none');
if (noCassetteCard) { noCassetteCard.style.display = isMotorized ? 'none' : 'block'; if (isMotorized && state.cassetteType === 'No Cassette') state.cassetteType = null; }
}
const tooNarrow = state.width && state.width < 18;
document.getElementById('motor-width-warning').classList.toggle('show', tooNarrow);
renderLiftOptions();
renderPrevFabricSuggest();
renderPrevRailCassetteSuggest();
if (!isPrint) renderColorSwatches();
}

loadOrder();
renderOrderList();

var _vs0=document.getElementById('step0-video-section');if(_vs0)_vs0.style.display='block';

// ── QUOTE RESTORE: load order from KV if ?quote= param present ──
(function() {
  const params = new URLSearchParams(window.location.search);
  const quoteId = params.get('quote');
  if (!quoteId) return;
  fetch('https://lmg-draft-order.ericcnavarro.workers.dev?loadQuote=' + encodeURIComponent(quoteId))
    .then(r => r.json())
    .then(data => {
      if (!data.orderList || !data.orderList.length) return;
      orderList = data.orderList;
      saveOrder();
      renderOrderList();
      setTimeout(() => {
        const sec = document.getElementById('order-list-section');
        if (sec) sec.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 400);
    })
    .catch(e => { console.warn('Quote restore failed:', e); });
})();

// ── WARRANTY ──
function selectWarranty(card) {
document.querySelectorAll('.warranty-card').forEach(function(c){c.classList.remove('selected');});
card.classList.add('selected');
orderWarranty = card.dataset.warranty;
orderWarrantyPrice = parseFloat(card.dataset.wc) || 0;
try{bRenderCrossCart();}catch(e){var tel=document.getElementById('order-total-amount');if(tel)tel.textContent='$'+(calcOrderTotal(orderList)+orderWarrantyPrice).toFixed(2);}
var note = document.getElementById('order-total-windows');
if (note) note.textContent = orderWarrantyPrice > 0 ? "Your Test Drive price + " + card.querySelector(".warranty-name").textContent + " Warranty ($" + orderWarrantyPrice.toFixed(0) + ")" : "Your Test Drive price";

try{localStorage.setItem('lmg_warranty',JSON.stringify({warranty:orderWarranty,warrantyPrice:orderWarrantyPrice}));}catch(e){}
}

// ── IN-PAGE MODALS ──
function showToast(msg,isErr){var t=document.getElementById('lmg-missing-toast');if(!t){t=document.createElement('div');t.id='lmg-missing-toast';t.style.cssText='position:fixed;top:80px;left:50%;transform:translateX(-50%);font-family:var(--font-body);font-size:13px;font-weight:600;padding:12px 24px;border-radius:6px;box-shadow:0 4px 20px rgba(0,0,0,.3);z-index:9999;pointer-events:none;transition:opacity .3s;white-space:nowrap;';document.body.appendChild(t);}
t.style.background=isErr?'#C0392B':'#1A1A1A';t.style.color='#fff';t.textContent=msg;t.style.opacity='1';
clearTimeout(t._timer);t._timer=setTimeout(function(){t.style.opacity='0';},3500);
}
function showConfirm(title,msg,okText,isDanger,onOk){
document.getElementById('lmg-confirm-title').textContent=title;
document.getElementById('lmg-confirm-msg').textContent=msg;
var btn=document.getElementById('lmg-confirm-ok');
btn.textContent=okText||'Confirm';
btn.className=isDanger?'lmg-modal-btn-danger':'lmg-modal-btn-ok';
btn.onclick=function(){closeLmgConfirm();onOk();};
document.getElementById('lmg-confirm-overlay').classList.add('open');
}
function closeLmgConfirm(){document.getElementById('lmg-confirm-overlay').classList.remove('open');}
function openEmailModal(){
if(orderList.length===0){showToast('Add at least one window first.',true);return;}
document.getElementById('blind-email-addr').value='';
document.getElementById('blind-email-name').value='';
document.getElementById('blind-email-modal').style.display='flex';
setTimeout(function(){document.getElementById('blind-email-addr').focus();},120);
}
function closeLmgEmail(){document.getElementById('blind-email-modal').style.display='none';}
async function submitEmailModal(){
const email=document.getElementById('blind-email-addr').value.trim();
const name=document.getElementById('blind-email-name').value.trim()||'';
if(!email||email.indexOf('@')===-1||email.indexOf('.')===-1){alert('Please enter a valid email address.');return;}
const btn=document.getElementById('blind-email-send');
const orig=btn.textContent;btn.textContent='Sending…';btn.disabled=true;
closeLmgEmail();
const qBtn=document.getElementById('btn-email-quote');
const qOrig=qBtn?qBtn.innerHTML:'';if(qBtn){qBtn.innerHTML='Sending…';qBtn.disabled=true;}
try{
var _sE=[],_dE=[],_bE=[],_vE=[],_oE=[];
try{var _sk=localStorage.getItem('lmg_shutters');if(_sk)_sE=JSON.parse(_sk);}catch(e){}
try{var _dk=localStorage.getItem('lmg_drapes');if(_dk)_dE=JSON.parse(_dk);}catch(e){}
try{var _bk=localStorage.getItem('lmg_bamboo');if(_bk)_bE=JSON.parse(_bk);}catch(e){}
try{var _vk=localStorage.getItem('lmg_venetian');if(_vk)_vE=JSON.parse(_vk);}catch(e){}
try{var _ok=localStorage.getItem('lmg_outdoor');if(_ok)_oE=JSON.parse(_ok);}catch(e){}
var _allEmailItems=[];
orderList.forEach(function(w){_allEmailItems.push({productType:'blind',label:w.label,product:w.product,width:w.width||w.w,height:w.height||w.h,customerPrice:w.customerPrice||w.customer,listedPrice:w.listedPrice||w.listed||0,shippingAmt:w.shippingAmt||w.shipping,room:w.room});});
_sE.forEach(function(w){_allEmailItems.push({productType:'shutter',label:w.label,type:w.type,louver:w.louver,width:w.w,height:w.h,customerPrice:w.customer,listedPrice:w.listedPrice||w.listed||0,shippingAmt:w.shipping,room:w.room});});
_dE.forEach(function(w){_allEmailItems.push({productType:'drape',label:w.label,fabric:w.fabric,category:w.category,width:w.w,height:w.h,customerPrice:w.customer,listedPrice:w.listedPrice||w.listed||0,shippingAmt:w.shipping,room:w.room});});
_bE.forEach(function(w){_allEmailItems.push({productType:'bamboo',label:w.label,fabric:w.fab,fabricSku:w.fabSku,lift:w.lift,width:w.w,height:w.h,customerPrice:w.customer,listedPrice:w.listedPrice||w.listed||0,shippingAmt:w.ship,room:w.room});});
_vE.forEach(function(w){_allEmailItems.push({productType:'venetian',label:w.room+(w.win?' — '+w.win:''),mat:w.mat,slat:w.slat,color:w.color,colorCode:w.colorCode,lift:w.lift,width:w.w,height:w.h,customerPrice:w.customer,listedPrice:w.listedPrice||w.listed||0,shippingAmt:w.ship,room:w.room});});
_oE.forEach(function(w){_allEmailItems.push({productType:'outdoor',label:w.room+(w.win?' — '+w.win:''),fabCode:w.fabCode,fabName:w.fabName,lift:w.lift,width:w.w,height:w.h,customerPrice:w.customer,listedPrice:w.listedPrice||w.listed||0,shippingAmt:w.ship,room:w.room});});
var _emailTotal=_allEmailItems.reduce(function(s,w){return s+(w.customerPrice||0)+(w.shippingAmt||0);},0)+orderWarrantyPrice;
const response=await fetch('https://lmg-draft-order.ericcnavarro.workers.dev',{method:'POST',headers:{'Content-Type':'application/json','X-Worker-Secret':window.__lmgCfg.s},body:JSON.stringify({type:'unifiedQuote',email:email,name:name,items:_allEmailItems,total:_emailTotal,warranty:orderWarranty,warrantyPrice:orderWarrantyPrice,fullCart:{blinds:orderList,shutters:_sE,drapes:_dE,bamboo:_bE,venetian:_vE,outdoor:_oE,warranty:orderWarranty,warrantyPrice:orderWarrantyPrice}})});
if(!response.ok){const err=await response.json();throw new Error(err.error||'Failed');}
if(qBtn){qBtn.innerHTML='✓ Sent! Check your inbox';setTimeout(function(){qBtn.innerHTML=qOrig;qBtn.disabled=false;},4000);}
}catch(err){
showToast('Could not send quote. Try again or email support@lmgblinds.com',true);
if(qBtn){qBtn.innerHTML=qOrig;qBtn.disabled=false;}
}
btn.textContent=orig;btn.disabled=false;
}
function showVenetianSoon(e){
  e.stopPropagation();
  // Deselect any selected card since this isn't a real product
  document.querySelectorAll('.product-type-card').forEach(function(c){ c.classList.remove('selected'); });
  showModal('venetian-soon-modal');
}
function openBlindFabricInquiry(){
  var product = state.product || 'Roller Shade';
  var fab;
  if (product === 'Dual Roller') {
    var lf = state.dualColorCodeLF ? state.dualColorCodeLF + (state.dualColorLF ? ' — '+state.dualColorLF : '') : null;
    var bo = state.dualColorCodeBO ? state.dualColorCodeBO + (state.dualColorBO ? ' — '+state.dualColorBO : '') : null;
    fab = [lf,bo].filter(Boolean).join(' / ') || 'your selected fabric';
  } else {
    fab = state.color ? (state.colorCode ? state.colorCode+' — '+state.color : state.color) : 'your selected fabric';
  }
  var subject = encodeURIComponent('Fabric Photo Request — '+fab+' for '+product);
  var body = encodeURIComponent('Hi,\n\nI am interested in seeing the '+fab+' fabric for the '+product+' more closely — can you send me more photos and videos please?\n\nThank you!');
  window.open('mailto:info@lmginc.co?subject='+subject+'&body='+body,'_top');
}


/* ============================================================
   PHASE 13 — INLINE QUICK-EDIT from the cart (name / size / fabric)
   Repricing mirrors addWindowToOrder exactly, including the standalone
   side-channel add on customerPrice, so an edited window is byte-identical
   to a freshly added one. Do not "clean up" that line here in isolation.
   ============================================================ */
/* calcListPrice() derives bcCost from the LIVE wizard state rather than its
   arguments:  bcCost = state.bottomChannel ? (state.width * 1.28)/DISCOUNT : 0
   So the same record prices differently depending on what is loaded in the wizard.
   Borrow the record's own values for the duration of the call and restore the
   wizard's afterwards, so a cart record always prices as itself. */
function lmgPriceRec(w){
  var _bc = state.bottomChannel, _w = state.width;
  state.bottomChannel = !!w.bottomChannel; state.width = w.width;
  try {
    return calcListPrice(w.width, w.height, w.fabricCost || 1.99, w.liftPrice || 0, w.motorPrice || 0,
                         w.hubPrice || 0, w.solarPrice || 0, w.hookwandPrice || 0, w.lift, w.product, w.sideChannel);
  } finally { state.bottomChannel = _bc; state.width = _w; }
}
function lmgReprice(w){
  var r = lmgPriceRec(w);
  w.listedPrice = r.listedPrice;
  w.customerPrice = r.customerPrice + (w.sideChannel && w.height ? (w.height * 0.0254 * 50.40) : 0);
  w.shippingAmt = calcShipping((w.width * w.height) / 144);
}
function lmgHoist(id){
  var o=document.getElementById(id);
  /* These overlays are authored inside step-panel #step-4, which is display:none
     whenever the cart is on screen. position:fixed cannot escape a hidden ancestor,
     so move them to <body> the first time they are opened. Doing this at open time
     rather than on DOMContentLoaded means it works no matter when the section loads. */
  if(o && o.parentNode !== document.body) document.body.appendChild(o);
  return o;
}
function lmgFlash(i){
  var el = document.getElementById('order-item-' + i); if(!el) return;
  el.style.transition='box-shadow .3s'; el.style.boxShadow='0 0 0 3px var(--gold)';
  setTimeout(function(){ el.style.boxShadow=''; }, 1200);
}
/* --- rename --- */
function lmgRename(i){
  var el = document.getElementById('lmg-title-' + i), w = orderList[i];
  if(!el || !w || el.dataset.ed === '1') return;
  el.dataset.ed = '1';
  var inp = document.createElement('input');
  inp.type='text'; inp.maxLength=60; inp.className='lmg-name-in'; inp.value = w.label || '';
  var done=false;
  function fin(save){
    if(done) return; done=true;
    if(save){ var v=(inp.value||'').trim(); if(v) w.label=v; saveOrder(); }
    renderOrderList(); if(save) lmgFlash(i);
  }
  inp.onkeydown=function(e){ if(e.key==='Enter'){e.preventDefault();fin(true);} else if(e.key==='Escape'){e.preventDefault();fin(false);} };
  inp.onblur=function(){ fin(true); };
  el.parentNode.replaceChild(inp, el); inp.focus(); inp.select();
}
/* --- size --- */
var _lmgSizeIdx = null;
function lmgSizeValidate(wv, hv, w){
  if(!wv || !hv) return 'Enter both a width and a height.';
  if(wv < 10) return 'Minimum width is 10".';
  if(wv > 110) return 'Maximum width is 110". Wider openings must be split into multiple shades — please configure each separately.';
  if(hv < 10) return 'Minimum height is 10".';
  if(hv > 120) return 'Maximum height is 120".';
  if(w.motor && w.motor !== 'None' && wv > MOTOR_MAX_WIDTH && w.product !== 'Dream Curtains')
    return 'This shade is motorized, and motors are unavailable over ' + MOTOR_MAX_WIDTH + '". Use full Edit to change the lift type.';
  return '';
}
function lmgSizeOpen(i){
  var ov = lmgHoist('lmg-size-ov');
  var w = orderList[i], wi=document.getElementById('lmg-size-w'), hi=document.getElementById('lmg-size-h');
  if(!w || !wi || !hi || !ov) return;
  _lmgSizeIdx = i;
  var t=document.getElementById('lmg-size-title'); if(t) t.textContent='Change Size — ' + (w.label || 'Window');
  wi.value = w.width || ''; hi.value = w.height || '';
  ov.style.display='flex'; lmgSizePreview();
  setTimeout(function(){ wi.focus(); wi.select(); }, 50);
}
function lmgSizePreview(){
  var w = orderList[_lmgSizeIdx]; if(!w) return;
  var wi=document.getElementById('lmg-size-w'), hi=document.getElementById('lmg-size-h');
  var er=document.getElementById('lmg-size-err'), pv=document.getElementById('lmg-size-prev'), sb=document.getElementById('lmg-size-save');
  if(!wi||!hi||!er||!pv||!sb) return;
  var wv=parseFloat(wi.value)||0, hv=parseFloat(hi.value)||0;
  var msg = lmgSizeValidate(wv, hv, w);
  if(msg){ er.textContent='⚠️ '+msg; er.style.display='block'; pv.style.display='none';
           sb.disabled=true; sb.style.opacity='.4'; sb.style.cursor='not-allowed'; return; }
  er.style.display='none'; sb.disabled=false; sb.style.opacity='1'; sb.style.cursor='pointer';
  var probe = Object.assign({}, w, {width:wv, height:hv});
  lmgReprice(probe);
  /* Baseline = the CURRENT size repriced by the same path, so the delta reflects
     the size change alone rather than a stale stored figure. */
  var base = Object.assign({}, w);
  lmgReprice(base);
  var oldT=base.customerPrice+base.shippingAmt, newT=probe.customerPrice+probe.shippingAmt, d=newT-oldT;
  pv.style.display='block';
  pv.innerHTML = '<div>Area: <strong>' + ((wv*hv)/144).toFixed(2) + ' sqft</strong></div>'
   + '<div>Your price: <strong>$' + probe.customerPrice.toFixed(2) + '</strong> <span style="color:var(--ink-muted);">(was $' + base.customerPrice.toFixed(2) + ')</span></div>'
   + '<div>Shipping: <strong>$' + probe.shippingAmt.toFixed(2) + '</strong></div>'
   + (wv > OVERSIZED_THRESHOLD ? '<div style="color:#8B6000;">⚠️ Oversized carton fee applies</div>' : '')
   + '<div style="margin-top:6px;padding-top:6px;border-top:1px solid var(--border);">Total change: '
   + (Math.abs(d)<0.005 ? '<span style="color:var(--ink-muted);">no change</span>'
      : '<strong style="color:' + (d>0?'#A02020':'#1E7A3C') + ';">' + (d>0?'+':'−') + '$' + Math.abs(d).toFixed(2) + '</strong>') + '</div>';
}
function lmgSizeSave(){
  var i=_lmgSizeIdx, w=orderList[i]; if(!w) return;
  var wi=document.getElementById('lmg-size-w'), hi=document.getElementById('lmg-size-h'); if(!wi||!hi) return;
  var wv=parseFloat(wi.value)||0, hv=parseFloat(hi.value)||0;
  if(lmgSizeValidate(wv, hv, w)){ lmgSizePreview(); return; }
  w.width=wv; w.height=hv; lmgReprice(w);
  saveOrder(); lmgSizeClose(); renderOrderList(); lmgFlash(i);
}
function lmgSizeClose(){ var o=document.getElementById('lmg-size-ov'); if(o)o.style.display='none'; _lmgSizeIdx=null; }
/* --- fabric --- */
var _lmgFabIdx = null;
function lmgFabOpen(i){
  var ov = lmgHoist('lmg-fab-ov');
  var w=orderList[i], g=document.getElementById('lmg-fab-grid');
  if(!w || !g || !ov) return;
  var cat = (typeof FABRIC_CATALOG !== 'undefined') ? FABRIC_CATALOG[w.product] : null;
  if(!cat){ showToast('No fabric list available for ' + (w.product||'this product') + '.', true); return; }
  /* Same traversal findFabricInCatalog() uses: array of series, or keyed by light. */
  var groups = Array.isArray(cat) ? {_: cat} : cat;
  var series = w.light && groups[w.light] ? groups[w.light] : null;
  if(!series){
    series = []; var seenCode = {};
    for(var k in groups){
      (groups[k]||[]).forEach(function(ser){
        if(!ser || !ser.colors) return;
        var kept = ser.colors.filter(function(c){ if(seenCode[c.code]) return false; seenCode[c.code]=1; return true; });
        if(kept.length) series.push({name: ser.name, colors: kept});
      });
    }
  }
  if(!series || !series.length){ showToast('No fabrics found for this product.', true); return; }
  _lmgFabIdx = i;
  var t=document.getElementById('lmg-fab-title'); if(t) t.textContent='Change Fabric — ' + (w.label || 'Window');
  var sub=document.getElementById('lmg-fab-sub');
  if(sub) sub.textContent = w.product + (w.light ? ' · ' + w.light : '') + ' — same price, swapping is free.';
  g.innerHTML=''; var shown=0;
  series.forEach(function(ser){
    if(!ser || !ser.colors) return;
    if(ser.name){ var h=document.createElement('div'); h.className='lmg-pop-ser'; h.textContent=ser.name; g.appendChild(h); }
    ser.colors.forEach(function(c){
      var wrap=document.createElement('div'); wrap.className='color-swatch-wrap';
      wrap.style.cssText='display:flex;flex-direction:column;align-items:center;gap:4px;width:66px;';
      var sw=document.createElement('div');
      sw.className='color-swatch' + (w.colorCode===c.code ? ' selected' : '');
      /* Explicit inline box — the shared .color-swatch class sets these, but if that
         rule is ever unavailable the swatch would collapse to 0x0 and the grid reads
         as empty. Inline styling makes the picker self-sufficient. */
      sw.style.cssText='width:52px;height:52px;border-radius:50%;cursor:pointer;background-size:cover;background-position:center;border:3px solid ' +
        (w.colorCode===c.code ? 'var(--gold)' : 'transparent') + ';background-image:url(\'' + CDN + c.file + SWATCH_SIZE + '\');';
      sw.title = c.code + ' — ' + c.name;
      sw.onclick = (function(cc){ return function(){ lmgFabPick(cc); }; })(c);
      var nm=document.createElement('span'); nm.className='color-swatch-name';
      nm.style.cssText='font-size:9px;line-height:1.2;text-align:center;color:var(--ink-muted);word-break:break-word;';
      nm.textContent=c.name;
      wrap.appendChild(sw); wrap.appendChild(nm); g.appendChild(wrap); shown++;
    });
  });
  if(!shown){
    g.innerHTML='<div style="font-size:12px;color:var(--ink-muted);padding:14px 0;">No fabric swatches found for '
      + escHtml(w.product||'this product') + (w.light ? ' / ' + escHtml(w.light) : '')
      + '. Use full Edit to change the fabric.</div>';
  }
  ov.style.display='flex';
}
function lmgFabPick(c){
  var i=_lmgFabIdx, w=orderList[i]; if(!w || !c){ lmgFabClose(); return; }
  /* fabricCost comes from the PRODUCT card, not the colour — price is unaffected. */
  w.color=c.name; w.colorCode=c.code; w.colorDesc=c.desc;
  saveOrder(); lmgFabClose(); renderOrderList(); lmgFlash(i);
}
function lmgFabClose(){ var o=document.getElementById('lmg-fab-ov'); if(o)o.style.display='none'; _lmgFabIdx=null; }
document.addEventListener('keydown', function(e){
  if(e.key !== 'Escape') return;
  if(_lmgFabIdx !== null) lmgFabClose();
  if(_lmgSizeIdx !== null) lmgSizeClose();
});
document.addEventListener('DOMContentLoaded', function(){
  try{ ['lmg-fab-ov','lmg-size-ov'].forEach(function(id){
    var o=document.getElementById(id); if(o && o.parentNode!==document.body) document.body.appendChild(o);
  }); }catch(e){}
});

var blindNamingPanel = null;
var blindNamingQty = 1;

function blindNamingConfirm() {
  if(typeof orderList !== 'undefined' && orderList.length >= 1){
    document.getElementById('blind-naming-overlay').style.display='none';
    if(typeof showToast === 'function') showToast('Test Drive is limited to one blind. Use Start Over to reset.', true);
    return;
  }
  var inputs = document.querySelectorAll('#blind-naming-fields input');
  inputs.forEach(function(input) {
    var p = JSON.parse(JSON.stringify(blindNamingPanel));
    var val = input.value.trim() || blindNamingPanel.label || getRoomLabel(blindNamingPanel.room) || 'Window';
    p.label = val;
    var dash = val.indexOf(' — ');
    if (dash !== -1) { p.room = val.substring(0, dash); p.windowName = val.substring(dash + 3); }
    else { p.windowName = ''; }
    orderList.push(p);
  });
  document.getElementById('blind-naming-overlay').style.display = 'none';
  saveOrder(); renderOrderList();
  document.getElementById('order-list-section').classList.add('visible');
  resetConfigurator();
  document.getElementById('step-' + state.step).classList.remove('active');
  state.step = 0; document.getElementById('step-0').classList.add('active');
  setTimeout(function() {
    var items = document.querySelectorAll('.order-item');
    var last = items[items.length - 1];
    if (last) last.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }, 400);
}

function blindNamingCancel() {
  document.getElementById('blind-naming-overlay').style.display = 'none';
}

function blindUpdateDeleteBar() {
  var checked = document.querySelectorAll('.blind-item-check:checked');
  var bar = document.getElementById('blind-delete-selected-bar');
  var cnt = document.getElementById('blind-selected-count');
  if (bar) bar.style.display = checked.length > 0 ? 'flex' : 'none';
  if (cnt) cnt.textContent = checked.length + ' selected';
}

function blindDeleteSelected() {
  var checked = document.querySelectorAll('.blind-item-check:checked');
  if (!checked.length) return;
  var count = checked.length;
  showConfirm(
    'Delete ' + count + ' Window' + (count > 1 ? 's' : ''),
    'Are you sure you want to delete the selected window' + (count > 1 ? 's' : '') + '? You cannot reverse this action.',
    'Delete', true,
    function() {
      var idxs = [];
      document.querySelectorAll('.blind-item-check:checked').forEach(function(cb) { idxs.push(parseInt(cb.dataset.idx)); });
      idxs.sort(function(a, b) { return b - a; });
      idxs.forEach(function(i) { orderList.splice(i, 1); });
      saveOrder(); renderOrderList();
    }
  );
}

function blindClearCheckboxes() {
  document.querySelectorAll('.blind-item-check').forEach(function(cb) { cb.checked = false; });
  blindUpdateDeleteBar();
}


// ── TEST DRIVE: Initialize Stripe Card Element ──
(function(){
  try {
    var elements = STRIPE_OBJ.elements();
    var cardEl = elements.create('card', {
      hidePostalCode: true, // TD: billing ZIP comes from the form field and is verified by the bank
      style: {
        base: { fontFamily: "'Jost', sans-serif", fontSize: '16px', color: '#1A1A1A', '::placeholder': { color: '#9A9A9A' } },
        invalid: { color: '#C0392B' }
      }
    });
    cardEl.mount('#td-stripe-card-element');
    window._tdStripeCard = cardEl;
    cardEl.on('change', function(e){
      var errEl = document.getElementById('td-stripe-error');
      if(errEl) errEl.textContent = e.error ? e.error.message : '';
    });
  } catch(e) { console.warn('Stripe init error:', e); }
})();

// ── TEST DRIVE: UTM tracking ──
(function(){
  var params = new URLSearchParams(window.location.search);
  var src = params.get('utm_source');
  var el = document.getElementById('td-utm-label');
  if(el && src) {
    el.textContent = 'Via: ' + src.charAt(0).toUpperCase() + src.slice(1) + ' Ad';
    el.style.display = 'inline-block';
  }
})();

// ── TEST DRIVE: Show checkout panel when order list has items ──
var _tdOrigRenderOrder = renderOrderList;
renderOrderList = function() {
  _tdOrigRenderOrder.apply(this, arguments);
  var panel = document.getElementById('td-checkout-panel');
  if(panel) panel.style.display = orderList.length > 0 ? 'block' : 'none';
  if(typeof tdCustomizeCartUI === 'function') { try { tdCustomizeCartUI(); } catch(e){} }
};


// Update deposit amount display whenever order list changes
var _tdOrigRender2 = typeof _tdOrigRenderOrder !== 'undefined' ? null : null;
function tdUpdateDepositDisplay(){
  var total=orderList.reduce(function(s,w){return s+(w.customerPrice||0)+(w.shippingAmt||0);},0);
  var dep=Math.round(total*TD_DEPOSIT_RATE*100)/100;
  var el=document.getElementById('td-deposit-amount-label');
  if(el)el.textContent='$'+dep.toFixed(2);
}

// TD: Form persistence + panel restore on page load
document.addEventListener('DOMContentLoaded', function(){
  // Hide quantity selector
  var qtyWrap = document.querySelector('.qty-wrap, [id*="blind-qty"], .quantity-wrap');
  if(qtyWrap) qtyWrap.style.display='none';
  var qtyLabel = document.querySelector('[for="blind-qty"]');
  if(qtyLabel) qtyLabel.style.display='none';

  // Restore saved form fields
  var savedForm = {};
  try { savedForm = JSON.parse(localStorage.getItem('lmg_td_form')||'{}'); } catch(e){}

  ['td-name','td-email','td-phone','td-address','td-bill-zip','td-ship-zip'].forEach(function(id){
    var el=document.getElementById(id);
    if(!el) return;
    if(savedForm[id]) el.value=savedForm[id];
    el.addEventListener('input', function(){
      try {
        var form=JSON.parse(localStorage.getItem('lmg_td_form')||'{}');
        form[id]=el.value;
        localStorage.setItem('lmg_td_form', JSON.stringify(form));
      } catch(e){}
    });
  });

  // If blind already in localStorage, show checkout panel without requiring re-config
  setTimeout(function(){
    try {
      var saved = JSON.parse(localStorage.getItem('lmg_td_order')||'[]');
      if(saved.length > 0){
        var panel = document.getElementById('td-checkout-panel');
        if(panel) panel.style.display='block';
        // Update deposit amount display
        var total = saved.reduce(function(s,w){ return s+(w.customerPrice||0)+(w.shippingAmt||0); }, 0);
        var depEl = document.getElementById('td-deposit-amount-label');
        if(depEl) depEl.textContent = '$'+(Math.round(total*TD_DEPOSIT_RATE*100)/100).toFixed(2);
      }
    } catch(e){}
  }, 800);
});
var _tdOrigSaveOrder=saveOrder;
saveOrder=function(){_tdOrigSaveOrder.apply(this,arguments);tdUpdateDepositDisplay();};